/*

Flow by WeTheme (http://www.wetheme.com)
Plugins

1. Masonry PACKAGED v4.1.0
3. ScrollToFixed
4. imagesLoaded v4.1.0
5. Social Icon Buttons v1.0
6. FancyBox 2.1.5
7. jQuery Cookie 1.4.1
8. jQuery Smooth Scroll 1.7.2
9. jQuery FlexSlider v2.6.3
10. Wow 1.1.3
11. Zoom 1.7.20
12. hoverIntent v1.8.1
13. Owl Carousel v2.3.4
14. Rellax 1.9.1
15. lazysizes v4.0.1
16. lazysizes RIaS v4.0.1
16. lazysizes object-fit v4.0.1
17. Recently viewed
18. lazysizes blur-up - v4.1.6
19. color-thief - v2.3.0
20. Readmore.js - v3.0.0-alpha-6
21. jQuery throttle/debounce v1.1
*/

(function ($) {
  var jQuery = $;
  var _oldJquery = window.jQuery;
  // The scripts are using window.jQuery, we need to force our version
  // so jQuery plugins will attach to correct jQuery namespace.
  window.jQuery = $;

  // 1. Masonry PACKAGED v4.1.0

  /*!
   * Masonry PACKAGED v4.1.0
   * Cascading grid layout library
   * http://masonry.desandro.com
   * MIT License
   * by David DeSandro
   */

  !(function (t, e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define('jquery-bridget/jquery-bridget', ['jquery'], function (i) {
          e(t, i);
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = e(t, require('jquery')))
      : (t.jQueryBridget = e(t, t.jQuery));
  })(window, function (t, e) {
    'use strict';
    function i(i, r, a) {
      function h(t, e, n) {
        var o,
          r = '$().' + i + '("' + e + '")';
        return (
          t.each(function (t, h) {
            var u = a.data(h, i);
            if (!u) return void s(i + ' not initialized. Cannot call methods, i.e. ' + r);
            var d = u[e];
            if (!d || '_' == e.charAt(0)) return void s(r + ' is not a valid method');
            var l = d.apply(u, n);
            o = void 0 === o ? l : o;
          }),
          void 0 !== o ? o : t
        );
      }
      function u(t, e) {
        t.each(function (t, n) {
          var o = a.data(n, i);
          o ? (o.option(e), o._init()) : ((o = new r(n, e)), a.data(n, i, o));
        });
      }
      (a = a || e || t.jQuery),
        a &&
          (r.prototype.option ||
            (r.prototype.option = function (t) {
              a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
            }),
          (a.fn[i] = function (t) {
            if ('string' == typeof t) {
              var e = o.call(arguments, 1);
              return h(this, t, e);
            }
            return u(this, t), this;
          }),
          n(a));
    }
    function n(t) {
      !t || (t && t.bridget) || (t.bridget = i);
    }
    var o = Array.prototype.slice,
      r = t.console,
      s =
        'undefined' == typeof r
          ? function () {}
          : function (t) {
              r.error(t);
            };
    return n(e || t.jQuery), i;
  }),
    (function (t, e) {
      'function' == typeof define && define.amd
        ? define('ev-emitter/ev-emitter', e)
        : 'object' == typeof module && module.exports
        ? (module.exports = e())
        : (t.EvEmitter = e());
    })(this, function () {
      function t() {}
      var e = t.prototype;
      return (
        (e.on = function (t, e) {
          if (t && e) {
            var i = (this._events = this._events || {}),
              n = (i[t] = i[t] || []);
            return -1 == n.indexOf(e) && n.push(e), this;
          }
        }),
        (e.once = function (t, e) {
          if (t && e) {
            this.on(t, e);
            var i = (this._onceEvents = this._onceEvents || {}),
              n = (i[t] = i[t] || {});
            return (n[e] = !0), this;
          }
        }),
        (e.off = function (t, e) {
          var i = this._events && this._events[t];
          if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this;
          }
        }),
        (e.emitEvent = function (t, e) {
          var i = this._events && this._events[t];
          if (i && i.length) {
            var n = 0,
              o = i[n];
            e = e || [];
            for (var r = this._onceEvents && this._onceEvents[t]; o; ) {
              var s = r && r[o];
              s && (this.off(t, o), delete r[o]), o.apply(this, e), (n += s ? 0 : 1), (o = i[n]);
            }
            return this;
          }
        }),
        t
      );
    }),
    (function (t, e) {
      'use strict';
      'function' == typeof define && define.amd
        ? define('get-size/get-size', [], function () {
            return e();
          })
        : 'object' == typeof module && module.exports
        ? (module.exports = e())
        : (t.getSize = e());
    })(window, function () {
      'use strict';
      function t(t) {
        var e = parseFloat(t),
          i = -1 == t.indexOf('%') && !isNaN(e);
        return i && e;
      }
      function e() {}
      function i() {
        for (
          var t = {
              width: 0,
              height: 0,
              innerWidth: 0,
              innerHeight: 0,
              outerWidth: 0,
              outerHeight: 0,
            },
            e = 0;
          u > e;
          e++
        ) {
          var i = h[e];
          t[i] = 0;
        }
        return t;
      }
      function n(t) {
        var e = getComputedStyle(t);
        return (
          e ||
            a(
              'Style returned ' +
                e +
                '. Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1'
            ),
          e
        );
      }
      function o() {
        if (!d) {
          d = !0;
          var e = document.createElement('div');
          (e.style.width = '200px'),
            (e.style.padding = '1px 2px 3px 4px'),
            (e.style.borderStyle = 'solid'),
            (e.style.borderWidth = '1px 2px 3px 4px'),
            (e.style.boxSizing = 'border-box');
          var i = document.body || document.documentElement;
          i.appendChild(e);
          var o = n(e);
          (r.isBoxSizeOuter = s = 200 == t(o.width)), i.removeChild(e);
        }
      }
      function r(e) {
        if ((o(), 'string' == typeof e && (e = document.querySelector(e)), e && 'object' == typeof e && e.nodeType)) {
          var r = n(e);
          if ('none' == r.display) return i();
          var a = {};
          (a.width = e.offsetWidth), (a.height = e.offsetHeight);
          for (var d = (a.isBorderBox = 'border-box' == r.boxSizing), l = 0; u > l; l++) {
            var c = h[l],
              f = r[c],
              m = parseFloat(f);
            a[c] = isNaN(m) ? 0 : m;
          }
          var p = a.paddingLeft + a.paddingRight,
            g = a.paddingTop + a.paddingBottom,
            y = a.marginLeft + a.marginRight,
            v = a.marginTop + a.marginBottom,
            _ = a.borderLeftWidth + a.borderRightWidth,
            E = a.borderTopWidth + a.borderBottomWidth,
            z = d && s,
            b = t(r.width);
          b !== !1 && (a.width = b + (z ? 0 : p + _));
          var x = t(r.height);
          return (
            x !== !1 && (a.height = x + (z ? 0 : g + E)),
            (a.innerWidth = a.width - (p + _)),
            (a.innerHeight = a.height - (g + E)),
            (a.outerWidth = a.width + y),
            (a.outerHeight = a.height + v),
            a
          );
        }
      }
      var s,
        a =
          'undefined' == typeof console
            ? e
            : function (t) {
                console.error(t);
              },
        h = [
          'paddingLeft',
          'paddingRight',
          'paddingTop',
          'paddingBottom',
          'marginLeft',
          'marginRight',
          'marginTop',
          'marginBottom',
          'borderLeftWidth',
          'borderRightWidth',
          'borderTopWidth',
          'borderBottomWidth',
        ],
        u = h.length,
        d = !1;
      return r;
    }),
    (function (t, e) {
      'use strict';
      'function' == typeof define && define.amd
        ? define('desandro-matches-selector/matches-selector', e)
        : 'object' == typeof module && module.exports
        ? (module.exports = e())
        : (t.matchesSelector = e());
    })(window, function () {
      'use strict';
      var t = (function () {
        var t = Element.prototype;
        if (t.matches) return 'matches';
        if (t.matchesSelector) return 'matchesSelector';
        for (var e = ['webkit', 'moz', 'ms', 'o'], i = 0; i < e.length; i++) {
          var n = e[i],
            o = n + 'MatchesSelector';
          if (t[o]) return o;
        }
      })();
      return function (e, i) {
        return e[t](i);
      };
    }),
    (function (t, e) {
      'function' == typeof define && define.amd
        ? define('fizzy-ui-utils/utils', ['desandro-matches-selector/matches-selector'], function (i) {
            return e(t, i);
          })
        : 'object' == typeof module && module.exports
        ? (module.exports = e(t, require('desandro-matches-selector')))
        : (t.fizzyUIUtils = e(t, t.matchesSelector));
    })(window, function (t, e) {
      var i = {};
      (i.extend = function (t, e) {
        for (var i in e) t[i] = e[i];
        return t;
      }),
        (i.modulo = function (t, e) {
          return ((t % e) + e) % e;
        }),
        (i.makeArray = function (t) {
          var e = [];
          if (Array.isArray(t)) e = t;
          else if (t && 'number' == typeof t.length) for (var i = 0; i < t.length; i++) e.push(t[i]);
          else e.push(t);
          return e;
        }),
        (i.removeFrom = function (t, e) {
          var i = t.indexOf(e);
          -1 != i && t.splice(i, 1);
        }),
        (i.getParent = function (t, i) {
          for (; t != document.body; ) if (((t = t.parentNode), e(t, i))) return t;
        }),
        (i.getQueryElement = function (t) {
          return 'string' == typeof t ? document.querySelector(t) : t;
        }),
        (i.handleEvent = function (t) {
          var e = 'on' + t.type;
          this[e] && this[e](t);
        }),
        (i.filterFindElements = function (t, n) {
          t = i.makeArray(t);
          var o = [];
          return (
            t.forEach(function (t) {
              if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) o.push(i[r]);
              }
            }),
            o
          );
        }),
        (i.debounceMethod = function (t, e, i) {
          var n = t.prototype[e],
            o = e + 'Timeout';
          t.prototype[e] = function () {
            var t = this[o];
            t && clearTimeout(t);
            var e = arguments,
              r = this;
            this[o] = setTimeout(function () {
              n.apply(r, e), delete r[o];
            }, i || 100);
          };
        }),
        (i.docReady = function (t) {
          'complete' == document.readyState ? t() : document.addEventListener('DOMContentLoaded', t);
        }),
        (i.toDashed = function (t) {
          return t
            .replace(/(.)([A-Z])/g, function (t, e, i) {
              return e + '-' + i;
            })
            .toLowerCase();
        });
      var n = t.console;
      return (
        (i.htmlInit = function (e, o) {
          i.docReady(function () {
            var r = i.toDashed(o),
              s = 'data-' + r,
              a = document.querySelectorAll('[' + s + ']'),
              h = document.querySelectorAll('.js-' + r),
              u = i.makeArray(a).concat(i.makeArray(h)),
              d = s + '-options',
              l = t.jQuery;
            u.forEach(function (t) {
              var i,
                r = t.getAttribute(s) || t.getAttribute(d);
              try {
                i = r && JSON.parse(r);
              } catch (a) {
                return void (n && n.error('Error parsing ' + s + ' on ' + t.className + ': ' + a));
              }
              var h = new e(t, i);
              l && l.data(t, o, h);
            });
          });
        }),
        i
      );
    }),
    (function (t, e) {
      'function' == typeof define && define.amd
        ? define('outlayer/item', ['ev-emitter/ev-emitter', 'get-size/get-size'], e)
        : 'object' == typeof module && module.exports
        ? (module.exports = e(require('ev-emitter'), require('get-size')))
        : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
    })(window, function (t, e) {
      'use strict';
      function i(t) {
        for (var e in t) return !1;
        return (e = null), !0;
      }
      function n(t, e) {
        t && ((this.element = t), (this.layout = e), (this.position = { x: 0, y: 0 }), this._create());
      }
      function o(t) {
        return t.replace(/([A-Z])/g, function (t) {
          return '-' + t.toLowerCase();
        });
      }
      var r = document.documentElement.style,
        s = 'string' == typeof r.transition ? 'transition' : 'WebkitTransition',
        a = 'string' == typeof r.transform ? 'transform' : 'WebkitTransform',
        h = {
          WebkitTransition: 'webkitTransitionEnd',
          transition: 'transitionend',
        }[s],
        u = {
          transform: a,
          transition: s,
          transitionDuration: s + 'Duration',
          transitionProperty: s + 'Property',
          transitionDelay: s + 'Delay',
        },
        d = (n.prototype = Object.create(t.prototype));
      (d.constructor = n),
        (d._create = function () {
          (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }), this.css({ position: 'absolute' });
        }),
        (d.handleEvent = function (t) {
          var e = 'on' + t.type;
          this[e] && this[e](t);
        }),
        (d.getSize = function () {
          this.size = e(this.element);
        }),
        (d.css = function (t) {
          var e = this.element.style;
          for (var i in t) {
            var n = u[i] || i;
            e[n] = t[i];
          }
        }),
        (d.getPosition = function () {
          var t = getComputedStyle(this.element),
            e = this.layout._getOption('originLeft'),
            i = this.layout._getOption('originTop'),
            n = t[e ? 'left' : 'right'],
            o = t[i ? 'top' : 'bottom'],
            r = this.layout.size,
            s = -1 != n.indexOf('%') ? (parseFloat(n) / 100) * r.width : parseInt(n, 10),
            a = -1 != o.indexOf('%') ? (parseFloat(o) / 100) * r.height : parseInt(o, 10);
          (s = isNaN(s) ? 0 : s),
            (a = isNaN(a) ? 0 : a),
            (s -= e ? r.paddingLeft : r.paddingRight),
            (a -= i ? r.paddingTop : r.paddingBottom),
            (this.position.x = s),
            (this.position.y = a);
        }),
        (d.layoutPosition = function () {
          var t = this.layout.size,
            e = {},
            i = this.layout._getOption('originLeft'),
            n = this.layout._getOption('originTop'),
            o = i ? 'paddingLeft' : 'paddingRight',
            r = i ? 'left' : 'right',
            s = i ? 'right' : 'left',
            a = this.position.x + t[o];
          (e[r] = this.getXValue(a)), (e[s] = '');
          var h = n ? 'paddingTop' : 'paddingBottom',
            u = n ? 'top' : 'bottom',
            d = n ? 'bottom' : 'top',
            l = this.position.y + t[h];
          (e[u] = this.getYValue(l)), (e[d] = ''), this.css(e), this.emitEvent('layout', [this]);
        }),
        (d.getXValue = function (t) {
          var e = this.layout._getOption('horizontal');
          return this.layout.options.percentPosition && !e ? (t / this.layout.size.width) * 100 + '%' : t + 'px';
        }),
        (d.getYValue = function (t) {
          var e = this.layout._getOption('horizontal');
          return this.layout.options.percentPosition && e ? (t / this.layout.size.height) * 100 + '%' : t + 'px';
        }),
        (d._transitionTo = function (t, e) {
          this.getPosition();
          var i = this.position.x,
            n = this.position.y,
            o = parseInt(t, 10),
            r = parseInt(e, 10),
            s = o === this.position.x && r === this.position.y;
          if ((this.setPosition(t, e), s && !this.isTransitioning)) return void this.layoutPosition();
          var a = t - i,
            h = e - n,
            u = {};
          (u.transform = this.getTranslate(a, h)),
            this.transition({
              to: u,
              onTransitionEnd: { transform: this.layoutPosition },
              isCleaning: !0,
            });
        }),
        (d.getTranslate = function (t, e) {
          var i = this.layout._getOption('originLeft'),
            n = this.layout._getOption('originTop');
          return (t = i ? t : -t), (e = n ? e : -e), 'translate3d(' + t + 'px, ' + e + 'px, 0)';
        }),
        (d.goTo = function (t, e) {
          this.setPosition(t, e), this.layoutPosition();
        }),
        (d.moveTo = d._transitionTo),
        (d.setPosition = function (t, e) {
          (this.position.x = parseInt(t, 10)), (this.position.y = parseInt(e, 10));
        }),
        (d._nonTransition = function (t) {
          this.css(t.to), t.isCleaning && this._removeStyles(t.to);
          for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this);
        }),
        (d.transition = function (t) {
          if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
          var e = this._transn;
          for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
          for (i in t.to) (e.ingProperties[i] = !0), t.isCleaning && (e.clean[i] = !0);
          if (t.from) {
            this.css(t.from);
            var n = this.element.offsetHeight;
            n = null;
          }
          this.enableTransition(t.to), this.css(t.to), (this.isTransitioning = !0);
        });
      var l = 'opacity,' + o(a);
      (d.enableTransition = function () {
        if (!this.isTransitioning) {
          var t = this.layout.options.transitionDuration;
          (t = 'number' == typeof t ? t + 'ms' : t),
            this.css({
              transitionProperty: l,
              transitionDuration: t,
              transitionDelay: this.staggerDelay || 0,
            }),
            this.element.addEventListener(h, this, !1);
        }
      }),
        (d.onwebkitTransitionEnd = function (t) {
          this.ontransitionend(t);
        }),
        (d.onotransitionend = function (t) {
          this.ontransitionend(t);
        });
      var c = { '-webkit-transform': 'transform' };
      (d.ontransitionend = function (t) {
        if (t.target === this.element) {
          var e = this._transn,
            n = c[t.propertyName] || t.propertyName;
          if (
            (delete e.ingProperties[n],
            i(e.ingProperties) && this.disableTransition(),
            n in e.clean && ((this.element.style[t.propertyName] = ''), delete e.clean[n]),
            n in e.onEnd)
          ) {
            var o = e.onEnd[n];
            o.call(this), delete e.onEnd[n];
          }
          this.emitEvent('transitionEnd', [this]);
        }
      }),
        (d.disableTransition = function () {
          this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), (this.isTransitioning = !1);
        }),
        (d._removeStyles = function (t) {
          var e = {};
          for (var i in t) e[i] = '';
          this.css(e);
        });
      var f = {
        transitionProperty: '',
        transitionDuration: '',
        transitionDelay: '',
      };
      return (
        (d.removeTransitionStyles = function () {
          this.css(f);
        }),
        (d.stagger = function (t) {
          (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + 'ms');
        }),
        (d.removeElem = function () {
          this.element.parentNode.removeChild(this.element),
            this.css({ display: '' }),
            this.emitEvent('remove', [this]);
        }),
        (d.remove = function () {
          return s && parseFloat(this.layout.options.transitionDuration)
            ? (this.once('transitionEnd', function () {
                this.removeElem();
              }),
              void this.hide())
            : void this.removeElem();
        }),
        (d.reveal = function () {
          delete this.isHidden, this.css({ display: '' });
          var t = this.layout.options,
            e = {},
            i = this.getHideRevealTransitionEndProperty('visibleStyle');
          (e[i] = this.onRevealTransitionEnd),
            this.transition({
              from: t.hiddenStyle,
              to: t.visibleStyle,
              isCleaning: !0,
              onTransitionEnd: e,
            });
        }),
        (d.onRevealTransitionEnd = function () {
          this.isHidden || this.emitEvent('reveal');
        }),
        (d.getHideRevealTransitionEndProperty = function (t) {
          var e = this.layout.options[t];
          if (e.opacity) return 'opacity';
          for (var i in e) return i;
        }),
        (d.hide = function () {
          (this.isHidden = !0), this.css({ display: '' });
          var t = this.layout.options,
            e = {},
            i = this.getHideRevealTransitionEndProperty('hiddenStyle');
          (e[i] = this.onHideTransitionEnd),
            this.transition({
              from: t.visibleStyle,
              to: t.hiddenStyle,
              isCleaning: !0,
              onTransitionEnd: e,
            });
        }),
        (d.onHideTransitionEnd = function () {
          this.isHidden && (this.css({ display: 'none' }), this.emitEvent('hide'));
        }),
        (d.destroy = function () {
          this.css({
            position: '',
            left: '',
            right: '',
            top: '',
            bottom: '',
            transition: '',
            transform: '',
          });
        }),
        n
      );
    }),
    (function (t, e) {
      'use strict';
      'function' == typeof define && define.amd
        ? define(
            'outlayer/outlayer',
            ['ev-emitter/ev-emitter', 'get-size/get-size', 'fizzy-ui-utils/utils', './item'],
            function (i, n, o, r) {
              return e(t, i, n, o, r);
            }
          )
        : 'object' == typeof module && module.exports
        ? (module.exports = e(
            t,
            require('ev-emitter'),
            require('get-size'),
            require('fizzy-ui-utils'),
            require('./item')
          ))
        : (t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item));
    })(window, function (t, e, i, n, o) {
      'use strict';
      function r(t, e) {
        var i = n.getQueryElement(t);
        if (!i) return void (h && h.error('Bad element for ' + this.constructor.namespace + ': ' + (i || t)));
        (this.element = i),
          u && (this.$element = u(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          this.option(e);
        var o = ++l;
        (this.element.outlayerGUID = o), (c[o] = this), this._create();
        var r = this._getOption('initLayout');
        r && this.layout();
      }
      function s(t) {
        function e() {
          t.apply(this, arguments);
        }
        return (e.prototype = Object.create(t.prototype)), (e.prototype.constructor = e), e;
      }
      function a(t) {
        if ('number' == typeof t) return t;
        var e = t.match(/(^\d*\.?\d*)(\w*)/),
          i = e && e[1],
          n = e && e[2];
        if (!i.length) return 0;
        i = parseFloat(i);
        var o = m[n] || 1;
        return i * o;
      }
      var h = t.console,
        u = t.jQuery,
        d = function () {},
        l = 0,
        c = {};
      (r.namespace = 'outlayer'),
        (r.Item = o),
        (r.defaults = {
          containerStyle: { position: 'relative' },
          initLayout: !0,
          originLeft: !0,
          originTop: !0,
          resize: !0,
          resizeContainer: !0,
          transitionDuration: '0.4s',
          hiddenStyle: { opacity: 0, transform: 'scale(0.001)' },
          visibleStyle: { opacity: 1, transform: 'scale(1)' },
        });
      var f = r.prototype;
      n.extend(f, e.prototype),
        (f.option = function (t) {
          n.extend(this.options, t);
        }),
        (f._getOption = function (t) {
          var e = this.constructor.compatOptions[t];
          return e && void 0 !== this.options[e] ? this.options[e] : this.options[t];
        }),
        (r.compatOptions = {
          initLayout: 'isInitLayout',
          horizontal: 'isHorizontal',
          layoutInstant: 'isLayoutInstant',
          originLeft: 'isOriginLeft',
          originTop: 'isOriginTop',
          resize: 'isResizeBound',
          resizeContainer: 'isResizingContainer',
        }),
        (f._create = function () {
          this.reloadItems(),
            (this.stamps = []),
            this.stamp(this.options.stamp),
            n.extend(this.element.style, this.options.containerStyle);
          var t = this._getOption('resize');
          t && this.bindResize();
        }),
        (f.reloadItems = function () {
          this.items = this._itemize(this.element.children);
        }),
        (f._itemize = function (t) {
          for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var r = e[o],
              s = new i(r, this);
            n.push(s);
          }
          return n;
        }),
        (f._filterFindItemElements = function (t) {
          return n.filterFindElements(t, this.options.itemSelector);
        }),
        (f.getItemElements = function () {
          return this.items.map(function (t) {
            return t.element;
          });
        }),
        (f.layout = function () {
          this._resetLayout(), this._manageStamps();
          var t = this._getOption('layoutInstant'),
            e = void 0 !== t ? t : !this._isLayoutInited;
          this.layoutItems(this.items, e), (this._isLayoutInited = !0);
        }),
        (f._init = f.layout),
        (f._resetLayout = function () {
          this.getSize();
        }),
        (f.getSize = function () {
          this.size = i(this.element);
        }),
        (f._getMeasurement = function (t, e) {
          var n,
            o = this.options[t];
          o
            ? ('string' == typeof o ? (n = this.element.querySelector(o)) : o instanceof HTMLElement && (n = o),
              (this[t] = n ? i(n)[e] : o))
            : (this[t] = 0);
        }),
        (f.layoutItems = function (t, e) {
          (t = this._getItemsForLayout(t)), this._layoutItems(t, e), this._postLayout();
        }),
        (f._getItemsForLayout = function (t) {
          return t.filter(function (t) {
            return !t.isIgnored;
          });
        }),
        (f._layoutItems = function (t, e) {
          if ((this._emitCompleteOnItems('layout', t), t && t.length)) {
            var i = [];
            t.forEach(function (t) {
              var n = this._getItemLayoutPosition(t);
              (n.item = t), (n.isInstant = e || t.isLayoutInstant), i.push(n);
            }, this),
              this._processLayoutQueue(i);
          }
        }),
        (f._getItemLayoutPosition = function () {
          return { x: 0, y: 0 };
        }),
        (f._processLayoutQueue = function (t) {
          this.updateStagger(),
            t.forEach(function (t, e) {
              this._positionItem(t.item, t.x, t.y, t.isInstant, e);
            }, this);
        }),
        (f.updateStagger = function () {
          var t = this.options.stagger;
          return null === t || void 0 === t ? void (this.stagger = 0) : ((this.stagger = a(t)), this.stagger);
        }),
        (f._positionItem = function (t, e, i, n, o) {
          n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
        }),
        (f._postLayout = function () {
          this.resizeContainer();
        }),
        (f.resizeContainer = function () {
          var t = this._getOption('resizeContainer');
          if (t) {
            var e = this._getContainerSize();
            e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1));
          }
        }),
        (f._getContainerSize = d),
        (f._setContainerMeasure = function (t, e) {
          if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox &&
              (t += e
                ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth
                : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth),
              (t = Math.max(t, 0)),
              (this.element.style[e ? 'width' : 'height'] = t + 'px');
          }
        }),
        (f._emitCompleteOnItems = function (t, e) {
          function i() {
            o.dispatchEvent(t + 'Complete', null, [e]);
          }
          function n() {
            s++, s == r && i();
          }
          var o = this,
            r = e.length;
          if (!e || !r) return void i();
          var s = 0;
          e.forEach(function (e) {
            e.once(t, n);
          });
        }),
        (f.dispatchEvent = function (t, e, i) {
          var n = e ? [e].concat(i) : i;
          if ((this.emitEvent(t, n), u))
            if (((this.$element = this.$element || u(this.element)), e)) {
              var o = u.Event(e);
              (o.type = t), this.$element.trigger(o, i);
            } else this.$element.trigger(t, i);
        }),
        (f.ignore = function (t) {
          var e = this.getItem(t);
          e && (e.isIgnored = !0);
        }),
        (f.unignore = function (t) {
          var e = this.getItem(t);
          e && delete e.isIgnored;
        }),
        (f.stamp = function (t) {
          (t = this._find(t)), t && ((this.stamps = this.stamps.concat(t)), t.forEach(this.ignore, this));
        }),
        (f.unstamp = function (t) {
          (t = this._find(t)),
            t &&
              t.forEach(function (t) {
                n.removeFrom(this.stamps, t), this.unignore(t);
              }, this);
        }),
        (f._find = function (t) {
          return t ? ('string' == typeof t && (t = this.element.querySelectorAll(t)), (t = n.makeArray(t))) : void 0;
        }),
        (f._manageStamps = function () {
          this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
        }),
        (f._getBoundingRect = function () {
          var t = this.element.getBoundingClientRect(),
            e = this.size;
          this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
          };
        }),
        (f._manageStamp = d),
        (f._getElementOffset = function (t) {
          var e = t.getBoundingClientRect(),
            n = this._boundingRect,
            o = i(t),
            r = {
              left: e.left - n.left - o.marginLeft,
              top: e.top - n.top - o.marginTop,
              right: n.right - e.right - o.marginRight,
              bottom: n.bottom - e.bottom - o.marginBottom,
            };
          return r;
        }),
        (f.handleEvent = n.handleEvent),
        (f.bindResize = function () {
          t.addEventListener('resize', this), (this.isResizeBound = !0);
        }),
        (f.unbindResize = function () {
          t.removeEventListener('resize', this), (this.isResizeBound = !1);
        }),
        (f.onresize = function () {
          this.resize();
        }),
        n.debounceMethod(r, 'onresize', 100),
        (f.resize = function () {
          this.isResizeBound && this.needsResizeLayout() && this.layout();
        }),
        (f.needsResizeLayout = function () {
          var t = i(this.element),
            e = this.size && t;
          return e && t.innerWidth !== this.size.innerWidth;
        }),
        (f.addItems = function (t) {
          var e = this._itemize(t);
          return e.length && (this.items = this.items.concat(e)), e;
        }),
        (f.appended = function (t) {
          var e = this.addItems(t);
          e.length && (this.layoutItems(e, !0), this.reveal(e));
        }),
        (f.prepended = function (t) {
          var e = this._itemize(t);
          if (e.length) {
            var i = this.items.slice(0);
            (this.items = e.concat(i)),
              this._resetLayout(),
              this._manageStamps(),
              this.layoutItems(e, !0),
              this.reveal(e),
              this.layoutItems(i);
          }
        }),
        (f.reveal = function (t) {
          if ((this._emitCompleteOnItems('reveal', t), t && t.length)) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
              t.stagger(i * e), t.reveal();
            });
          }
        }),
        (f.hide = function (t) {
          if ((this._emitCompleteOnItems('hide', t), t && t.length)) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
              t.stagger(i * e), t.hide();
            });
          }
        }),
        (f.revealItemElements = function (t) {
          var e = this.getItems(t);
          this.reveal(e);
        }),
        (f.hideItemElements = function (t) {
          var e = this.getItems(t);
          this.hide(e);
        }),
        (f.getItem = function (t) {
          for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i;
          }
        }),
        (f.getItems = function (t) {
          t = n.makeArray(t);
          var e = [];
          return (
            t.forEach(function (t) {
              var i = this.getItem(t);
              i && e.push(i);
            }, this),
            e
          );
        }),
        (f.remove = function (t) {
          var e = this.getItems(t);
          this._emitCompleteOnItems('remove', e),
            e &&
              e.length &&
              e.forEach(function (t) {
                t.remove(), n.removeFrom(this.items, t);
              }, this);
        }),
        (f.destroy = function () {
          var t = this.element.style;
          (t.height = ''),
            (t.position = ''),
            (t.width = ''),
            this.items.forEach(function (t) {
              t.destroy();
            }),
            this.unbindResize();
          var e = this.element.outlayerGUID;
          delete c[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace);
        }),
        (r.data = function (t) {
          t = n.getQueryElement(t);
          var e = t && t.outlayerGUID;
          return e && c[e];
        }),
        (r.create = function (t, e) {
          var i = s(r);
          return (
            (i.defaults = n.extend({}, r.defaults)),
            n.extend(i.defaults, e),
            (i.compatOptions = n.extend({}, r.compatOptions)),
            (i.namespace = t),
            (i.data = r.data),
            (i.Item = s(o)),
            n.htmlInit(i, t),
            u && u.bridget && u.bridget(t, i),
            i
          );
        });
      var m = { ms: 1, s: 1e3 };
      return (r.Item = o), r;
    }),
    (function (t, e) {
      'function' == typeof define && define.amd
        ? define(['outlayer/outlayer', 'get-size/get-size'], e)
        : 'object' == typeof module && module.exports
        ? (module.exports = e(require('outlayer'), require('get-size')))
        : (t.Masonry = e(t.Outlayer, t.getSize));
    })(window, function (t, e) {
      var i = t.create('masonry');
      return (
        (i.compatOptions.fitWidth = 'isFitWidth'),
        (i.prototype._resetLayout = function () {
          this.getSize(),
            this._getMeasurement('columnWidth', 'outerWidth'),
            this._getMeasurement('gutter', 'outerWidth'),
            this.measureColumns(),
            (this.colYs = []);
          for (var t = 0; t < this.cols; t++) this.colYs.push(0);
          this.maxY = 0;
        }),
        (i.prototype.measureColumns = function () {
          if ((this.getContainerWidth(), !this.columnWidth)) {
            var t = this.items[0],
              i = t && t.element;
            this.columnWidth = (i && e(i).outerWidth) || this.containerWidth;
          }
          var n = (this.columnWidth += this.gutter),
            o = this.containerWidth + this.gutter,
            r = o / n,
            s = n - (o % n),
            a = s && 1 > s ? 'round' : 'floor';
          (r = Math[a](r)), (this.cols = Math.max(r, 1));
        }),
        (i.prototype.getContainerWidth = function () {
          var t = this._getOption('fitWidth'),
            i = t ? this.element.parentNode : this.element,
            n = e(i);
          this.containerWidth = n && n.innerWidth;
        }),
        (i.prototype._getItemLayoutPosition = function (t) {
          t.getSize();
          var e = t.size.outerWidth % this.columnWidth,
            i = e && 1 > e ? 'round' : 'ceil',
            n = Math[i](t.size.outerWidth / this.columnWidth);
          n = Math.min(n, this.cols);
          for (
            var o = this._getColGroup(n),
              r = Math.min.apply(Math, o),
              s = o.indexOf(r),
              a = { x: this.columnWidth * s, y: r },
              h = r + t.size.outerHeight,
              u = this.cols + 1 - o.length,
              d = 0;
            u > d;
            d++
          )
            this.colYs[s + d] = h;
          return a;
        }),
        (i.prototype._getColGroup = function (t) {
          if (2 > t) return this.colYs;
          for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) {
            var o = this.colYs.slice(n, n + t);
            e[n] = Math.max.apply(Math, o);
          }
          return e;
        }),
        (i.prototype._manageStamp = function (t) {
          var i = e(t),
            n = this._getElementOffset(t),
            o = this._getOption('originLeft'),
            r = o ? n.left : n.right,
            s = r + i.outerWidth,
            a = Math.floor(r / this.columnWidth);
          a = Math.max(0, a);
          var h = Math.floor(s / this.columnWidth);
          (h -= s % this.columnWidth ? 0 : 1), (h = Math.min(this.cols - 1, h));
          for (var u = this._getOption('originTop'), d = (u ? n.top : n.bottom) + i.outerHeight, l = a; h >= l; l++)
            this.colYs[l] = Math.max(d, this.colYs[l]);
        }),
        (i.prototype._getContainerSize = function () {
          this.maxY = Math.max.apply(Math, this.colYs);
          var t = { height: this.maxY };
          return this._getOption('fitWidth') && (t.width = this._getContainerFitWidth()), t;
        }),
        (i.prototype._getContainerFitWidth = function () {
          for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
          return (this.cols - t) * this.columnWidth - this.gutter;
        }),
        (i.prototype.needsResizeLayout = function () {
          var t = this.containerWidth;
          return this.getContainerWidth(), t != this.containerWidth;
        }),
        i
      );
    });

  /*!
   * # Semantic UI 2.2.9 - Sticky
   * http://github.com/semantic-org/semantic-ui/
   *
   *
   * Released under the MIT license
   * http://opensource.org/licenses/MIT
   *
   */
  !(function (e, t, o, n) {
    'use strict';
    (t =
      'undefined' != typeof t && t.Math == Math
        ? t
        : 'undefined' != typeof self && self.Math == Math
        ? self
        : Function('return this')()),
      (e.fn.sticky = function (i) {
        var s,
          r = e(this),
          c = r.selector || '',
          l = new Date().getTime(),
          a = [],
          f = arguments[0],
          m = 'string' == typeof f,
          u = [].slice.call(arguments, 1);
        return (
          r.each(function () {
            var r,
              d,
              h,
              g,
              p,
              b = e.isPlainObject(i) ? e.extend(!0, {}, e.fn.sticky.settings, i) : e.extend({}, e.fn.sticky.settings),
              v = b.className,
              x = b.namespace,
              C = b.error,
              S = '.' + x,
              y = 'module-' + x,
              k = e(this),
              T = e(t),
              w = e(b.scrollContext),
              z = (k.selector || '', k.data(y)),
              B =
                t.requestAnimationFrame ||
                t.mozRequestAnimationFrame ||
                t.webkitRequestAnimationFrame ||
                t.msRequestAnimationFrame ||
                function (e) {
                  setTimeout(e, 0);
                },
              P = this;
            (p = {
              initialize: function () {
                p.determineContainer(),
                  p.determineContext(),
                  p.verbose('Initializing sticky', b, r),
                  p.save.positions(),
                  p.checkErrors(),
                  p.bind.events(),
                  b.observeChanges && p.observeChanges(),
                  p.instantiate();
              },
              instantiate: function () {
                p.verbose('Storing instance of module', p), (z = p), k.data(y, p);
              },
              destroy: function () {
                p.verbose('Destroying previous instance'),
                  p.reset(),
                  h && h.disconnect(),
                  g && g.disconnect(),
                  T.off('load' + S, p.event.load).off('resize' + S, p.event.resize),
                  w.off('scrollchange' + S, p.event.scrollchange),
                  k.removeData(y);
              },
              observeChanges: function () {
                'MutationObserver' in t &&
                  ((h = new MutationObserver(p.event.documentChanged)),
                  (g = new MutationObserver(p.event.changed)),
                  h.observe(o, { childList: !0, subtree: !0 }),
                  g.observe(P, { childList: !0, subtree: !0 }),
                  g.observe(d[0], { childList: !0, subtree: !0 }),
                  p.debug('Setting up mutation observer', g));
              },
              determineContainer: function () {
                r = b.container ? e(b.container) : k.offsetParent();
              },
              determineContext: function () {
                if (((d = b.context ? e(b.context) : r), 0 === d.length))
                  return void p.error(C.invalidContext, b.context, k);
              },
              checkErrors: function () {
                if ((p.is.hidden() && p.error(C.visible, k), p.cache.element.height > p.cache.context.height))
                  return p.reset(), void p.error(C.elementSize, k);
              },
              bind: {
                events: function () {
                  T.on('load' + S, p.event.load).on('resize' + S, p.event.resize),
                    w
                      .off('scroll' + S)
                      .on('scroll' + S, p.event.scroll)
                      .on('scrollchange' + S, p.event.scrollchange);
                },
              },
              event: {
                changed: function (e) {
                  clearTimeout(p.timer),
                    (p.timer = setTimeout(function () {
                      p.verbose('DOM tree modified, updating sticky menu', e), p.refresh();
                    }, 100));
                },
                documentChanged: function (t) {
                  [].forEach.call(t, function (t) {
                    t.removedNodes &&
                      [].forEach.call(t.removedNodes, function (t) {
                        (t == P || e(t).find(P).length > 0) &&
                          (p.debug('Element removed from DOM, tearing down events'), p.destroy());
                      });
                  });
                },
                load: function () {
                  p.verbose('Page contents finished loading'), B(p.refresh);
                },
                resize: function () {
                  p.verbose('Window resized'), B(p.refresh);
                },
                scroll: function () {
                  B(function () {
                    w.triggerHandler('scrollchange' + S, w.scrollTop());
                  });
                },
                scrollchange: function (e, t) {
                  p.stick(t), b.onScroll.call(P);
                },
              },
              refresh: function (e) {
                p.reset(),
                  b.context || p.determineContext(),
                  e && p.determineContainer(),
                  p.save.positions(),
                  p.stick(),
                  b.onReposition.call(P);
              },
              supports: {
                sticky: function () {
                  var t = e('<div/>');
                  t[0];
                  return t.addClass(v.supported), t.css('position').match('sticky');
                },
              },
              save: {
                lastScroll: function (e) {
                  p.lastScroll = e;
                },
                elementScroll: function (e) {
                  p.elementScroll = e;
                },
                positions: function () {
                  var e = { height: w.height() },
                    t = {
                      margin: {
                        top: parseInt(k.css('margin-top'), 10),
                        bottom: parseInt(k.css('margin-bottom'), 10),
                      },
                      offset: k.offset(),
                      width: k.outerWidth(),
                      height: k.outerHeight(),
                    },
                    o = { offset: d.offset(), height: d.outerHeight() };
                  ({ height: r.outerHeight() });
                  p.is.standardScroll() ||
                    (p.debug('Non-standard scroll. Removing scroll offset from element offset'),
                    (e.top = w.scrollTop()),
                    (e.left = w.scrollLeft()),
                    (t.offset.top += e.top),
                    (o.offset.top += e.top),
                    (t.offset.left += e.left),
                    (o.offset.left += e.left)),
                    (p.cache = {
                      fits: t.height < e.height,
                      scrollContext: { height: e.height },
                      element: {
                        margin: t.margin,
                        top: t.offset.top - t.margin.top,
                        left: t.offset.left,
                        width: t.width,
                        height: t.height,
                        bottom: t.offset.top + t.height,
                      },
                      context: {
                        top: o.offset.top,
                        height: o.height,
                        bottom: o.offset.top + o.height,
                      },
                    }),
                    p.set.containerSize(),
                    p.set.size(),
                    p.stick(),
                    p.debug('Caching element positions', p.cache);
                },
              },
              get: {
                direction: function (e) {
                  var t = 'down';
                  return (
                    (e = e || w.scrollTop()),
                    p.lastScroll !== n && (p.lastScroll < e ? (t = 'down') : p.lastScroll > e && (t = 'up')),
                    t
                  );
                },
                scrollChange: function (e) {
                  return (e = e || w.scrollTop()), p.lastScroll ? e - p.lastScroll : 0;
                },
                currentElementScroll: function () {
                  return p.elementScroll
                    ? p.elementScroll
                    : p.is.top()
                    ? Math.abs(parseInt(k.css('top'), 10)) || 0
                    : Math.abs(parseInt(k.css('bottom'), 10)) || 0;
                },
                elementScroll: function (e) {
                  e = e || w.scrollTop();
                  var t = p.cache.element,
                    o = p.cache.scrollContext,
                    n = p.get.scrollChange(e),
                    i = t.height - o.height + b.offset,
                    s = p.get.currentElementScroll(),
                    r = s + n;
                  return (s = p.cache.fits || r < 0 ? 0 : r > i ? i : r);
                },
              },
              remove: {
                lastScroll: function () {
                  delete p.lastScroll;
                },
                elementScroll: function (e) {
                  delete p.elementScroll;
                },
                offset: function () {
                  k.css('margin-top', '');
                },
              },
              set: {
                offset: function () {
                  p.verbose('Setting offset on element', b.offset), k.css('margin-top', b.offset);
                },
                containerSize: function () {
                  var e = r.get(0).tagName;
                  'HTML' === e || 'body' == e
                    ? p.determineContainer()
                    : Math.abs(r.outerHeight() - p.cache.context.height) > b.jitter &&
                      (p.debug('Context has padding, specifying exact height for container', p.cache.context.height),
                      r.css({ height: p.cache.context.height }));
                },
                minimumSize: function () {
                  var e = p.cache.element;
                  r.css('min-height', e.height);
                },
                scroll: function (e) {
                  p.debug('Setting scroll on element', e),
                    p.elementScroll != e &&
                      (p.is.top() && k.css('bottom', '').css('top', -e),
                      p.is.bottom() && k.css('top', '').css('bottom', e));
                },
                size: function () {
                  0 !== p.cache.element.height &&
                    0 !== p.cache.element.width &&
                    (P.style.setProperty('width', p.cache.element.width + 'px', 'important'),
                    P.style.setProperty('height', p.cache.element.height + 'px', 'important'));
                },
              },
              is: {
                standardScroll: function () {
                  return w[0] == t;
                },
                top: function () {
                  return k.hasClass(v.top);
                },
                bottom: function () {
                  return k.hasClass(v.bottom);
                },
                initialPosition: function () {
                  return !p.is.fixed() && !p.is.bound();
                },
                hidden: function () {
                  return !k.is(':visible');
                },
                bound: function () {
                  return k.hasClass(v.bound);
                },
                fixed: function () {
                  return k.hasClass(v.fixed);
                },
              },
              stick: function (e) {
                var t = e || w.scrollTop(),
                  o = p.cache,
                  n = o.fits,
                  i = o.element,
                  s = o.scrollContext,
                  r = o.context,
                  c = p.is.bottom() && b.pushing ? b.bottomOffset : b.offset,
                  e = { top: t + c, bottom: t + c + s.height },
                  l = (p.get.direction(e.top), n ? 0 : p.get.elementScroll(e.top)),
                  a = !n,
                  f = 0 !== i.height;
                f &&
                  (p.is.initialPosition()
                    ? e.top >= r.bottom
                      ? (p.debug('Initial element position is bottom of container'), p.bindBottom())
                      : e.top > i.top &&
                        (i.height + e.top - l >= r.bottom
                          ? (p.debug('Initial element position is bottom of container'), p.bindBottom())
                          : (p.debug('Initial element position is fixed'), p.fixTop()))
                    : p.is.fixed()
                    ? p.is.top()
                      ? e.top <= i.top
                        ? (p.debug('Fixed element reached top of container'), p.setInitialPosition())
                        : i.height + e.top - l >= r.bottom
                        ? (p.debug('Fixed element reached bottom of container'), p.bindBottom())
                        : a && (p.set.scroll(l), p.save.lastScroll(e.top), p.save.elementScroll(l))
                      : p.is.bottom() &&
                        (e.bottom - i.height <= i.top
                          ? (p.debug('Bottom fixed rail has reached top of container'), p.setInitialPosition())
                          : e.bottom >= r.bottom
                          ? (p.debug('Bottom fixed rail has reached bottom of container'), p.bindBottom())
                          : a && (p.set.scroll(l), p.save.lastScroll(e.top), p.save.elementScroll(l)))
                    : p.is.bottom() &&
                      (e.top <= i.top
                        ? (p.debug('Jumped from bottom fixed to top fixed, most likely used home/end button'),
                          p.setInitialPosition())
                        : b.pushing
                        ? p.is.bound() &&
                          e.bottom <= r.bottom &&
                          (p.debug('Fixing bottom attached element to bottom of browser.'), p.fixBottom())
                        : p.is.bound() &&
                          e.top <= r.bottom - i.height &&
                          (p.debug('Fixing bottom attached element to top of browser.'), p.fixTop())));
              },
              bindTop: function () {
                p.debug('Binding element to top of parent container'),
                  p.remove.offset(),
                  k
                    .css({ left: '', top: '', marginBottom: '' })
                    .removeClass(v.fixed)
                    .removeClass(v.bottom)
                    .addClass(v.bound)
                    .addClass(v.top),
                  b.onTop.call(P),
                  b.onUnstick.call(P);
              },
              bindBottom: function () {
                p.debug('Binding element to bottom of parent container'),
                  p.remove.offset(),
                  k
                    .css({ left: '', top: '' })
                    .removeClass(v.fixed)
                    .removeClass(v.top)
                    .addClass(v.bound)
                    .addClass(v.bottom),
                  b.onBottom.call(P),
                  b.onUnstick.call(P);
              },
              setInitialPosition: function () {
                p.debug('Returning to initial position'), p.unfix(), p.unbind();
              },
              fixTop: function () {
                p.debug('Fixing element to top of page'),
                  p.set.minimumSize(),
                  p.set.offset(),
                  k
                    .css({
                      left: p.cache.element.left,
                      bottom: '',
                      marginBottom: '',
                    })
                    .removeClass(v.bound)
                    .removeClass(v.bottom)
                    .addClass(v.fixed)
                    .addClass(v.top),
                  b.onStick.call(P);
              },
              fixBottom: function () {
                p.debug('Sticking element to bottom of page'),
                  p.set.minimumSize(),
                  p.set.offset(),
                  k
                    .css({
                      left: p.cache.element.left,
                      bottom: '',
                      marginBottom: '',
                    })
                    .removeClass(v.bound)
                    .removeClass(v.top)
                    .addClass(v.fixed)
                    .addClass(v.bottom),
                  b.onStick.call(P);
              },
              unbind: function () {
                p.is.bound() &&
                  (p.debug('Removing container bound position on element'),
                  p.remove.offset(),
                  k.removeClass(v.bound).removeClass(v.top).removeClass(v.bottom));
              },
              unfix: function () {
                p.is.fixed() &&
                  (p.debug('Removing fixed position on element'),
                  p.remove.offset(),
                  k.removeClass(v.fixed).removeClass(v.top).removeClass(v.bottom),
                  b.onUnstick.call(P));
              },
              reset: function () {
                p.debug('Resetting elements position'),
                  p.unbind(),
                  p.unfix(),
                  p.resetCSS(),
                  p.remove.offset(),
                  p.remove.lastScroll();
              },
              resetCSS: function () {
                k.css({ width: '', height: '' }), r.css({ height: '' });
              },
              setting: function (t, o) {
                if (e.isPlainObject(t)) e.extend(!0, b, t);
                else {
                  if (o === n) return b[t];
                  b[t] = o;
                }
              },
              internal: function (t, o) {
                if (e.isPlainObject(t)) e.extend(!0, p, t);
                else {
                  if (o === n) return p[t];
                  p[t] = o;
                }
              },
              debug: function () {
                !b.silent &&
                  b.debug &&
                  (b.performance
                    ? p.performance.log(arguments)
                    : ((p.debug = Function.prototype.bind.call(console.info, console, b.name + ':')),
                      p.debug.apply(console, arguments)));
              },
              verbose: function () {
                !b.silent &&
                  b.verbose &&
                  b.debug &&
                  (b.performance
                    ? p.performance.log(arguments)
                    : ((p.verbose = Function.prototype.bind.call(console.info, console, b.name + ':')),
                      p.verbose.apply(console, arguments)));
              },
              error: function () {
                b.silent ||
                  ((p.error = Function.prototype.bind.call(console.error, console, b.name + ':')),
                  p.error.apply(console, arguments));
              },
              performance: {
                log: function (e) {
                  var t, o, n;
                  b.performance &&
                    ((t = new Date().getTime()),
                    (n = l || t),
                    (o = t - n),
                    (l = t),
                    a.push({
                      Name: e[0],
                      Arguments: [].slice.call(e, 1) || '',
                      Element: P,
                      'Execution Time': o,
                    })),
                    clearTimeout(p.performance.timer),
                    (p.performance.timer = setTimeout(p.performance.display, 0));
                },
                display: function () {
                  var t = b.name + ':',
                    o = 0;
                  (l = !1),
                    clearTimeout(p.performance.timer),
                    e.each(a, function (e, t) {
                      o += t['Execution Time'];
                    }),
                    (t += ' ' + o + 'ms'),
                    c && (t += " '" + c + "'"),
                    (console.group !== n || console.table !== n) &&
                      a.length > 0 &&
                      (console.groupCollapsed(t),
                      console.table
                        ? console.table(a)
                        : e.each(a, function (e, t) {
                            console.log(t.Name + ': ' + t['Execution Time'] + 'ms');
                          }),
                      console.groupEnd()),
                    (a = []);
                },
              },
              invoke: function (t, o, i) {
                var r,
                  c,
                  l,
                  a = z;
                return (
                  (o = o || u),
                  (i = P || i),
                  'string' == typeof t &&
                    a !== n &&
                    ((t = t.split(/[\. ]/)),
                    (r = t.length - 1),
                    e.each(t, function (o, i) {
                      var s = o != r ? i + t[o + 1].charAt(0).toUpperCase() + t[o + 1].slice(1) : t;
                      if (e.isPlainObject(a[s]) && o != r) a = a[s];
                      else {
                        if (a[s] !== n) return (c = a[s]), !1;
                        if (!e.isPlainObject(a[i]) || o == r) return a[i] !== n && ((c = a[i]), !1);
                        a = a[i];
                      }
                    })),
                  e.isFunction(c) ? (l = c.apply(i, o)) : c !== n && (l = c),
                  e.isArray(s) ? s.push(l) : s !== n ? (s = [s, l]) : l !== n && (s = l),
                  c
                );
              },
            }),
              m ? (z === n && p.initialize(), p.invoke(f)) : (z !== n && z.invoke('destroy'), p.initialize());
          }),
          s !== n ? s : this
        );
      }),
      (e.fn.sticky.settings = {
        name: 'Sticky',
        namespace: 'sticky',
        silent: !1,
        debug: !1,
        verbose: !0,
        performance: !0,
        pushing: !1,
        context: !1,
        container: !1,
        scrollContext: t,
        offset: 0,
        bottomOffset: 0,
        jitter: 5,
        observeChanges: !1,
        onReposition: function () {},
        onScroll: function () {},
        onStick: function () {},
        onUnstick: function () {},
        onTop: function () {},
        onBottom: function () {},
        error: {
          container: 'Sticky element must be inside a relative container',
          visible:
            'Element is hidden, you must call refresh after element becomes visible. Use silent setting to surpress this warning in production.',
          method: 'The method you called is not defined.',
          invalidContext: 'Context specified does not exist',
          elementSize: 'Sticky element is larger than its container, cannot create sticky.',
        },
        className: {
          bound: 'bound',
          fixed: 'fixed',
          supported: 'native',
          top: 'top',
          bottom: 'bottom',
        },
      });
  })(jQuery, window, document);

  // 4. imagesLoaded v4.1.0
  /*!
   * imagesLoaded PACKAGED v4.1.0
   * JavaScript is all like "You images are done yet or what?"
   * MIT License
   */

  !(function (t, e) {
    'function' == typeof define && define.amd
      ? define('ev-emitter/ev-emitter', e)
      : 'object' == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })(this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {}),
            n = (i[t] = i[t] || []);
          return (n[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = 0,
            o = i[n];
          e = e || [];
          for (var r = this._onceEvents && this._onceEvents[t]; o; ) {
            var s = r && r[o];
            s && (this.off(t, o), delete r[o]), o.apply(this, e), (n += s ? 0 : 1), (o = i[n]);
          }
          return this;
        }
      }),
      t
    );
  }),
    (function (t, e) {
      'use strict';
      'function' == typeof define && define.amd
        ? define(['ev-emitter/ev-emitter'], function (i) {
            return e(t, i);
          })
        : 'object' == typeof module && module.exports
        ? (module.exports = e(t, require('ev-emitter')))
        : (t.imagesLoaded = e(t, t.EvEmitter));
    })(window, function (t, e) {
      function i(t, e) {
        for (var i in e) t[i] = e[i];
        return t;
      }
      function n(t) {
        var e = [];
        if (Array.isArray(t)) e = t;
        else if ('number' == typeof t.length) for (var i = 0; i < t.length; i++) e.push(t[i]);
        else e.push(t);
        return e;
      }
      function o(t, e, r) {
        return this instanceof o
          ? ('string' == typeof t && (t = document.querySelectorAll(t)),
            (this.elements = n(t)),
            (this.options = i({}, this.options)),
            'function' == typeof e ? (r = e) : i(this.options, e),
            r && this.on('always', r),
            this.getImages(),
            h && (this.jqDeferred = new h.Deferred()),
            void setTimeout(
              function () {
                this.check();
              }.bind(this)
            ))
          : new o(t, e, r);
      }
      function r(t) {
        this.img = t;
      }
      function s(t, e) {
        (this.url = t), (this.element = e), (this.img = new Image());
      }
      var h = t.jQuery,
        a = t.console;
      (o.prototype = Object.create(e.prototype)),
        (o.prototype.options = {}),
        (o.prototype.getImages = function () {
          (this.images = []), this.elements.forEach(this.addElementImages, this);
        }),
        (o.prototype.addElementImages = function (t) {
          'IMG' == t.nodeName && this.addImage(t), this.options.background === !0 && this.addElementBackgroundImages(t);
          var e = t.nodeType;
          if (e && d[e]) {
            for (var i = t.querySelectorAll('img'), n = 0; n < i.length; n++) {
              var o = i[n];
              this.addImage(o);
            }
            if ('string' == typeof this.options.background) {
              var r = t.querySelectorAll(this.options.background);
              for (n = 0; n < r.length; n++) {
                var s = r[n];
                this.addElementBackgroundImages(s);
              }
            }
          }
        });
      var d = { 1: !0, 9: !0, 11: !0 };
      return (
        (o.prototype.addElementBackgroundImages = function (t) {
          var e = getComputedStyle(t);
          if (e)
            for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage); null !== n; ) {
              var o = n && n[2];
              o && this.addBackground(o, t), (n = i.exec(e.backgroundImage));
            }
        }),
        (o.prototype.addImage = function (t) {
          var e = new r(t);
          this.images.push(e);
        }),
        (o.prototype.addBackground = function (t, e) {
          var i = new s(t, e);
          this.images.push(i);
        }),
        (o.prototype.check = function () {
          function t(t, i, n) {
            setTimeout(function () {
              e.progress(t, i, n);
            });
          }
          var e = this;
          return (
            (this.progressedCount = 0),
            (this.hasAnyBroken = !1),
            this.images.length
              ? void this.images.forEach(function (e) {
                  e.once('progress', t), e.check();
                })
              : void this.complete()
          );
        }),
        (o.prototype.progress = function (t, e, i) {
          this.progressedCount++,
            (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
            this.emitEvent('progress', [this, t, e]),
            this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t),
            this.progressedCount == this.images.length && this.complete(),
            this.options.debug && a && a.log('progress: ' + i, t, e);
        }),
        (o.prototype.complete = function () {
          var t = this.hasAnyBroken ? 'fail' : 'done';
          if (((this.isComplete = !0), this.emitEvent(t, [this]), this.emitEvent('always', [this]), this.jqDeferred)) {
            var e = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[e](this);
          }
        }),
        (r.prototype = Object.create(e.prototype)),
        (r.prototype.check = function () {
          var t = this.getIsImageComplete();
          return t
            ? void this.confirm(0 !== this.img.naturalWidth, 'naturalWidth')
            : ((this.proxyImage = new Image()),
              this.proxyImage.addEventListener('load', this),
              this.proxyImage.addEventListener('error', this),
              this.img.addEventListener('load', this),
              this.img.addEventListener('error', this),
              void (this.proxyImage.src = this.img.src));
        }),
        (r.prototype.getIsImageComplete = function () {
          return this.img.complete && void 0 !== this.img.naturalWidth;
        }),
        (r.prototype.confirm = function (t, e) {
          (this.isLoaded = t), this.emitEvent('progress', [this, this.img, e]);
        }),
        (r.prototype.handleEvent = function (t) {
          var e = 'on' + t.type;
          this[e] && this[e](t);
        }),
        (r.prototype.onload = function () {
          this.confirm(!0, 'onload'), this.unbindEvents();
        }),
        (r.prototype.onerror = function () {
          this.confirm(!1, 'onerror'), this.unbindEvents();
        }),
        (r.prototype.unbindEvents = function () {
          this.proxyImage.removeEventListener('load', this),
            this.proxyImage.removeEventListener('error', this),
            this.img.removeEventListener('load', this),
            this.img.removeEventListener('error', this);
        }),
        (s.prototype = Object.create(r.prototype)),
        (s.prototype.check = function () {
          this.img.addEventListener('load', this), this.img.addEventListener('error', this), (this.img.src = this.url);
          var t = this.getIsImageComplete();
          t && (this.confirm(0 !== this.img.naturalWidth, 'naturalWidth'), this.unbindEvents());
        }),
        (s.prototype.unbindEvents = function () {
          this.img.removeEventListener('load', this), this.img.removeEventListener('error', this);
        }),
        (s.prototype.confirm = function (t, e) {
          (this.isLoaded = t), this.emitEvent('progress', [this, this.element, e]);
        }),
        (o.makeJQueryPlugin = function (e) {
          (e = e || t.jQuery),
            e &&
              ((h = e),
              (h.fn.imagesLoaded = function (t, e) {
                var i = new o(this, t, e);
                return i.jqDeferred.promise(h(this));
              }));
        }),
        o.makeJQueryPlugin(),
        o
      );
    });

  /*============================================================================
  5. Social Icon Buttons v1.0
  Author:
    Carson Shold | @cshold
    http://www.carsonshold.com
  MIT License
==============================================================================*/
  window.CSbuttons = window.CSbuttons || {};

  CSbuttons.init = function () {
    var $shareLinks = $('.social-sharing').find('a');

    // Share popups
    $shareLinks.on('click', function (e) {
      var el = $(this),
        popup = el.attr('class').replace('-', '_'),
        link = el.attr('href'),
        w = 700,
        h = 400;

      // Set popup sizes
      switch (popup) {
        case 'share_twitter':
          h = 300;
          break;
        case 'share_fancy':
          w = 480;
          h = 720;
          break;
        case 'share_google':
          w = 500;
          break;
        case 'share_reddit':
          popup = false;
          break;
        case 'share_skype':
          w = 300;
          h = 720;
          break;
      }

      if (popup) {
        e.preventDefault();
        window.open(link, popup, 'width=' + w + ', height=' + h);
      }
    });
  };

  $(function () {
    window.CSbuttons.init();
  });

  /*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
   * Licensed under the MIT License (LICENSE.txt).
   *
   * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
   * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
   * Thanks to: Seamus Leahy for adding deltaX and deltaY
   *
   * Version: 3.0.6
   *
   * Requires: 1.2.2+
   */
  (function (d) {
    function e(a) {
      var b = a || window.event,
        c = [].slice.call(arguments, 1),
        f = 0,
        e = 0,
        g = 0,
        a = d.event.fix(b);
      a.type = 'mousewheel';
      b.wheelDelta && (f = b.wheelDelta / 120);
      b.detail && (f = -b.detail / 3);
      g = f;
      b.axis !== void 0 && b.axis === b.HORIZONTAL_AXIS && ((g = 0), (e = -1 * f));
      b.wheelDeltaY !== void 0 && (g = b.wheelDeltaY / 120);
      b.wheelDeltaX !== void 0 && (e = (-1 * b.wheelDeltaX) / 120);
      c.unshift(a, f, e, g);
      return (d.event.dispatch || d.event.handle).apply(this, c);
    }
    var c = ['DOMMouseScroll', 'mousewheel'];
    if (d.event.fixHooks) for (var h = c.length; h; ) d.event.fixHooks[c[--h]] = d.event.mouseHooks;
    d.event.special.mousewheel = {
      setup: function () {
        if (this.addEventListener) for (var a = c.length; a; ) this.addEventListener(c[--a], e, false);
        else this.onmousewheel = e;
      },
      teardown: function () {
        if (this.removeEventListener) for (var a = c.length; a; ) this.removeEventListener(c[--a], e, false);
        else this.onmousewheel = null;
      },
    };
    d.fn.extend({
      mousewheel: function (a) {
        return a ? this.bind('mousewheel', a) : this.trigger('mousewheel');
      },
      unmousewheel: function (a) {
        return this.unbind('mousewheel', a);
      },
    });
  })(jQuery);

  /*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
  (function (r, G, f, v) {
    var J = f('html'),
      n = f(r),
      p = f(G),
      b = (f.fancybox = function () {
        b.open.apply(this, arguments);
      }),
      I = navigator.userAgent.match(/msie/i),
      B = null,
      s = G.createTouch !== v,
      t = function (a) {
        return a && a.hasOwnProperty && a instanceof f;
      },
      q = function (a) {
        return a && 'string' === f.type(a);
      },
      E = function (a) {
        return q(a) && 0 < a.indexOf('%');
      },
      l = function (a, d) {
        var e = parseInt(a, 10) || 0;
        d && E(a) && (e *= b.getViewport()[d] / 100);
        return Math.ceil(e);
      },
      w = function (a, b) {
        return l(a, b) + 'px';
      };
    f.extend(b, {
      version: '2.1.5',
      defaults: {
        padding: 15,
        margin: 20,
        width: 800,
        height: 600,
        minWidth: 100,
        minHeight: 100,
        maxWidth: 9999,
        maxHeight: 9999,
        pixelRatio: 1,
        autoSize: !0,
        autoHeight: !1,
        autoWidth: !1,
        autoResize: !0,
        autoCenter: !s,
        fitToView: !0,
        aspectRatio: !1,
        topRatio: 0.5,
        leftRatio: 0.5,
        scrolling: 'auto',
        wrapCSS: '',
        arrows: !0,
        closeBtn: !0,
        closeClick: !1,
        nextClick: !1,
        mouseWheel: !0,
        autoPlay: !1,
        playSpeed: 3e3,
        preload: 3,
        modal: !1,
        loop: !0,
        ajax: { dataType: 'html', headers: { 'X-fancyBox': !0 } },
        iframe: { scrolling: 'auto', preload: !0 },
        swf: {
          wmode: 'transparent',
          allowfullscreen: 'true',
          allowscriptaccess: 'always',
        },
        keys: {
          next: { 13: 'left', 34: 'up', 39: 'left', 40: 'up' },
          prev: { 8: 'right', 33: 'down', 37: 'right', 38: 'down' },
          close: [27],
          play: [32],
          toggle: [70],
        },
        direction: { next: 'left', prev: 'right' },
        scrollOutside: !0,
        index: 0,
        type: null,
        href: null,
        content: null,
        title: null,
        tpl: {
          wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
          image: '<img class="fancybox-image" src="{href}" alt="" />',
          iframe:
            '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' +
            (I ? ' allowtransparency="true"' : '') +
            '></iframe>',
          error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
          closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
          next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
          prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
        },
        openEffect: 'fade',
        openSpeed: 250,
        openEasing: 'swing',
        openOpacity: !0,
        openMethod: 'zoomIn',
        closeEffect: 'fade',
        closeSpeed: 250,
        closeEasing: 'swing',
        closeOpacity: !0,
        closeMethod: 'zoomOut',
        nextEffect: 'elastic',
        nextSpeed: 250,
        nextEasing: 'swing',
        nextMethod: 'changeIn',
        prevEffect: 'elastic',
        prevSpeed: 250,
        prevEasing: 'swing',
        prevMethod: 'changeOut',
        helpers: { overlay: !0, title: !0 },
        onCancel: f.noop,
        beforeLoad: f.noop,
        afterLoad: f.noop,
        beforeShow: f.noop,
        afterShow: f.noop,
        beforeChange: f.noop,
        beforeClose: f.noop,
        afterClose: f.noop,
      },
      group: {},
      opts: {},
      previous: null,
      coming: null,
      current: null,
      isActive: !1,
      isOpen: !1,
      isOpened: !1,
      wrap: null,
      skin: null,
      outer: null,
      inner: null,
      player: { timer: null, isActive: !1 },
      ajaxLoad: null,
      imgPreload: null,
      transitions: {},
      helpers: {},
      open: function (a, d) {
        if (a && (f.isPlainObject(d) || (d = {}), !1 !== b.close(!0)))
          return (
            f.isArray(a) || (a = t(a) ? f(a).get() : [a]),
            f.each(a, function (e, c) {
              var k = {},
                g,
                h,
                j,
                m,
                l;
              'object' === f.type(c) &&
                (c.nodeType && (c = f(c)),
                t(c)
                  ? ((k = {
                      href: c.data('fancybox-href') || c.attr('href'),
                      title: c.data('fancybox-title') || c.attr('title'),
                      isDom: !0,
                      element: c,
                    }),
                    f.metadata && f.extend(!0, k, c.metadata()))
                  : (k = c));
              g = d.href || k.href || (q(c) ? c : null);
              h = d.title !== v ? d.title : k.title || '';
              m = (j = d.content || k.content) ? 'html' : d.type || k.type;
              !m &&
                k.isDom &&
                ((m = c.data('fancybox-type')),
                m || (m = (m = c.prop('class').match(/fancybox\.(\w+)/)) ? m[1] : null));
              q(g) &&
                (m ||
                  (b.isImage(g)
                    ? (m = 'image')
                    : b.isSWF(g)
                    ? (m = 'swf')
                    : '#' === g.charAt(0)
                    ? (m = 'inline')
                    : q(c) && ((m = 'html'), (j = c))),
                'ajax' === m && ((l = g.split(/\s+/, 2)), (g = l.shift()), (l = l.shift())));
              j ||
                ('inline' === m
                  ? g
                    ? (j = f(q(g) ? g.replace(/.*(?=#[^\s]+$)/, '') : g))
                    : k.isDom && (j = c)
                  : 'html' === m
                  ? (j = g)
                  : !m && !g && k.isDom && ((m = 'inline'), (j = c)));
              f.extend(k, {
                href: g,
                type: m,
                content: j,
                title: h,
                selector: l,
              });
              a[e] = k;
            }),
            (b.opts = f.extend(!0, {}, b.defaults, d)),
            d.keys !== v && (b.opts.keys = d.keys ? f.extend({}, b.defaults.keys, d.keys) : !1),
            (b.group = a),
            b._start(b.opts.index)
          );
      },
      cancel: function () {
        var a = b.coming;
        a &&
          !1 !== b.trigger('onCancel') &&
          (b.hideLoading(),
          b.ajaxLoad && b.ajaxLoad.abort(),
          (b.ajaxLoad = null),
          b.imgPreload && (b.imgPreload.onload = b.imgPreload.onerror = null),
          a.wrap && a.wrap.stop(!0, !0).trigger('onReset').remove(),
          (b.coming = null),
          b.current || b._afterZoomOut(a));
      },
      close: function (a) {
        b.cancel();
        !1 !== b.trigger('beforeClose') &&
          (b.unbindEvents(),
          b.isActive &&
            (!b.isOpen || !0 === a
              ? (f('.fancybox-wrap').stop(!0).trigger('onReset').remove(), b._afterZoomOut())
              : ((b.isOpen = b.isOpened = !1),
                (b.isClosing = !0),
                f('.fancybox-item, .fancybox-nav').remove(),
                b.wrap.stop(!0, !0).removeClass('fancybox-opened'),
                b.transitions[b.current.closeMethod]())));
      },
      play: function (a) {
        var d = function () {
            clearTimeout(b.player.timer);
          },
          e = function () {
            d();
            b.current && b.player.isActive && (b.player.timer = setTimeout(b.next, b.current.playSpeed));
          },
          c = function () {
            d();
            p.unbind('.player');
            b.player.isActive = !1;
            b.trigger('onPlayEnd');
          };
        if (!0 === a || (!b.player.isActive && !1 !== a)) {
          if (b.current && (b.current.loop || b.current.index < b.group.length - 1))
            (b.player.isActive = !0),
              p.bind({
                'onCancel.player beforeClose.player': c,
                'onUpdate.player': e,
                'beforeLoad.player': d,
              }),
              e(),
              b.trigger('onPlayStart');
        } else c();
      },
      next: function (a) {
        var d = b.current;
        d && (q(a) || (a = d.direction.next), b.jumpto(d.index + 1, a, 'next'));
      },
      prev: function (a) {
        var d = b.current;
        d && (q(a) || (a = d.direction.prev), b.jumpto(d.index - 1, a, 'prev'));
      },
      jumpto: function (a, d, e) {
        var c = b.current;
        c &&
          ((a = l(a)),
          (b.direction = d || c.direction[a >= c.index ? 'next' : 'prev']),
          (b.router = e || 'jumpto'),
          c.loop && (0 > a && (a = c.group.length + (a % c.group.length)), (a %= c.group.length)),
          c.group[a] !== v && (b.cancel(), b._start(a)));
      },
      reposition: function (a, d) {
        var e = b.current,
          c = e ? e.wrap : null,
          k;
        c &&
          ((k = b._getPosition(d)),
          a && 'scroll' === a.type
            ? (delete k.position, c.stop(!0, !0).animate(k, 200))
            : (c.css(k), (e.pos = f.extend({}, e.dim, k))));
      },
      update: function (a) {
        var d = a && a.type,
          e = !d || 'orientationchange' === d;
        e && (clearTimeout(B), (B = null));
        b.isOpen &&
          !B &&
          (B = setTimeout(
            function () {
              var c = b.current;
              c &&
                !b.isClosing &&
                (b.wrap.removeClass('fancybox-tmp'),
                (e || 'load' === d || ('resize' === d && c.autoResize)) && b._setDimension(),
                ('scroll' === d && c.canShrink) || b.reposition(a),
                b.trigger('onUpdate'),
                (B = null));
            },
            e && !s ? 0 : 300
          ));
      },
      toggle: function (a) {
        b.isOpen &&
          ((b.current.fitToView = 'boolean' === f.type(a) ? a : !b.current.fitToView),
          s && (b.wrap.removeAttr('style').addClass('fancybox-tmp'), b.trigger('onUpdate')),
          b.update());
      },
      hideLoading: function () {
        p.unbind('.loading');
        f('#fancybox-loading').remove();
      },
      showLoading: function () {
        var a, d;
        b.hideLoading();
        a = f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo('body');
        p.bind('keydown.loading', function (a) {
          if (27 === (a.which || a.keyCode)) a.preventDefault(), b.cancel();
        });
        b.defaults.fixed ||
          ((d = b.getViewport()),
          a.css({
            position: 'absolute',
            top: 0.5 * d.h + d.y,
            left: 0.5 * d.w + d.x,
          }));
      },
      getViewport: function () {
        var a = (b.current && b.current.locked) || !1,
          d = { x: n.scrollLeft(), y: n.scrollTop() };
        a
          ? ((d.w = a[0].clientWidth), (d.h = a[0].clientHeight))
          : ((d.w = s && r.innerWidth ? r.innerWidth : n.width()),
            (d.h = s && r.innerHeight ? r.innerHeight : n.height()));
        return d;
      },
      unbindEvents: function () {
        b.wrap && t(b.wrap) && b.wrap.unbind('.fb');
        p.unbind('.fb');
        n.unbind('.fb');
      },
      bindEvents: function () {
        var a = b.current,
          d;
        a &&
          (n.bind(
            'orientationchange.fb' + (s ? '' : ' resize.fb') + (a.autoCenter && !a.locked ? ' scroll.fb' : ''),
            b.update
          ),
          (d = a.keys) &&
            p.bind('keydown.fb', function (e) {
              var c = e.which || e.keyCode,
                k = e.target || e.srcElement;
              if (27 === c && b.coming) return !1;
              !e.ctrlKey &&
                !e.altKey &&
                !e.shiftKey &&
                !e.metaKey &&
                (!k || (!k.type && !f(k).is('[contenteditable]'))) &&
                f.each(d, function (d, k) {
                  if (1 < a.group.length && k[c] !== v) return b[d](k[c]), e.preventDefault(), !1;
                  if (-1 < f.inArray(c, k)) return b[d](), e.preventDefault(), !1;
                });
            }),
          f.fn.mousewheel &&
            a.mouseWheel &&
            b.wrap.bind('mousewheel.fb', function (d, c, k, g) {
              for (
                var h = f(d.target || null), j = !1;
                h.length && !j && !h.is('.fancybox-skin') && !h.is('.fancybox-wrap');

              )
                (j =
                  h[0] &&
                  !(h[0].style.overflow && 'hidden' === h[0].style.overflow) &&
                  ((h[0].clientWidth && h[0].scrollWidth > h[0].clientWidth) ||
                    (h[0].clientHeight && h[0].scrollHeight > h[0].clientHeight))),
                  (h = f(h).parent());
              if (0 !== c && !j && 1 < b.group.length && !a.canShrink) {
                if (0 < g || 0 < k) b.prev(0 < g ? 'down' : 'left');
                else if (0 > g || 0 > k) b.next(0 > g ? 'up' : 'right');
                d.preventDefault();
              }
            }));
      },
      trigger: function (a, d) {
        var e,
          c = d || b.coming || b.current;
        if (c) {
          f.isFunction(c[a]) && (e = c[a].apply(c, Array.prototype.slice.call(arguments, 1)));
          if (!1 === e) return !1;
          c.helpers &&
            f.each(c.helpers, function (d, e) {
              if (e && b.helpers[d] && f.isFunction(b.helpers[d][a]))
                b.helpers[d][a](f.extend(!0, {}, b.helpers[d].defaults, e), c);
            });
          p.trigger(a);
        }
      },
      isImage: function (a) {
        return q(a) && a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
      },
      isSWF: function (a) {
        return q(a) && a.match(/\.(swf)((\?|#).*)?$/i);
      },
      _start: function (a) {
        var d = {},
          e,
          c;
        a = l(a);
        e = b.group[a] || null;
        if (!e) return !1;
        d = f.extend(!0, {}, b.opts, e);
        e = d.margin;
        c = d.padding;
        'number' === f.type(e) && (d.margin = [e, e, e, e]);
        'number' === f.type(c) && (d.padding = [c, c, c, c]);
        d.modal &&
          f.extend(!0, d, {
            closeBtn: !1,
            closeClick: !1,
            nextClick: !1,
            arrows: !1,
            mouseWheel: !1,
            keys: null,
            helpers: { overlay: { closeClick: !1 } },
          });
        d.autoSize && (d.autoWidth = d.autoHeight = !0);
        'auto' === d.width && (d.autoWidth = !0);
        'auto' === d.height && (d.autoHeight = !0);
        d.group = b.group;
        d.index = a;
        b.coming = d;
        if (!1 === b.trigger('beforeLoad')) b.coming = null;
        else {
          c = d.type;
          e = d.href;
          if (!c)
            return (
              (b.coming = null),
              b.current && b.router && 'jumpto' !== b.router ? ((b.current.index = a), b[b.router](b.direction)) : !1
            );
          b.isActive = !0;
          if ('image' === c || 'swf' === c) (d.autoHeight = d.autoWidth = !1), (d.scrolling = 'visible');
          'image' === c && (d.aspectRatio = !0);
          'iframe' === c && s && (d.scrolling = 'scroll');
          d.wrap = f(d.tpl.wrap)
            .addClass('fancybox-' + (s ? 'mobile' : 'desktop') + ' fancybox-type-' + c + ' fancybox-tmp ' + d.wrapCSS)
            .appendTo(d.parent || 'body');
          f.extend(d, {
            skin: f('.fancybox-skin', d.wrap),
            outer: f('.fancybox-outer', d.wrap),
            inner: f('.fancybox-inner', d.wrap),
          });
          f.each(['Top', 'Right', 'Bottom', 'Left'], function (a, b) {
            d.skin.css('padding' + b, w(d.padding[a]));
          });
          b.trigger('onReady');
          if ('inline' === c || 'html' === c) {
            if (!d.content || !d.content.length) return b._error('content');
          } else if (!e) return b._error('href');
          'image' === c
            ? b._loadImage()
            : 'ajax' === c
            ? b._loadAjax()
            : 'iframe' === c
            ? b._loadIframe()
            : b._afterLoad();
        }
      },
      _error: function (a) {
        f.extend(b.coming, {
          type: 'html',
          autoWidth: !0,
          autoHeight: !0,
          minWidth: 0,
          minHeight: 0,
          scrolling: 'no',
          hasError: a,
          content: b.coming.tpl.error,
        });
        b._afterLoad();
      },
      _loadImage: function () {
        var a = (b.imgPreload = new Image());
        a.onload = function () {
          this.onload = this.onerror = null;
          b.coming.width = this.width / b.opts.pixelRatio;
          b.coming.height = this.height / b.opts.pixelRatio;
          b._afterLoad();
        };
        a.onerror = function () {
          this.onload = this.onerror = null;
          b._error('image');
        };
        a.src = b.coming.href;
        !0 !== a.complete && b.showLoading();
      },
      _loadAjax: function () {
        var a = b.coming;
        b.showLoading();
        b.ajaxLoad = f.ajax(
          f.extend({}, a.ajax, {
            url: a.href,
            error: function (a, e) {
              b.coming && 'abort' !== e ? b._error('ajax', a) : b.hideLoading();
            },
            success: function (d, e) {
              'success' === e && ((a.content = d), b._afterLoad());
            },
          })
        );
      },
      _loadIframe: function () {
        var a = b.coming,
          d = f(a.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
            .attr('scrolling', s ? 'auto' : a.iframe.scrolling)
            .attr('src', a.href);
        f(a.wrap).bind('onReset', function () {
          try {
            f(this).find('iframe').hide().attr('src', '//about:blank').end().empty();
          } catch (a) {}
        });
        a.iframe.preload &&
          (b.showLoading(),
          d.one('load', function () {
            f(this).data('ready', 1);
            s || f(this).bind('load.fb', b.update);
            f(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();
            b._afterLoad();
          }));
        a.content = d.appendTo(a.inner);
        a.iframe.preload || b._afterLoad();
      },
      _preloadImages: function () {
        var a = b.group,
          d = b.current,
          e = a.length,
          c = d.preload ? Math.min(d.preload, e - 1) : 0,
          f,
          g;
        for (g = 1; g <= c; g += 1)
          (f = a[(d.index + g) % e]), 'image' === f.type && f.href && (new Image().src = f.href);
      },
      _afterLoad: function () {
        var a = b.coming,
          d = b.current,
          e,
          c,
          k,
          g,
          h;
        b.hideLoading();
        if (a && !1 !== b.isActive)
          if (!1 === b.trigger('afterLoad', a, d)) a.wrap.stop(!0).trigger('onReset').remove(), (b.coming = null);
          else {
            d &&
              (b.trigger('beforeChange', d),
              d.wrap.stop(!0).removeClass('fancybox-opened').find('.fancybox-item, .fancybox-nav').remove());
            b.unbindEvents();
            e = a.content;
            c = a.type;
            k = a.scrolling;
            f.extend(b, {
              wrap: a.wrap,
              skin: a.skin,
              outer: a.outer,
              inner: a.inner,
              current: a,
              previous: d,
            });
            g = a.href;
            switch (c) {
              case 'inline':
              case 'ajax':
              case 'html':
                a.selector
                  ? (e = f('<div>').html(e).find(a.selector))
                  : t(e) &&
                    (e.data('fancybox-placeholder') ||
                      e.data(
                        'fancybox-placeholder',
                        f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()
                      ),
                    (e = e.show().detach()),
                    a.wrap.bind('onReset', function () {
                      f(this).find(e).length &&
                        e.hide().replaceAll(e.data('fancybox-placeholder')).data('fancybox-placeholder', !1);
                    }));
                break;
              case 'image':
                e = a.tpl.image.replace('{href}', g);
                break;
              case 'swf':
                (e =
                  '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' +
                  g +
                  '"></param>'),
                  (h = ''),
                  f.each(a.swf, function (a, b) {
                    e += '<param name="' + a + '" value="' + b + '"></param>';
                    h += ' ' + a + '="' + b + '"';
                  }),
                  (e +=
                    '<embed src="' +
                    g +
                    '" type="application/x-shockwave-flash" width="100%" height="100%"' +
                    h +
                    '></embed></object>');
            }
            (!t(e) || !e.parent().is(a.inner)) && a.inner.append(e);
            b.trigger('beforeShow');
            a.inner.css('overflow', 'yes' === k ? 'scroll' : 'no' === k ? 'hidden' : k);
            b._setDimension();
            b.reposition();
            b.isOpen = !1;
            b.coming = null;
            b.bindEvents();
            if (b.isOpened) {
              if (d.prevMethod) b.transitions[d.prevMethod]();
            } else f('.fancybox-wrap').not(a.wrap).stop(!0).trigger('onReset').remove();
            b.transitions[b.isOpened ? a.nextMethod : a.openMethod]();
            b._preloadImages();
          }
      },
      _setDimension: function () {
        var a = b.getViewport(),
          d = 0,
          e = !1,
          c = !1,
          e = b.wrap,
          k = b.skin,
          g = b.inner,
          h = b.current,
          c = h.width,
          j = h.height,
          m = h.minWidth,
          u = h.minHeight,
          n = h.maxWidth,
          p = h.maxHeight,
          s = h.scrolling,
          q = h.scrollOutside ? h.scrollbarWidth : 0,
          x = h.margin,
          y = l(x[1] + x[3]),
          r = l(x[0] + x[2]),
          v,
          z,
          t,
          C,
          A,
          F,
          B,
          D,
          H;
        e.add(k).add(g).width('auto').height('auto').removeClass('fancybox-tmp');
        x = l(k.outerWidth(!0) - k.width());
        v = l(k.outerHeight(!0) - k.height());
        z = y + x;
        t = r + v;
        C = E(c) ? ((a.w - z) * l(c)) / 100 : c;
        A = E(j) ? ((a.h - t) * l(j)) / 100 : j;
        if ('iframe' === h.type) {
          if (((H = h.content), h.autoHeight && 1 === H.data('ready')))
            try {
              H[0].contentWindow.document.location &&
                (g.width(C).height(9999),
                (F = H.contents().find('body')),
                q && F.css('overflow-x', 'hidden'),
                (A = F.outerHeight(!0)));
            } catch (G) {}
        } else if (h.autoWidth || h.autoHeight)
          g.addClass('fancybox-tmp'),
            h.autoWidth || g.width(C),
            h.autoHeight || g.height(A),
            h.autoWidth && (C = g.width()),
            h.autoHeight && (A = g.height()),
            g.removeClass('fancybox-tmp');
        c = l(C);
        j = l(A);
        D = C / A;
        m = l(E(m) ? l(m, 'w') - z : m);
        n = l(E(n) ? l(n, 'w') - z : n);
        u = l(E(u) ? l(u, 'h') - t : u);
        p = l(E(p) ? l(p, 'h') - t : p);
        F = n;
        B = p;
        h.fitToView && ((n = Math.min(a.w - z, n)), (p = Math.min(a.h - t, p)));
        z = a.w - y;
        r = a.h - r;
        h.aspectRatio
          ? (c > n && ((c = n), (j = l(c / D))),
            j > p && ((j = p), (c = l(j * D))),
            c < m && ((c = m), (j = l(c / D))),
            j < u && ((j = u), (c = l(j * D))))
          : ((c = Math.max(m, Math.min(c, n))),
            h.autoHeight && 'iframe' !== h.type && (g.width(c), (j = g.height())),
            (j = Math.max(u, Math.min(j, p))));
        if (h.fitToView)
          if ((g.width(c).height(j), e.width(c + x), (a = e.width()), (y = e.height()), h.aspectRatio))
            for (; (a > z || y > r) && c > m && j > u && !(19 < d++); )
              (j = Math.max(u, Math.min(p, j - 10))),
                (c = l(j * D)),
                c < m && ((c = m), (j = l(c / D))),
                c > n && ((c = n), (j = l(c / D))),
                g.width(c).height(j),
                e.width(c + x),
                (a = e.width()),
                (y = e.height());
          else (c = Math.max(m, Math.min(c, c - (a - z)))), (j = Math.max(u, Math.min(j, j - (y - r))));
        q && 'auto' === s && j < A && c + x + q < z && (c += q);
        g.width(c).height(j);
        e.width(c + x);
        a = e.width();
        y = e.height();
        e = (a > z || y > r) && c > m && j > u;
        c = h.aspectRatio ? c < F && j < B && c < C && j < A : (c < F || j < B) && (c < C || j < A);
        f.extend(h, {
          dim: { width: w(a), height: w(y) },
          origWidth: C,
          origHeight: A,
          canShrink: e,
          canExpand: c,
          wPadding: x,
          hPadding: v,
          wrapSpace: y - k.outerHeight(!0),
          skinSpace: k.height() - j,
        });
        !H && h.autoHeight && j > u && j < p && !c && g.height('auto');
      },
      _getPosition: function (a) {
        var d = b.current,
          e = b.getViewport(),
          c = d.margin,
          f = b.wrap.width() + c[1] + c[3],
          g = b.wrap.height() + c[0] + c[2],
          c = { position: 'absolute', top: c[0], left: c[3] };
        d.autoCenter && d.fixed && !a && g <= e.h && f <= e.w
          ? (c.position = 'fixed')
          : d.locked || ((c.top += e.y), (c.left += e.x));
        c.top = w(Math.max(c.top, c.top + (e.h - g) * d.topRatio));
        c.left = w(Math.max(c.left, c.left + (e.w - f) * d.leftRatio));
        return c;
      },
      _afterZoomIn: function () {
        var a = b.current;
        a &&
          ((b.isOpen = b.isOpened = !0),
          b.wrap.css('overflow', 'visible').addClass('fancybox-opened'),
          b.update(),
          (a.closeClick || (a.nextClick && 1 < b.group.length)) &&
            b.inner.css('cursor', 'pointer').bind('click.fb', function (d) {
              !f(d.target).is('a') &&
                !f(d.target).parent().is('a') &&
                (d.preventDefault(), b[a.closeClick ? 'close' : 'next']());
            }),
          a.closeBtn &&
            f(a.tpl.closeBtn)
              .appendTo(b.skin)
              .bind('click.fb', function (a) {
                a.preventDefault();
                b.close();
              }),
          a.arrows &&
            1 < b.group.length &&
            ((a.loop || 0 < a.index) && f(a.tpl.prev).appendTo(b.outer).bind('click.fb', b.prev),
            (a.loop || a.index < b.group.length - 1) && f(a.tpl.next).appendTo(b.outer).bind('click.fb', b.next)),
          b.trigger('afterShow'),
          !a.loop && a.index === a.group.length - 1
            ? b.play(!1)
            : b.opts.autoPlay && !b.player.isActive && ((b.opts.autoPlay = !1), b.play()));
      },
      _afterZoomOut: function (a) {
        a = a || b.current;
        f('.fancybox-wrap').trigger('onReset').remove();
        f.extend(b, {
          group: {},
          opts: {},
          router: !1,
          current: null,
          isActive: !1,
          isOpened: !1,
          isOpen: !1,
          isClosing: !1,
          wrap: null,
          skin: null,
          outer: null,
          inner: null,
        });
        b.trigger('afterClose', a);
      },
    });
    b.transitions = {
      getOrigPosition: function () {
        var a = b.current,
          d = a.element,
          e = a.orig,
          c = {},
          f = 50,
          g = 50,
          h = a.hPadding,
          j = a.wPadding,
          m = b.getViewport();
        !e && a.isDom && d.is(':visible') && ((e = d.find('img:first')), e.length || (e = d));
        t(e)
          ? ((c = e.offset()), e.is('img') && ((f = e.outerWidth()), (g = e.outerHeight())))
          : ((c.top = m.y + (m.h - g) * a.topRatio), (c.left = m.x + (m.w - f) * a.leftRatio));
        if ('fixed' === b.wrap.css('position') || a.locked) (c.top -= m.y), (c.left -= m.x);
        return (c = {
          top: w(c.top - h * a.topRatio),
          left: w(c.left - j * a.leftRatio),
          width: w(f + j),
          height: w(g + h),
        });
      },
      step: function (a, d) {
        var e,
          c,
          f = d.prop;
        c = b.current;
        var g = c.wrapSpace,
          h = c.skinSpace;
        if ('width' === f || 'height' === f)
          (e = d.end === d.start ? 1 : (a - d.start) / (d.end - d.start)),
            b.isClosing && (e = 1 - e),
            (c = 'width' === f ? c.wPadding : c.hPadding),
            (c = a - c),
            b.skin[f](l('width' === f ? c : c - g * e)),
            b.inner[f](l('width' === f ? c : c - g * e - h * e));
      },
      zoomIn: function () {
        var a = b.current,
          d = a.pos,
          e = a.openEffect,
          c = 'elastic' === e,
          k = f.extend({ opacity: 1 }, d);
        delete k.position;
        c ? ((d = this.getOrigPosition()), a.openOpacity && (d.opacity = 0.1)) : 'fade' === e && (d.opacity = 0.1);
        b.wrap.css(d).animate(k, {
          duration: 'none' === e ? 0 : a.openSpeed,
          easing: a.openEasing,
          step: c ? this.step : null,
          complete: b._afterZoomIn,
        });
      },
      zoomOut: function () {
        var a = b.current,
          d = a.closeEffect,
          e = 'elastic' === d,
          c = { opacity: 0.1 };
        e && ((c = this.getOrigPosition()), a.closeOpacity && (c.opacity = 0.1));
        b.wrap.animate(c, {
          duration: 'none' === d ? 0 : a.closeSpeed,
          easing: a.closeEasing,
          step: e ? this.step : null,
          complete: b._afterZoomOut,
        });
      },
      changeIn: function () {
        var a = b.current,
          d = a.nextEffect,
          e = a.pos,
          c = { opacity: 1 },
          f = b.direction,
          g;
        e.opacity = 0.1;
        'elastic' === d &&
          ((g = 'down' === f || 'up' === f ? 'top' : 'left'),
          'down' === f || 'right' === f
            ? ((e[g] = w(l(e[g]) - 200)), (c[g] = '+=200px'))
            : ((e[g] = w(l(e[g]) + 200)), (c[g] = '-=200px')));
        'none' === d
          ? b._afterZoomIn()
          : b.wrap.css(e).animate(c, {
              duration: a.nextSpeed,
              easing: a.nextEasing,
              complete: b._afterZoomIn,
            });
      },
      changeOut: function () {
        var a = b.previous,
          d = a.prevEffect,
          e = { opacity: 0.1 },
          c = b.direction;
        'elastic' === d &&
          (e['down' === c || 'up' === c ? 'top' : 'left'] = ('up' === c || 'left' === c ? '-' : '+') + '=200px');
        a.wrap.animate(e, {
          duration: 'none' === d ? 0 : a.prevSpeed,
          easing: a.prevEasing,
          complete: function () {
            f(this).trigger('onReset').remove();
          },
        });
      },
    };
    b.helpers.overlay = {
      defaults: {
        closeClick: !0,
        speedOut: 200,
        showEarly: !0,
        css: {},
        locked: !s,
        fixed: !0,
      },
      overlay: null,
      fixed: !1,
      el: f('html'),
      create: function (a) {
        a = f.extend({}, this.defaults, a);
        this.overlay && this.close();
        this.overlay = f('<div class="fancybox-overlay"></div>').appendTo(b.coming ? b.coming.parent : a.parent);
        this.fixed = !1;
        a.fixed && b.defaults.fixed && (this.overlay.addClass('fancybox-overlay-fixed'), (this.fixed = !0));
      },
      open: function (a) {
        var d = this;
        a = f.extend({}, this.defaults, a);
        this.overlay ? this.overlay.unbind('.overlay').width('auto').height('auto') : this.create(a);
        this.fixed || (n.bind('resize.overlay', f.proxy(this.update, this)), this.update());
        a.closeClick &&
          this.overlay.bind('click.overlay', function (a) {
            if (f(a.target).hasClass('fancybox-overlay')) return b.isActive ? b.close() : d.close(), !1;
          });
        this.overlay.css(a.css).show();
      },
      close: function () {
        var a, b;
        n.unbind('resize.overlay');
        this.el.hasClass('fancybox-lock') &&
          (f('.fancybox-margin').removeClass('fancybox-margin'),
          (a = n.scrollTop()),
          (b = n.scrollLeft()),
          this.el.removeClass('fancybox-lock'),
          n.scrollTop(a).scrollLeft(b));
        f('.fancybox-overlay').remove().hide();
        f.extend(this, { overlay: null, fixed: !1 });
      },
      update: function () {
        var a = '100%',
          b;
        this.overlay.width(a).height('100%');
        I
          ? ((b = Math.max(G.documentElement.offsetWidth, G.body.offsetWidth)), p.width() > b && (a = p.width()))
          : p.width() > n.width() && (a = p.width());
        this.overlay.width(a).height(p.height());
      },
      onReady: function (a, b) {
        var e = this.overlay;
        f('.fancybox-overlay').stop(!0, !0);
        e || this.create(a);
        a.locked &&
          this.fixed &&
          b.fixed &&
          (e || (this.margin = p.height() > n.height() ? f('html').css('margin-right').replace('px', '') : !1),
          (b.locked = this.overlay.append(b.wrap)),
          (b.fixed = !1));
        !0 === a.showEarly && this.beforeShow.apply(this, arguments);
      },
      beforeShow: function (a, b) {
        var e, c;
        b.locked &&
          (!1 !== this.margin &&
            (f('*')
              .filter(function () {
                return (
                  'fixed' === f(this).css('position') &&
                  !f(this).hasClass('fancybox-overlay') &&
                  !f(this).hasClass('fancybox-wrap')
                );
              })
              .addClass('fancybox-margin'),
            this.el.addClass('fancybox-margin')),
          (e = n.scrollTop()),
          (c = n.scrollLeft()),
          this.el.addClass('fancybox-lock'),
          n.scrollTop(e).scrollLeft(c));
        this.open(a);
      },
      onUpdate: function () {
        this.fixed || this.update();
      },
      afterClose: function (a) {
        this.overlay && !b.coming && this.overlay.fadeOut(a.speedOut, f.proxy(this.close, this));
      },
    };
    b.helpers.title = {
      defaults: { type: 'float', position: 'bottom' },
      beforeShow: function (a) {
        var d = b.current,
          e = d.title,
          c = a.type;
        f.isFunction(e) && (e = e.call(d.element, d));
        if (q(e) && '' !== f.trim(e)) {
          d = f('<div class="fancybox-title fancybox-title-' + c + '-wrap">' + e + '</div>');
          switch (c) {
            case 'inside':
              c = b.skin;
              break;
            case 'outside':
              c = b.wrap;
              break;
            case 'over':
              c = b.inner;
              break;
            default:
              (c = b.skin),
                d.appendTo('body'),
                I && d.width(d.width()),
                d.wrapInner('<span class="child"></span>'),
                (b.current.margin[2] += Math.abs(l(d.css('margin-bottom'))));
          }
          d['top' === a.position ? 'prependTo' : 'appendTo'](c);
        }
      },
    };
    f.fn.fancybox = function (a) {
      var d,
        e = f(this),
        c = this.selector || '',
        k = function (g) {
          var h = f(this).blur(),
            j = d,
            k,
            l;
          !g.ctrlKey &&
            !g.altKey &&
            !g.shiftKey &&
            !g.metaKey &&
            !h.is('.fancybox-wrap') &&
            ((k = a.groupAttr || 'data-fancybox-group'),
            (l = h.attr(k)),
            l || ((k = 'rel'), (l = h.get(0)[k])),
            l &&
              '' !== l &&
              'nofollow' !== l &&
              ((h = c.length ? f(c) : e), (h = h.filter('[' + k + '="' + l + '"]')), (j = h.index(this))),
            (a.index = j),
            !1 !== b.open(h, a) && g.preventDefault());
        };
      a = a || {};
      d = a.index || 0;
      !c || !1 === a.live
        ? e.unbind('click.fb-start').bind('click.fb-start', k)
        : p.undelegate(c, 'click.fb-start').delegate(c + ":not('.fancybox-item, .fancybox-nav')", 'click.fb-start', k);
      this.filter('[data-fancybox-start=1]').trigger('click');
      return this;
    };
    p.ready(function () {
      var a, d;
      f.scrollbarWidth === v &&
        (f.scrollbarWidth = function () {
          var a = f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),
            b = a.children(),
            b = b.innerWidth() - b.height(99).innerWidth();
          a.remove();
          return b;
        });
      if (f.support.fixedPosition === v) {
        a = f.support;
        d = f('<div style="position:fixed;top:20px;"></div>').appendTo('body');
        var e = 20 === d[0].offsetTop || 15 === d[0].offsetTop;
        d.remove();
        a.fixedPosition = e;
      }
      f.extend(b.defaults, {
        scrollbarWidth: f.scrollbarWidth(),
        fixed: f.support.fixedPosition,
        parent: f('body'),
      });
      a = f(r).width();
      J.addClass('fancybox-lock-test');
      d = f(r).width();
      J.removeClass('fancybox-lock-test');
      f("<style type='text/css'>.fancybox-margin{margin-right:" + (d - a) + 'px;}</style>').appendTo('head');
    });
  })(window, document, jQuery);

  /*!
   * jQuery Cookie Plugin v1.4.1
   * https://github.com/carhartl/jquery-cookie
   *
   * Copyright 2006, 2014 Klaus Hartl
   * Released under the MIT license
   */

  (function (factory) {
    if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
    } else if (typeof exports === 'object') {
      factory(require('jquery'));
    } else {
      factory(jQuery);
    }
  })(function ($) {
    var pluses = /\+/g;
    function encode(s) {
      return config.raw ? s : encodeURIComponent(s);
    }
    function decode(s) {
      return config.raw ? s : decodeURIComponent(s);
    }
    function stringifyCookieValue(value) {
      return encode(config.json ? JSON.stringify(value) : String(value));
    }
    function parseCookieValue(s) {
      if (s.indexOf('"') === 0) {
        s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
      }
      try {
        s = decodeURIComponent(s.replace(pluses, ' '));
        return config.json ? JSON.parse(s) : s;
      } catch (e) {}
    }
    function read(s, converter) {
      var value = config.raw ? s : parseCookieValue(s);
      return $.isFunction(converter) ? converter(value) : value;
    }
    var config = ($.cookie = function (key, value, options) {
      if (arguments.length > 1 && !$.isFunction(value)) {
        options = $.extend({}, config.defaults, options);
        if (typeof options.expires === 'number') {
          var days = options.expires,
            t = (options.expires = new Date());
          t.setTime(+t + days * 864e5);
        }
        return (document.cookie = [
          encode(key),
          '=',
          stringifyCookieValue(value),
          options.expires ? '; expires=' + options.expires.toUTCString() : '',
          options.path ? '; path=' + options.path : '',
          options.domain ? '; domain=' + options.domain : '',
          options.secure ? '; secure' : '',
        ].join(''));
      }
      var result = key ? undefined : {};
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      for (var i = 0, l = cookies.length; i < l; i++) {
        var parts = cookies[i].split('=');
        var name = decode(parts.shift());
        var cookie = parts.join('=');
        if (key && key === name) {
          result = read(cookie, value);
          break;
        }
        if (!key && (cookie = read(cookie)) !== undefined) {
          result[name] = cookie;
        }
      }
      return result;
    });
    config.defaults = {};
    $.removeCookie = function (key, options) {
      if ($.cookie(key) === undefined) {
        return false;
      }
      $.cookie(key, '', $.extend({}, options, { expires: -1 }));
      return !$.cookie(key);
    };
  });

  /*!
   * jQuery Smooth Scroll - v1.7.2 - 2016-01-23
   * https://github.com/kswedberg/jquery-smooth-scroll
   * Copyright (c) 2016 Karl Swedberg
   * Licensed MIT
   */

  !(function (a) {
    'function' == typeof define && define.amd
      ? define(['jquery'], a)
      : a('object' == typeof module && module.exports ? require('jquery') : jQuery);
  })(function (a) {
    var b = '1.7.2',
      c = {},
      d = {
        exclude: [],
        excludeWithin: [],
        offset: 0,
        direction: 'top',
        delegateSelector: null,
        scrollElement: null,
        scrollTarget: null,
        beforeScroll: function () {},
        afterScroll: function () {},
        easing: 'swing',
        speed: 400,
        autoCoefficient: 2,
        preventDefault: !0,
      },
      e = function (b) {
        var c = [],
          d = !1,
          e = b.dir && 'left' === b.dir ? 'scrollLeft' : 'scrollTop';
        return (
          this.each(function () {
            var b = a(this);
            if (this !== document && this !== window)
              return !document.scrollingElement || (this !== document.documentElement && this !== document.body)
                ? void (b[e]() > 0 ? c.push(this) : (b[e](1), (d = b[e]() > 0), d && c.push(this), b[e](0)))
                : (c.push(document.scrollingElement), !1);
          }),
          c.length ||
            this.each(function () {
              this === document.documentElement && 'smooth' === a(this).css('scrollBehavior') && (c = [this]),
                c.length || 'BODY' !== this.nodeName || (c = [this]);
            }),
          'first' === b.el && c.length > 1 && (c = [c[0]]),
          c
        );
      };
    a.fn.extend({
      scrollable: function (a) {
        var b = e.call(this, { dir: a });
        return this.pushStack(b);
      },
      firstScrollable: function (a) {
        var b = e.call(this, { el: 'first', dir: a });
        return this.pushStack(b);
      },
      smoothScroll: function (b, c) {
        if (((b = b || {}), 'options' === b))
          return c
            ? this.each(function () {
                var b = a(this),
                  d = a.extend(b.data('ssOpts') || {}, c);
                a(this).data('ssOpts', d);
              })
            : this.first().data('ssOpts');
        var d = a.extend({}, a.fn.smoothScroll.defaults, b),
          e = function (b) {
            var c = function (a) {
                return a.replace(/(:|\.|\/)/g, '\\$1');
              },
              e = this,
              f = a(this),
              g = a.extend({}, d, f.data('ssOpts') || {}),
              h = d.exclude,
              i = g.excludeWithin,
              j = 0,
              k = 0,
              l = !0,
              m = {},
              n = a.smoothScroll.filterPath(location.pathname),
              o = a.smoothScroll.filterPath(e.pathname),
              p = location.hostname === e.hostname || !e.hostname,
              q = g.scrollTarget || o === n,
              r = c(e.hash);
            if ((r && !a(r).length && (l = !1), g.scrollTarget || (p && q && r))) {
              for (; l && j < h.length; ) f.is(c(h[j++])) && (l = !1);
              for (; l && k < i.length; ) f.closest(i[k++]).length && (l = !1);
            } else l = !1;
            l &&
              (g.preventDefault && b.preventDefault(),
              a.extend(m, g, { scrollTarget: g.scrollTarget || r, link: e }),
              a.smoothScroll(m));
          };
        return (
          null !== b.delegateSelector
            ? this.undelegate(b.delegateSelector, 'click.smoothscroll').delegate(
                b.delegateSelector,
                'click.smoothscroll',
                e
              )
            : this.unbind('click.smoothscroll').bind('click.smoothscroll', e),
          this
        );
      },
    }),
      (a.smoothScroll = function (b, d) {
        if ('options' === b && 'object' == typeof d) return a.extend(c, d);
        var e,
          f,
          g,
          h,
          i,
          j = 0,
          k = 'offset',
          l = 'scrollTop',
          m = {},
          n = {};
        'number' == typeof b
          ? ((e = a.extend({ link: null }, a.fn.smoothScroll.defaults, c)), (g = b))
          : ((e = a.extend({ link: null }, a.fn.smoothScroll.defaults, b || {}, c)),
            e.scrollElement &&
              ((k = 'position'),
              'static' === e.scrollElement.css('position') && e.scrollElement.css('position', 'relative'))),
          (l = 'left' === e.direction ? 'scrollLeft' : l),
          e.scrollElement
            ? ((f = e.scrollElement), /^(?:HTML|BODY)$/.test(f[0].nodeName) || (j = f[l]()))
            : (f = a('html, body').firstScrollable(e.direction)),
          e.beforeScroll.call(f, e),
          (g = 'number' == typeof b ? b : d || (a(e.scrollTarget)[k]() && a(e.scrollTarget)[k]()[e.direction]) || 0),
          (m[l] = g + j + e.offset),
          (h = e.speed),
          'auto' === h && ((i = Math.abs(m[l] - f[l]())), (h = i / e.autoCoefficient)),
          (n = {
            duration: h,
            easing: e.easing,
            complete: function () {
              e.afterScroll.call(e.link, e);
            },
          }),
          e.step && (n.step = e.step),
          f.length ? f.stop().animate(m, n) : e.afterScroll.call(e.link, e);
      }),
      (a.smoothScroll.version = b),
      (a.smoothScroll.filterPath = function (a) {
        return (
          (a = a || ''),
          a
            .replace(/^\//, '')
            .replace(/(?:index|default).[a-zA-Z]{3,4}$/, '')
            .replace(/\/$/, '')
        );
      }),
      (a.fn.smoothScroll.defaults = d);
  });

  /*
   * jQuery FlexSlider v2.6.3
   * Copyright 2012 WooThemes
   * Contributing Author: Tyler Smith
   */ !(function ($) {
    var e = !0;
    ($.flexslider = function (t, a) {
      var n = $(t);
      n.vars = $.extend({}, $.flexslider.defaults, a);
      var i = n.vars.namespace,
        s = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
        r =
          ('ontouchstart' in window || s || (window.DocumentTouch && document instanceof DocumentTouch)) &&
          n.vars.touch,
        o = 'click touchend MSPointerUp keyup',
        l = '',
        c,
        d = 'vertical' === n.vars.direction,
        u = n.vars.reverse,
        v = n.vars.itemWidth > 0,
        p = 'fade' === n.vars.animation,
        m = '' !== n.vars.asNavFor,
        f = {};
      $.data(t, 'flexslider', n),
        (f = {
          init: function () {
            (n.animating = !1),
              (n.currentSlide = parseInt(n.vars.startAt ? n.vars.startAt : 0, 10)),
              isNaN(n.currentSlide) && (n.currentSlide = 0),
              (n.animatingTo = n.currentSlide),
              (n.atEnd = 0 === n.currentSlide || n.currentSlide === n.last),
              (n.containerSelector = n.vars.selector.substr(0, n.vars.selector.search(' '))),
              (n.slides = $(n.vars.selector, n)),
              (n.container = $(n.containerSelector, n)),
              (n.count = n.slides.length),
              (n.syncExists = $(n.vars.sync).length > 0),
              'slide' === n.vars.animation && (n.vars.animation = 'swing'),
              (n.prop = d ? 'top' : 'marginLeft'),
              (n.args = {}),
              (n.manualPause = !1),
              (n.stopped = !1),
              (n.started = !1),
              (n.startTimeout = null),
              (n.transitions =
                !n.vars.video &&
                !p &&
                n.vars.useCSS &&
                (function () {
                  var e = document.createElement('div'),
                    t = ['perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
                  for (var a in t)
                    if (void 0 !== e.style[t[a]])
                      return (
                        (n.pfx = t[a].replace('Perspective', '').toLowerCase()),
                        (n.prop = '-' + n.pfx + '-transform'),
                        !0
                      );
                  return !1;
                })()),
              (n.ensureAnimationEnd = ''),
              '' !== n.vars.controlsContainer &&
                (n.controlsContainer = $(n.vars.controlsContainer).length > 0 && $(n.vars.controlsContainer)),
              '' !== n.vars.manualControls &&
                (n.manualControls = $(n.vars.manualControls).length > 0 && $(n.vars.manualControls)),
              '' !== n.vars.customDirectionNav &&
                (n.customDirectionNav = 2 === $(n.vars.customDirectionNav).length && $(n.vars.customDirectionNav)),
              n.vars.randomize &&
                (n.slides.sort(function () {
                  return Math.round(Math.random()) - 0.5;
                }),
                n.container.empty().append(n.slides)),
              n.doMath(),
              n.setup('init'),
              n.vars.controlNav && f.controlNav.setup(),
              n.vars.directionNav && f.directionNav.setup(),
              n.vars.keyboard &&
                (1 === $(n.containerSelector).length || n.vars.multipleKeyboard) &&
                $(document).bind('keyup', function (e) {
                  var t = e.keyCode;
                  if (!n.animating && (39 === t || 37 === t)) {
                    var a = 39 === t ? n.getTarget('next') : 37 === t ? n.getTarget('prev') : !1;
                    n.flexAnimate(a, n.vars.pauseOnAction);
                  }
                }),
              n.vars.mousewheel &&
                n.bind('mousewheel', function (e, t, a, i) {
                  e.preventDefault();
                  var s = 0 > t ? n.getTarget('next') : n.getTarget('prev');
                  n.flexAnimate(s, n.vars.pauseOnAction);
                }),
              n.vars.pausePlay && f.pausePlay.setup(),
              n.vars.slideshow && n.vars.pauseInvisible && f.pauseInvisible.init(),
              n.vars.slideshow &&
                (n.vars.pauseOnHover &&
                  n.hover(
                    function () {
                      n.manualPlay || n.manualPause || n.pause();
                    },
                    function () {
                      n.manualPause || n.manualPlay || n.stopped || n.play();
                    }
                  ),
                (n.vars.pauseInvisible && f.pauseInvisible.isHidden()) ||
                  (n.vars.initDelay > 0 ? (n.startTimeout = setTimeout(n.play, n.vars.initDelay)) : n.play())),
              m && f.asNav.setup(),
              r && n.vars.touch && f.touch(),
              (!p || (p && n.vars.smoothHeight)) && $(window).bind('resize orientationchange focus', f.resize),
              n.find('img').attr('draggable', 'false'),
              setTimeout(function () {
                n.vars.start(n);
              }, 200);
          },
          asNav: {
            setup: function () {
              (n.asNav = !0),
                (n.animatingTo = Math.floor(n.currentSlide / n.move)),
                (n.currentItem = n.currentSlide),
                n.slides
                  .removeClass(i + 'active-slide')
                  .eq(n.currentItem)
                  .addClass(i + 'active-slide'),
                s
                  ? ((t._slider = n),
                    n.slides.each(function () {
                      var e = this;
                      (e._gesture = new MSGesture()),
                        (e._gesture.target = e),
                        e.addEventListener(
                          'MSPointerDown',
                          function (e) {
                            e.preventDefault(),
                              e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId);
                          },
                          !1
                        ),
                        e.addEventListener('MSGestureTap', function (e) {
                          e.preventDefault();
                          var t = $(this),
                            a = t.index();
                          $(n.vars.asNavFor).data('flexslider').animating ||
                            t.hasClass('active') ||
                            ((n.direction = n.currentItem < a ? 'next' : 'prev'),
                            n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0));
                        });
                    }))
                  : n.slides.on(o, function (e) {
                      e.preventDefault();
                      var t = $(this),
                        a = t.index(),
                        s = t.offset().left - $(n).scrollLeft();
                      0 >= s && t.hasClass(i + 'active-slide')
                        ? n.flexAnimate(n.getTarget('prev'), !0)
                        : $(n.vars.asNavFor).data('flexslider').animating ||
                          t.hasClass(i + 'active-slide') ||
                          ((n.direction = n.currentItem < a ? 'next' : 'prev'),
                          n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0));
                    });
            },
          },
          controlNav: {
            setup: function () {
              n.manualControls ? f.controlNav.setupManual() : f.controlNav.setupPaging();
            },
            setupPaging: function () {
              var e = 'thumbnails' === n.vars.controlNav ? 'control-thumbs' : 'control-paging',
                t = 1,
                a,
                s;
              if (
                ((n.controlNavScaffold = $('<ol class="' + i + 'control-nav ' + i + e + '"></ol>')), n.pagingCount > 1)
              )
                for (var r = 0; r < n.pagingCount; r++) {
                  (s = n.slides.eq(r)), void 0 === s.attr('data-thumb-alt') && s.attr('data-thumb-alt', '');
                  var c = '' !== s.attr('data-thumb-alt') ? (c = ' alt="' + s.attr('data-thumb-alt') + '"') : '';
                  if (
                    ((a =
                      'thumbnails' === n.vars.controlNav
                        ? '<img src="' + s.attr('data-thumb') + '"' + c + '/>'
                        : '<a href="#">' + t + '</a>'),
                    'thumbnails' === n.vars.controlNav && !0 === n.vars.thumbCaptions)
                  ) {
                    var d = s.attr('data-thumbcaption');
                    '' !== d && void 0 !== d && (a += '<span class="' + i + 'caption">' + d + '</span>');
                  }
                  n.controlNavScaffold.append('<li>' + a + '</li>'), t++;
                }
              n.controlsContainer
                ? $(n.controlsContainer).append(n.controlNavScaffold)
                : n.append(n.controlNavScaffold),
                f.controlNav.set(),
                f.controlNav.active(),
                n.controlNavScaffold.delegate('a, img', o, function (e) {
                  if ((e.preventDefault(), '' === l || l === e.type)) {
                    var t = $(this),
                      a = n.controlNav.index(t);
                    t.hasClass(i + 'active') ||
                      ((n.direction = a > n.currentSlide ? 'next' : 'prev'), n.flexAnimate(a, n.vars.pauseOnAction));
                  }
                  '' === l && (l = e.type), f.setToClearWatchedEvent();
                });
            },
            setupManual: function () {
              (n.controlNav = n.manualControls),
                f.controlNav.active(),
                n.controlNav.bind(o, function (e) {
                  if ((e.preventDefault(), '' === l || l === e.type)) {
                    var t = $(this),
                      a = n.controlNav.index(t);
                    t.hasClass(i + 'active') ||
                      (a > n.currentSlide ? (n.direction = 'next') : (n.direction = 'prev'),
                      n.flexAnimate(a, n.vars.pauseOnAction));
                  }
                  '' === l && (l = e.type), f.setToClearWatchedEvent();
                });
            },
            set: function () {
              var e = 'thumbnails' === n.vars.controlNav ? 'img' : 'a';
              n.controlNav = $('.' + i + 'control-nav li ' + e, n.controlsContainer ? n.controlsContainer : n);
            },
            active: function () {
              n.controlNav
                .removeClass(i + 'active')
                .eq(n.animatingTo)
                .addClass(i + 'active');
            },
            update: function (e, t) {
              n.pagingCount > 1 && 'add' === e
                ? n.controlNavScaffold.append($('<li><a href="#">' + n.count + '</a></li>'))
                : 1 === n.pagingCount
                ? n.controlNavScaffold.find('li').remove()
                : n.controlNav.eq(t).closest('li').remove(),
                f.controlNav.set(),
                n.pagingCount > 1 && n.pagingCount !== n.controlNav.length ? n.update(t, e) : f.controlNav.active();
            },
          },
          directionNav: {
            setup: function () {
              var e = $(
                '<ul class="' +
                  i +
                  'direction-nav"><li class="' +
                  i +
                  'nav-prev"><a class="' +
                  i +
                  'prev" href="#">' +
                  n.vars.prevText +
                  '</a></li><li class="' +
                  i +
                  'nav-next"><a class="' +
                  i +
                  'next" href="#">' +
                  n.vars.nextText +
                  '</a></li></ul>'
              );
              n.customDirectionNav
                ? (n.directionNav = n.customDirectionNav)
                : n.controlsContainer
                ? ($(n.controlsContainer).append(e),
                  (n.directionNav = $('.' + i + 'direction-nav li a', n.controlsContainer)))
                : (n.append(e), (n.directionNav = $('.' + i + 'direction-nav li a', n))),
                f.directionNav.update(),
                n.directionNav.bind(o, function (e) {
                  e.preventDefault();
                  var t;
                  ('' !== l && l !== e.type) ||
                    ((t = $(this).hasClass(i + 'next') ? n.getTarget('next') : n.getTarget('prev')),
                    n.flexAnimate(t, n.vars.pauseOnAction)),
                    '' === l && (l = e.type),
                    f.setToClearWatchedEvent();
                });
            },
            update: function () {
              var e = i + 'disabled';
              1 === n.pagingCount
                ? n.directionNav.addClass(e).attr('tabindex', '-1')
                : n.vars.animationLoop
                ? n.directionNav.removeClass(e).removeAttr('tabindex')
                : 0 === n.animatingTo
                ? n.directionNav
                    .removeClass(e)
                    .filter('.' + i + 'prev')
                    .addClass(e)
                    .attr('tabindex', '-1')
                : n.animatingTo === n.last
                ? n.directionNav
                    .removeClass(e)
                    .filter('.' + i + 'next')
                    .addClass(e)
                    .attr('tabindex', '-1')
                : n.directionNav.removeClass(e).removeAttr('tabindex');
            },
          },
          pausePlay: {
            setup: function () {
              var e = $('<div class="' + i + 'pauseplay"><a href="#"></a></div>');
              n.controlsContainer
                ? (n.controlsContainer.append(e), (n.pausePlay = $('.' + i + 'pauseplay a', n.controlsContainer)))
                : (n.append(e), (n.pausePlay = $('.' + i + 'pauseplay a', n))),
                f.pausePlay.update(n.vars.slideshow ? i + 'pause' : i + 'play'),
                n.pausePlay.bind(o, function (e) {
                  e.preventDefault(),
                    ('' !== l && l !== e.type) ||
                      ($(this).hasClass(i + 'pause')
                        ? ((n.manualPause = !0), (n.manualPlay = !1), n.pause())
                        : ((n.manualPause = !1), (n.manualPlay = !0), n.play())),
                    '' === l && (l = e.type),
                    f.setToClearWatchedEvent();
                });
            },
            update: function (e) {
              'play' === e
                ? n.pausePlay
                    .removeClass(i + 'pause')
                    .addClass(i + 'play')
                    .html(n.vars.playText)
                : n.pausePlay
                    .removeClass(i + 'play')
                    .addClass(i + 'pause')
                    .html(n.vars.pauseText);
            },
          },
          touch: function () {
            function e(e) {
              e.stopPropagation(),
                n.animating
                  ? e.preventDefault()
                  : (n.pause(),
                    t._gesture.addPointer(e.pointerId),
                    (T = 0),
                    (c = d ? n.h : n.w),
                    (f = Number(new Date())),
                    (l =
                      v && u && n.animatingTo === n.last
                        ? 0
                        : v && u
                        ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                        : v && n.currentSlide === n.last
                        ? n.limit
                        : v
                        ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                        : u
                        ? (n.last - n.currentSlide + n.cloneOffset) * c
                        : (n.currentSlide + n.cloneOffset) * c));
            }
            function a(e) {
              e.stopPropagation();
              var a = e.target._slider;
              if (a) {
                var n = -e.translationX,
                  i = -e.translationY;
                return (
                  (T += d ? i : n),
                  (m = T),
                  (y = d ? Math.abs(T) < Math.abs(-n) : Math.abs(T) < Math.abs(-i)),
                  e.detail === e.MSGESTURE_FLAG_INERTIA
                    ? void setImmediate(function () {
                        t._gesture.stop();
                      })
                    : void (
                        (!y || Number(new Date()) - f > 500) &&
                        (e.preventDefault(),
                        !p &&
                          a.transitions &&
                          (a.vars.animationLoop ||
                            (m =
                              T /
                              ((0 === a.currentSlide && 0 > T) || (a.currentSlide === a.last && T > 0)
                                ? Math.abs(T) / c + 2
                                : 1)),
                          a.setProps(l + m, 'setTouch')))
                      )
                );
              }
            }
            function i(e) {
              e.stopPropagation();
              var t = e.target._slider;
              if (t) {
                if (t.animatingTo === t.currentSlide && !y && null !== m) {
                  var a = u ? -m : m,
                    n = a > 0 ? t.getTarget('next') : t.getTarget('prev');
                  t.canAdvance(n) && ((Number(new Date()) - f < 550 && Math.abs(a) > 50) || Math.abs(a) > c / 2)
                    ? t.flexAnimate(n, t.vars.pauseOnAction)
                    : p || t.flexAnimate(t.currentSlide, t.vars.pauseOnAction, !0);
                }
                (r = null), (o = null), (m = null), (l = null), (T = 0);
              }
            }
            var r,
              o,
              l,
              c,
              m,
              f,
              g,
              h,
              S,
              y = !1,
              x = 0,
              b = 0,
              T = 0;
            s
              ? ((t.style.msTouchAction = 'none'),
                (t._gesture = new MSGesture()),
                (t._gesture.target = t),
                t.addEventListener('MSPointerDown', e, !1),
                (t._slider = n),
                t.addEventListener('MSGestureChange', a, !1),
                t.addEventListener('MSGestureEnd', i, !1))
              : ((g = function (e) {
                  n.animating
                    ? e.preventDefault()
                    : (window.navigator.msPointerEnabled || 1 === e.touches.length) &&
                      (n.pause(),
                      (c = d ? n.h : n.w),
                      (f = Number(new Date())),
                      (x = e.touches[0].pageX),
                      (b = e.touches[0].pageY),
                      (l =
                        v && u && n.animatingTo === n.last
                          ? 0
                          : v && u
                          ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                          : v && n.currentSlide === n.last
                          ? n.limit
                          : v
                          ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                          : u
                          ? (n.last - n.currentSlide + n.cloneOffset) * c
                          : (n.currentSlide + n.cloneOffset) * c),
                      (r = d ? b : x),
                      (o = d ? x : b),
                      t.addEventListener('touchmove', h, !1),
                      t.addEventListener('touchend', S, !1));
                }),
                (h = function (e) {
                  (x = e.touches[0].pageX),
                    (b = e.touches[0].pageY),
                    (m = d ? r - b : r - x),
                    (y = d ? Math.abs(m) < Math.abs(x - o) : Math.abs(m) < Math.abs(b - o));
                  var t = 500;
                  (!y || Number(new Date()) - f > t) &&
                    (e.preventDefault(),
                    !p &&
                      n.transitions &&
                      (n.vars.animationLoop ||
                        (m /=
                          (0 === n.currentSlide && 0 > m) || (n.currentSlide === n.last && m > 0)
                            ? Math.abs(m) / c + 2
                            : 1),
                      n.setProps(l + m, 'setTouch')));
                }),
                (S = function (e) {
                  if (
                    (t.removeEventListener('touchmove', h, !1), n.animatingTo === n.currentSlide && !y && null !== m)
                  ) {
                    var a = u ? -m : m,
                      i = a > 0 ? n.getTarget('next') : n.getTarget('prev');
                    n.canAdvance(i) && ((Number(new Date()) - f < 550 && Math.abs(a) > 50) || Math.abs(a) > c / 2)
                      ? n.flexAnimate(i, n.vars.pauseOnAction)
                      : p || n.flexAnimate(n.currentSlide, n.vars.pauseOnAction, !0);
                  }
                  t.removeEventListener('touchend', S, !1), (r = null), (o = null), (m = null), (l = null);
                }),
                t.addEventListener('touchstart', g, !1));
          },
          resize: function () {
            !n.animating &&
              n.is(':visible') &&
              (v || n.doMath(),
              p
                ? f.smoothHeight()
                : v
                ? (n.slides.width(n.computedW), n.update(n.pagingCount), n.setProps())
                : d
                ? (n.viewport.height(n.h), n.setProps(n.h, 'setTotal'))
                : (n.vars.smoothHeight && f.smoothHeight(),
                  n.newSlides.width(n.computedW),
                  n.setProps(n.computedW, 'setTotal')));
          },
          smoothHeight: function (e) {
            if (!d || p) {
              var t = p ? n : n.viewport;
              e
                ? t.animate({ height: n.slides.eq(n.animatingTo).innerHeight() }, e)
                : t.innerHeight(n.slides.eq(n.animatingTo).innerHeight());
            }
          },
          sync: function (e) {
            var t = $(n.vars.sync).data('flexslider'),
              a = n.animatingTo;
            switch (e) {
              case 'animate':
                t.flexAnimate(a, n.vars.pauseOnAction, !1, !0);
                break;
              case 'play':
                t.playing || t.asNav || t.play();
                break;
              case 'pause':
                t.pause();
            }
          },
          uniqueID: function (e) {
            return (
              e
                .filter('[id]')
                .add(e.find('[id]'))
                .each(function () {
                  var e = $(this);
                  e.attr('id', e.attr('id') + '_clone');
                }),
              e
            );
          },
          pauseInvisible: {
            visProp: null,
            init: function () {
              var e = f.pauseInvisible.getHiddenProp();
              if (e) {
                var t = e.replace(/[H|h]idden/, '') + 'visibilitychange';
                document.addEventListener(t, function () {
                  f.pauseInvisible.isHidden()
                    ? n.startTimeout
                      ? clearTimeout(n.startTimeout)
                      : n.pause()
                    : n.started
                    ? n.play()
                    : n.vars.initDelay > 0
                    ? setTimeout(n.play, n.vars.initDelay)
                    : n.play();
                });
              }
            },
            isHidden: function () {
              var e = f.pauseInvisible.getHiddenProp();
              return e ? document[e] : !1;
            },
            getHiddenProp: function () {
              var e = ['webkit', 'moz', 'ms', 'o'];
              if ('hidden' in document) return 'hidden';
              for (var t = 0; t < e.length; t++) if (e[t] + 'Hidden' in document) return e[t] + 'Hidden';
              return null;
            },
          },
          setToClearWatchedEvent: function () {
            clearTimeout(c),
              (c = setTimeout(function () {
                l = '';
              }, 3e3));
          },
        }),
        (n.flexAnimate = function (e, t, a, s, o) {
          if (
            (n.vars.animationLoop || e === n.currentSlide || (n.direction = e > n.currentSlide ? 'next' : 'prev'),
            m && 1 === n.pagingCount && (n.direction = n.currentItem < e ? 'next' : 'prev'),
            !n.animating && (n.canAdvance(e, o) || a) && n.is(':visible'))
          ) {
            if (m && s) {
              var l = $(n.vars.asNavFor).data('flexslider');
              if (
                ((n.atEnd = 0 === e || e === n.count - 1),
                l.flexAnimate(e, !0, !1, !0, o),
                (n.direction = n.currentItem < e ? 'next' : 'prev'),
                (l.direction = n.direction),
                Math.ceil((e + 1) / n.visible) - 1 === n.currentSlide || 0 === e)
              )
                return (
                  (n.currentItem = e),
                  n.slides
                    .removeClass(i + 'active-slide')
                    .eq(e)
                    .addClass(i + 'active-slide'),
                  !1
                );
              (n.currentItem = e),
                n.slides
                  .removeClass(i + 'active-slide')
                  .eq(e)
                  .addClass(i + 'active-slide'),
                (e = Math.floor(e / n.visible));
            }
            if (
              ((n.animating = !0),
              (n.animatingTo = e),
              t && n.pause(),
              n.vars.before(n),
              n.syncExists && !o && f.sync('animate'),
              n.vars.controlNav && f.controlNav.active(),
              v ||
                n.slides
                  .removeClass(i + 'active-slide')
                  .eq(e)
                  .addClass(i + 'active-slide'),
              (n.atEnd = 0 === e || e === n.last),
              n.vars.directionNav && f.directionNav.update(),
              e === n.last && (n.vars.end(n), n.vars.animationLoop || n.pause()),
              p)
            )
              r
                ? (n.slides.eq(n.currentSlide).css({ opacity: 0, zIndex: 1 }),
                  n.slides.eq(e).css({ opacity: 1, zIndex: 2 }),
                  n.wrapup(c))
                : (n.slides
                    .eq(n.currentSlide)
                    .css({ zIndex: 1 })
                    .animate({ opacity: 0 }, n.vars.animationSpeed, n.vars.easing),
                  n.slides
                    .eq(e)
                    .css({ zIndex: 2 })
                    .animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing, n.wrapup));
            else {
              var c = d ? n.slides.filter(':first').height() : n.computedW,
                g,
                h,
                S;
              v
                ? ((g = n.vars.itemMargin),
                  (S = (n.itemW + g) * n.move * n.animatingTo),
                  (h = S > n.limit && 1 !== n.visible ? n.limit : S))
                : (h =
                    0 === n.currentSlide && e === n.count - 1 && n.vars.animationLoop && 'next' !== n.direction
                      ? u
                        ? (n.count + n.cloneOffset) * c
                        : 0
                      : n.currentSlide === n.last && 0 === e && n.vars.animationLoop && 'prev' !== n.direction
                      ? u
                        ? 0
                        : (n.count + 1) * c
                      : u
                      ? (n.count - 1 - e + n.cloneOffset) * c
                      : (e + n.cloneOffset) * c),
                n.setProps(h, '', n.vars.animationSpeed),
                n.transitions
                  ? ((n.vars.animationLoop && n.atEnd) || ((n.animating = !1), (n.currentSlide = n.animatingTo)),
                    n.container.unbind('webkitTransitionEnd transitionend'),
                    n.container.bind('webkitTransitionEnd transitionend', function () {
                      clearTimeout(n.ensureAnimationEnd), n.wrapup(c);
                    }),
                    clearTimeout(n.ensureAnimationEnd),
                    (n.ensureAnimationEnd = setTimeout(function () {
                      n.wrapup(c);
                    }, n.vars.animationSpeed + 100)))
                  : n.container.animate(n.args, n.vars.animationSpeed, n.vars.easing, function () {
                      n.wrapup(c);
                    });
            }
            n.vars.smoothHeight && f.smoothHeight(n.vars.animationSpeed);
          }
        }),
        (n.wrapup = function (e) {
          p ||
            v ||
            (0 === n.currentSlide && n.animatingTo === n.last && n.vars.animationLoop
              ? n.setProps(e, 'jumpEnd')
              : n.currentSlide === n.last && 0 === n.animatingTo && n.vars.animationLoop && n.setProps(e, 'jumpStart')),
            (n.animating = !1),
            (n.currentSlide = n.animatingTo),
            n.vars.after(n);
        }),
        (n.animateSlides = function () {
          !n.animating && e && n.flexAnimate(n.getTarget('next'));
        }),
        (n.pause = function () {
          clearInterval(n.animatedSlides),
            (n.animatedSlides = null),
            (n.playing = !1),
            n.vars.pausePlay && f.pausePlay.update('play'),
            n.syncExists && f.sync('pause');
        }),
        (n.play = function () {
          n.playing && clearInterval(n.animatedSlides),
            (n.animatedSlides = n.animatedSlides || setInterval(n.animateSlides, n.vars.slideshowSpeed)),
            (n.started = n.playing = !0),
            n.vars.pausePlay && f.pausePlay.update('pause'),
            n.syncExists && f.sync('play');
        }),
        (n.stop = function () {
          n.pause(), (n.stopped = !0);
        }),
        (n.canAdvance = function (e, t) {
          var a = m ? n.pagingCount - 1 : n.last;
          return t
            ? !0
            : m && n.currentItem === n.count - 1 && 0 === e && 'prev' === n.direction
            ? !0
            : m && 0 === n.currentItem && e === n.pagingCount - 1 && 'next' !== n.direction
            ? !1
            : e !== n.currentSlide || m
            ? n.vars.animationLoop
              ? !0
              : n.atEnd && 0 === n.currentSlide && e === a && 'next' !== n.direction
              ? !1
              : !n.atEnd || n.currentSlide !== a || 0 !== e || 'next' !== n.direction
            : !1;
        }),
        (n.getTarget = function (e) {
          return (
            (n.direction = e),
            'next' === e
              ? n.currentSlide === n.last
                ? 0
                : n.currentSlide + 1
              : 0 === n.currentSlide
              ? n.last
              : n.currentSlide - 1
          );
        }),
        (n.setProps = function (e, t, a) {
          var i = (function () {
            var a = e ? e : (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo,
              i = (function () {
                if (v)
                  return 'setTouch' === t
                    ? e
                    : u && n.animatingTo === n.last
                    ? 0
                    : u
                    ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                    : n.animatingTo === n.last
                    ? n.limit
                    : a;
                switch (t) {
                  case 'setTotal':
                    return u
                      ? (n.count - 1 - n.currentSlide + n.cloneOffset) * e
                      : (n.currentSlide + n.cloneOffset) * e;
                  case 'setTouch':
                    return u ? e : e;
                  case 'jumpEnd':
                    return u ? e : n.count * e;
                  case 'jumpStart':
                    return u ? n.count * e : e;
                  default:
                    return e;
                }
              })();
            return -1 * i + 'px';
          })();
          n.transitions &&
            ((i = d ? 'translate3d(0,' + i + ',0)' : 'translate3d(' + i + ',0,0)'),
            (a = void 0 !== a ? a / 1e3 + 's' : '0s'),
            n.container.css('-' + n.pfx + '-transition-duration', a),
            n.container.css('transition-duration', a)),
            (n.args[n.prop] = i),
            (n.transitions || void 0 === a) && n.container.css(n.args),
            n.container.css('transform', i);
        }),
        (n.setup = function (e) {
          if (p)
            n.slides.css({
              width: '100%',
              float: 'left',
              marginRight: '-100%',
              position: 'relative',
            }),
              'init' === e &&
                (r
                  ? n.slides
                      .css({
                        opacity: 0,
                        display: 'block',
                        webkitTransition: 'opacity ' + n.vars.animationSpeed / 1e3 + 's ease',
                        zIndex: 1,
                      })
                      .eq(n.currentSlide)
                      .css({ opacity: 1, zIndex: 2 })
                  : 0 == n.vars.fadeFirstSlide
                  ? n.slides
                      .css({ opacity: 0, display: 'block', zIndex: 1 })
                      .eq(n.currentSlide)
                      .css({ zIndex: 2 })
                      .css({ opacity: 1 })
                  : n.slides
                      .css({ opacity: 0, display: 'block', zIndex: 1 })
                      .eq(n.currentSlide)
                      .css({ zIndex: 2 })
                      .animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing)),
              n.vars.smoothHeight && f.smoothHeight();
          else {
            var t, a;
            'init' === e &&
              ((n.viewport = $('<div class="' + i + 'viewport"></div>')
                .css({ overflow: 'hidden', position: 'relative' })
                .appendTo(n)
                .append(n.container)),
              (n.cloneCount = 0),
              (n.cloneOffset = 0),
              u && ((a = $.makeArray(n.slides).reverse()), (n.slides = $(a)), n.container.empty().append(n.slides))),
              n.vars.animationLoop &&
                !v &&
                ((n.cloneCount = 2),
                (n.cloneOffset = 1),
                'init' !== e && n.container.find('.clone').remove(),
                n.container
                  .append(f.uniqueID(n.slides.first().clone().addClass('clone')).attr('aria-hidden', 'true'))
                  .prepend(f.uniqueID(n.slides.last().clone().addClass('clone')).attr('aria-hidden', 'true'))),
              (n.newSlides = $(n.vars.selector, n)),
              (t = u ? n.count - 1 - n.currentSlide + n.cloneOffset : n.currentSlide + n.cloneOffset),
              d && !v
                ? (n.container
                    .height(200 * (n.count + n.cloneCount) + '%')
                    .css('position', 'absolute')
                    .width('100%'),
                  setTimeout(
                    function () {
                      n.newSlides.css({ display: 'block' }),
                        n.doMath(),
                        n.viewport.height(n.h),
                        n.setProps(t * n.h, 'init');
                    },
                    'init' === e ? 100 : 0
                  ))
                : (n.container.width(200 * (n.count + n.cloneCount) + '%'),
                  n.setProps(t * n.computedW, 'init'),
                  setTimeout(
                    function () {
                      n.doMath(),
                        n.newSlides.css({
                          width: n.computedW,
                          marginRight: n.computedM,
                          float: 'left',
                          display: 'block',
                        }),
                        n.vars.smoothHeight && f.smoothHeight();
                    },
                    'init' === e ? 100 : 0
                  ));
          }
          v ||
            n.slides
              .removeClass(i + 'active-slide')
              .eq(n.currentSlide)
              .addClass(i + 'active-slide'),
            n.vars.init(n);
        }),
        (n.doMath = function () {
          var e = n.slides.first(),
            t = n.vars.itemMargin,
            a = n.vars.minItems,
            i = n.vars.maxItems;
          (n.w = void 0 === n.viewport ? n.width() : n.viewport.width()),
            (n.h = e.height()),
            (n.boxPadding = e.outerWidth() - e.width()),
            v
              ? ((n.itemT = n.vars.itemWidth + t),
                (n.itemM = t),
                (n.minW = a ? a * n.itemT : n.w),
                (n.maxW = i ? i * n.itemT - t : n.w),
                (n.itemW =
                  n.minW > n.w
                    ? (n.w - t * (a - 1)) / a
                    : n.maxW < n.w
                    ? (n.w - t * (i - 1)) / i
                    : n.vars.itemWidth > n.w
                    ? n.w
                    : n.vars.itemWidth),
                (n.visible = Math.floor(n.w / n.itemW)),
                (n.move = n.vars.move > 0 && n.vars.move < n.visible ? n.vars.move : n.visible),
                (n.pagingCount = Math.ceil((n.count - n.visible) / n.move + 1)),
                (n.last = n.pagingCount - 1),
                (n.limit =
                  1 === n.pagingCount
                    ? 0
                    : n.vars.itemWidth > n.w
                    ? n.itemW * (n.count - 1) + t * (n.count - 1)
                    : (n.itemW + t) * n.count - n.w - t))
              : ((n.itemW = n.w), (n.itemM = t), (n.pagingCount = n.count), (n.last = n.count - 1)),
            (n.computedW = n.itemW - n.boxPadding),
            (n.computedM = n.itemM);
        }),
        (n.update = function (e, t) {
          n.doMath(),
            v ||
              (e < n.currentSlide ? (n.currentSlide += 1) : e <= n.currentSlide && 0 !== e && (n.currentSlide -= 1),
              (n.animatingTo = n.currentSlide)),
            n.vars.controlNav &&
              !n.manualControls &&
              (('add' === t && !v) || n.pagingCount > n.controlNav.length
                ? f.controlNav.update('add')
                : (('remove' === t && !v) || n.pagingCount < n.controlNav.length) &&
                  (v && n.currentSlide > n.last && ((n.currentSlide -= 1), (n.animatingTo -= 1)),
                  f.controlNav.update('remove', n.last))),
            n.vars.directionNav && f.directionNav.update();
        }),
        (n.addSlide = function (e, t) {
          var a = $(e);
          (n.count += 1),
            (n.last = n.count - 1),
            d && u
              ? void 0 !== t
                ? n.slides.eq(n.count - t).after(a)
                : n.container.prepend(a)
              : void 0 !== t
              ? n.slides.eq(t).before(a)
              : n.container.append(a),
            n.update(t, 'add'),
            (n.slides = $(n.vars.selector + ':not(.clone)', n)),
            n.setup(),
            n.vars.added(n);
        }),
        (n.removeSlide = function (e) {
          var t = isNaN(e) ? n.slides.index($(e)) : e;
          (n.count -= 1),
            (n.last = n.count - 1),
            isNaN(e) ? $(e, n.slides).remove() : d && u ? n.slides.eq(n.last).remove() : n.slides.eq(e).remove(),
            n.doMath(),
            n.update(t, 'remove'),
            (n.slides = $(n.vars.selector + ':not(.clone)', n)),
            n.setup(),
            n.vars.removed(n);
        }),
        f.init();
    }),
      $(window)
        .blur(function (t) {
          e = !1;
        })
        .focus(function (t) {
          e = !0;
        }),
      ($.flexslider.defaults = {
        namespace: 'flex-',
        selector: '.slides > li',
        animation: 'fade',
        easing: 'swing',
        direction: 'horizontal',
        reverse: !1,
        animationLoop: !0,
        smoothHeight: !1,
        startAt: 0,
        slideshow: !0,
        slideshowSpeed: 7e3,
        animationSpeed: 600,
        initDelay: 0,
        randomize: !1,
        fadeFirstSlide: !0,
        thumbCaptions: !1,
        pauseOnAction: !0,
        pauseOnHover: !1,
        pauseInvisible: !0,
        useCSS: !0,
        touch: !0,
        video: !1,
        controlNav: !0,
        directionNav: !0,
        prevText: 'Previous',
        nextText: 'Next',
        keyboard: !0,
        multipleKeyboard: !1,
        mousewheel: !1,
        pausePlay: !1,
        pauseText: 'Pause',
        playText: 'Play',
        controlsContainer: '',
        manualControls: '',
        customDirectionNav: '',
        sync: '',
        asNavFor: '',
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: !0,
        start: function () {},
        before: function () {},
        after: function () {},
        end: function () {},
        added: function () {},
        removed: function () {},
        init: function () {},
      }),
      ($.fn.flexslider = function (e) {
        if ((void 0 === e && (e = {}), 'object' == typeof e))
          return this.each(function () {
            var t = $(this),
              a = e.selector ? e.selector : '.slides > li',
              n = t.find(a);
            (1 === n.length && e.allowOneSlide === !1) || 0 === n.length
              ? (n.fadeIn(400), e.start && e.start(t))
              : void 0 === t.data('flexslider') && new $.flexslider(this, e);
          });
        var t = $(this).data('flexslider');
        switch (e) {
          case 'play':
            t.play();
            break;
          case 'pause':
            t.pause();
            break;
          case 'stop':
            t.stop();
            break;
          case 'next':
            t.flexAnimate(t.getTarget('next'), !0);
            break;
          case 'prev':
          case 'previous':
            t.flexAnimate(t.getTarget('prev'), !0);
            break;
          default:
            'number' == typeof e && t.flexAnimate(e, !0);
        }
      });
  })(jQuery);

  /*!
 Zoom 1.7.20
 license: MIT
 http://www.jacklmoore.com/zoom
 */
  (function (o) {
    var t = {
      url: !1,
      callback: !1,
      target: !1,
      duration: 120,
      on: 'mouseover',
      touch: !0,
      onZoomIn: !1,
      onZoomOut: !1,
      magnify: 1,
    };
    (o.zoom = function (t, n, e, i) {
      var u,
        c,
        r,
        a,
        m,
        l,
        s,
        f = o(t),
        h = f.css('position'),
        d = o(n);
      return (
        (t.style.position = /(absolute|fixed)/.test(h) ? h : 'relative'),
        (t.style.overflow = 'hidden'),
        (e.style.width = e.style.height = ''),
        o(e)
          .addClass('zoomImg')
          .css({
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 0,
            width: e.width * i,
            height: e.height * i,
            border: 'none',
            maxWidth: 'none',
            maxHeight: 'none',
          })
          .appendTo(t),
        {
          init: function () {
            (c = f.outerWidth()),
              (u = f.outerHeight()),
              n === t ? ((a = c), (r = u)) : ((a = d.outerWidth()), (r = d.outerHeight())),
              (m = (e.width - c) / a),
              (l = (e.height - u) / r),
              (s = d.offset());
          },
          move: function (o) {
            var t = o.pageX - s.left,
              n = o.pageY - s.top;
            (n = Math.max(Math.min(n, r), 0)),
              (t = Math.max(Math.min(t, a), 0)),
              (e.style.left = t * -m + 'px'),
              (e.style.top = n * -l + 'px');
          },
        }
      );
    }),
      (o.fn.zoom = function (n) {
        return this.each(function () {
          var e = o.extend({}, t, n || {}),
            i = (e.target && o(e.target)[0]) || this,
            u = this,
            c = o(u),
            r = document.createElement('img'),
            a = o(r),
            m = 'mousemove.zoom',
            l = !1,
            s = !1;
          if (!e.url) {
            var f = u.querySelector('img');
            if ((f && (e.url = f.getAttribute('data-src') || f.currentSrc || f.src), !e.url)) return;
          }
          c.one(
            'zoom.destroy',
            function (o, t) {
              c.off('.zoom'), (i.style.position = o), (i.style.overflow = t), (r.onload = null), a.remove();
            }.bind(this, i.style.position, i.style.overflow)
          ),
            (r.onload = function () {
              function t(t) {
                f.init(),
                  f.move(t),
                  a
                    .stop()
                    .fadeTo(o.support.opacity ? e.duration : 0, 1, o.isFunction(e.onZoomIn) ? e.onZoomIn.call(r) : !1);
              }
              function n() {
                a.stop().fadeTo(e.duration, 0, o.isFunction(e.onZoomOut) ? e.onZoomOut.call(r) : !1);
              }
              var f = o.zoom(i, u, r, e.magnify);
              'grab' === e.on
                ? c.on('mousedown.zoom', function (e) {
                    1 === e.which &&
                      (o(document).one('mouseup.zoom', function () {
                        n(), o(document).off(m, f.move);
                      }),
                      t(e),
                      o(document).on(m, f.move),
                      e.preventDefault());
                  })
                : 'click' === e.on
                ? c.on('click.zoom', function (e) {
                    return l
                      ? void 0
                      : ((l = !0),
                        t(e),
                        o(document).on(m, f.move),
                        o(document).one('click.zoom', function () {
                          n(), (l = !1), o(document).off(m, f.move);
                        }),
                        !1);
                  })
                : 'toggle' === e.on
                ? c.on('click.zoom', function (o) {
                    l ? n() : t(o), (l = !l);
                  })
                : 'mouseover' === e.on && (f.init(), c.on('mouseenter.zoom', t).on('mouseleave.zoom', n).on(m, f.move)),
                e.touch &&
                  c
                    .on('touchstart.zoom', function (o) {
                      o.preventDefault(),
                        s
                          ? ((s = !1), n())
                          : ((s = !0), t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]));
                    })
                    .on('touchmove.zoom', function (o) {
                      o.preventDefault(), f.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]);
                    })
                    .on('touchend.zoom', function (o) {
                      o.preventDefault(), s && ((s = !1), n());
                    }),
                o.isFunction(e.callback) && e.callback.call(r);
            }),
            r.setAttribute('role', 'presentation'),
            (r.src = e.url);
        });
      }),
      (o.fn.zoom.defaults = t);
  })(window.jQuery);

  /*!
   * hoverIntent v1.10.1 // 2019.10.05 // jQuery v1.7.0+
   * http://briancherne.github.io/jquery-hoverIntent/
   *
   * You may use hoverIntent under the terms of the MIT license. Basically that
   * means you are free to use hoverIntent as long as this header is left intact.
   * Copyright 2007-2019 Brian Cherne
   */
  !(function (factory) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['jquery'], factory)
      : 'object' == typeof module && module.exports
      ? (module.exports = factory(require('jquery')))
      : jQuery && !jQuery.fn.hoverIntent && factory(jQuery);
  })(function ($) {
    'use strict';
    function track(ev) {
      (cX = ev.pageX), (cY = ev.pageY);
    }
    var cX,
      cY,
      _cfg = { interval: 100, sensitivity: 6, timeout: 0 },
      INSTANCE_COUNT = 0,
      compare = function (ev, $el, s, cfg) {
        if (Math.sqrt((s.pX - cX) * (s.pX - cX) + (s.pY - cY) * (s.pY - cY)) < cfg.sensitivity)
          return (
            $el.off(s.event, track),
            delete s.timeoutId,
            (s.isActive = !0),
            (ev.pageX = cX),
            (ev.pageY = cY),
            delete s.pX,
            delete s.pY,
            cfg.over.apply($el[0], [ev])
          );
        (s.pX = cX),
          (s.pY = cY),
          (s.timeoutId = setTimeout(function () {
            compare(ev, $el, s, cfg);
          }, cfg.interval));
      };
    $.fn.hoverIntent = function (handlerIn, handlerOut, selector) {
      var instanceId = INSTANCE_COUNT++,
        cfg = $.extend({}, _cfg);
      $.isPlainObject(handlerIn)
        ? ((cfg = $.extend(cfg, handlerIn)), $.isFunction(cfg.out) || (cfg.out = cfg.over))
        : (cfg = $.isFunction(handlerOut)
            ? $.extend(cfg, {
                over: handlerIn,
                out: handlerOut,
                selector: selector,
              })
            : $.extend(cfg, {
                over: handlerIn,
                out: handlerIn,
                selector: handlerOut,
              }));
      function handleHover(e) {
        var ev = $.extend({}, e),
          $el = $(this),
          hoverIntentData = $el.data('hoverIntent');
        hoverIntentData || $el.data('hoverIntent', (hoverIntentData = {}));
        var state = hoverIntentData[instanceId];
        state || (hoverIntentData[instanceId] = state = { id: instanceId }),
          state.timeoutId && (state.timeoutId = clearTimeout(state.timeoutId));
        var mousemove = (state.event = 'mousemove.hoverIntent.hoverIntent' + instanceId);
        if ('mouseenter' === e.type) {
          if (state.isActive) return;
          (state.pX = ev.pageX),
            (state.pY = ev.pageY),
            $el.off(mousemove, track).on(mousemove, track),
            (state.timeoutId = setTimeout(function () {
              compare(ev, $el, state, cfg);
            }, cfg.interval));
        } else {
          if (!state.isActive) return;
          $el.off(mousemove, track),
            (state.timeoutId = setTimeout(function () {
              !(function (ev, $el, s, out) {
                var data = $el.data('hoverIntent');
                data && delete data[s.id], out.apply($el[0], [ev]);
              })(ev, $el, state, cfg.out);
            }, cfg.timeout));
        }
      }
      return this.on(
        {
          'mouseenter.hoverIntent': handleHover,
          'mouseleave.hoverIntent': handleHover,
        },
        cfg.selector
      );
    };
  });

  /**
   * Owl Carousel v2.3.4
   * Copyright 2013-2018 David Deutsch
   * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
   */
  !(function (a, b, c, d) {
    function e(b, c) {
      (this.settings = null),
        (this.options = a.extend({}, e.Defaults, c)),
        (this.$element = a(b)),
        (this._handlers = {}),
        (this._plugins = {}),
        (this._supress = {}),
        (this._current = null),
        (this._speed = null),
        (this._coordinates = []),
        (this._breakpoint = null),
        (this._width = null),
        (this._items = []),
        (this._clones = []),
        (this._mergers = []),
        (this._widths = []),
        (this._invalidated = {}),
        (this._pipe = []),
        (this._drag = {
          time: null,
          target: null,
          pointer: null,
          stage: { start: null, current: null },
          direction: null,
        }),
        (this._states = {
          current: {},
          tags: {
            initializing: ['busy'],
            animating: ['busy'],
            dragging: ['interacting'],
          },
        }),
        a.each(
          ['onResize', 'onThrottledResize'],
          a.proxy(function (b, c) {
            this._handlers[c] = a.proxy(this[c], this);
          }, this)
        ),
        a.each(
          e.Plugins,
          a.proxy(function (a, b) {
            this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
          }, this)
        ),
        a.each(
          e.Workers,
          a.proxy(function (b, c) {
            this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
          }, this)
        ),
        this.setup(),
        this.initialize();
    }
    (e.Defaults = {
      items: 3,
      loop: !1,
      center: !1,
      rewind: !1,
      checkVisibility: !0,
      mouseDrag: !0,
      touchDrag: !0,
      pullDrag: !0,
      freeDrag: !1,
      margin: 0,
      stagePadding: 0,
      merge: !1,
      mergeFit: !0,
      autoWidth: !1,
      startPosition: 0,
      rtl: !1,
      smartSpeed: 250,
      fluidSpeed: !1,
      dragEndSpeed: !1,
      responsive: {},
      responsiveRefreshRate: 200,
      responsiveBaseElement: b,
      fallbackEasing: 'swing',
      slideTransition: '',
      info: !1,
      nestedItemSelector: !1,
      itemElement: 'div',
      stageElement: 'div',
      refreshClass: 'owl-refresh',
      loadedClass: 'owl-loaded',
      loadingClass: 'owl-loading',
      rtlClass: 'owl-rtl',
      responsiveClass: 'owl-responsive',
      dragClass: 'owl-drag',
      itemClass: 'owl-item',
      stageClass: 'owl-stage',
      stageOuterClass: 'owl-stage-outer',
      grabClass: 'owl-grab',
    }),
      (e.Width = { Default: 'default', Inner: 'inner', Outer: 'outer' }),
      (e.Type = { Event: 'event', State: 'state' }),
      (e.Plugins = {}),
      (e.Workers = [
        {
          filter: ['width', 'settings'],
          run: function () {
            this._width = this.$element.width();
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (a) {
            a.current = this._items && this._items[this.relative(this._current)];
          },
        },
        {
          filter: ['items', 'settings'],
          run: function () {
            this.$stage.children('.cloned').remove();
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (a) {
            var b = this.settings.margin || '',
              c = !this.settings.autoWidth,
              d = this.settings.rtl,
              e = {
                width: 'auto',
                'margin-left': d ? b : '',
                'margin-right': d ? '' : b,
              };
            !c && this.$stage.children().css(e), (a.css = e);
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (a) {
            var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
              c = null,
              d = this._items.length,
              e = !this.settings.autoWidth,
              f = [];
            for (a.items = { merge: !1, width: b }; d--; )
              (c = this._mergers[d]),
                (c = (this.settings.mergeFit && Math.min(c, this.settings.items)) || c),
                (a.items.merge = c > 1 || a.items.merge),
                (f[d] = e ? b * c : this._items[d].width());
            this._widths = f;
          },
        },
        {
          filter: ['items', 'settings'],
          run: function () {
            var b = [],
              c = this._items,
              d = this.settings,
              e = Math.max(2 * d.items, 4),
              f = 2 * Math.ceil(c.length / 2),
              g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
              h = '',
              i = '';
            for (g /= 2; g > 0; )
              b.push(this.normalize(b.length / 2, !0)),
                (h += c[b[b.length - 1]][0].outerHTML),
                b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
                (i = c[b[b.length - 1]][0].outerHTML + i),
                (g -= 1);
            (this._clones = b),
              a(h).addClass('cloned').appendTo(this.$stage),
              a(i).addClass('cloned').prependTo(this.$stage);
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function () {
            for (
              var a = this.settings.rtl ? 1 : -1,
                b = this._clones.length + this._items.length,
                c = -1,
                d = 0,
                e = 0,
                f = [];
              ++c < b;

            )
              (d = f[c - 1] || 0), (e = this._widths[this.relative(c)] + this.settings.margin), f.push(d + e * a);
            this._coordinates = f;
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function () {
            var a = this.settings.stagePadding,
              b = this._coordinates,
              c = {
                width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
                'padding-left': a || '',
                'padding-right': a || '',
              };
            this.$stage.css(c);
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (a) {
            var b = this._coordinates.length,
              c = !this.settings.autoWidth,
              d = this.$stage.children();
            if (c && a.items.merge) for (; b--; ) (a.css.width = this._widths[this.relative(b)]), d.eq(b).css(a.css);
            else c && ((a.css.width = a.items.width), d.css(a.css));
          },
        },
        {
          filter: ['items'],
          run: function () {
            this._coordinates.length < 1 && this.$stage.removeAttr('style');
          },
        },
        {
          filter: ['width', 'items', 'settings'],
          run: function (a) {
            (a.current = a.current ? this.$stage.children().index(a.current) : 0),
              (a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current))),
              this.reset(a.current);
          },
        },
        {
          filter: ['position'],
          run: function () {
            this.animate(this.coordinates(this._current));
          },
        },
        {
          filter: ['width', 'position', 'items', 'settings'],
          run: function () {
            var a,
              b,
              c,
              d,
              e = this.settings.rtl ? 1 : -1,
              f = 2 * this.settings.stagePadding,
              g = this.coordinates(this.current()) + f,
              h = g + this.width() * e,
              i = [];
            for (c = 0, d = this._coordinates.length; c < d; c++)
              (a = this._coordinates[c - 1] || 0),
                (b = Math.abs(this._coordinates[c]) + f * e),
                ((this.op(a, '<=', g) && this.op(a, '>', h)) || (this.op(b, '<', g) && this.op(b, '>', h))) &&
                  i.push(c);
            this.$stage.children('.active').removeClass('active'),
              this.$stage.children(':eq(' + i.join('), :eq(') + ')').addClass('active'),
              this.$stage.children('.center').removeClass('center'),
              this.settings.center && this.$stage.children().eq(this.current()).addClass('center');
          },
        },
      ]),
      (e.prototype.initializeStage = function () {
        (this.$stage = this.$element.find('.' + this.settings.stageClass)),
          this.$stage.length ||
            (this.$element.addClass(this.options.loadingClass),
            (this.$stage = a('<' + this.settings.stageElement + '>', {
              class: this.settings.stageClass,
            }).wrap(a('<div/>', { class: this.settings.stageOuterClass }))),
            this.$element.append(this.$stage.parent()));
      }),
      (e.prototype.initializeItems = function () {
        var b = this.$element.find('.owl-item');
        if (b.length)
          return (
            (this._items = b.get().map(function (b) {
              return a(b);
            })),
            (this._mergers = this._items.map(function () {
              return 1;
            })),
            void this.refresh()
          );
        this.replace(this.$element.children().not(this.$stage.parent())),
          this.isVisible() ? this.refresh() : this.invalidate('width'),
          this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
      }),
      (e.prototype.initialize = function () {
        if (
          (this.enter('initializing'),
          this.trigger('initialize'),
          this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
          this.settings.autoWidth && !this.is('pre-loading'))
        ) {
          var a, b, c;
          (a = this.$element.find('img')),
            (b = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : d),
            (c = this.$element.children(b).width()),
            a.length && c <= 0 && this.preloadAutoWidthImages(a);
        }
        this.initializeStage(),
          this.initializeItems(),
          this.registerEventHandlers(),
          this.leave('initializing'),
          this.trigger('initialized');
      }),
      (e.prototype.isVisible = function () {
        return !this.settings.checkVisibility || this.$element.is(':visible');
      }),
      (e.prototype.setup = function () {
        var b = this.viewport(),
          c = this.options.responsive,
          d = -1,
          e = null;
        c
          ? (a.each(c, function (a) {
              a <= b && a > d && (d = Number(a));
            }),
            (e = a.extend({}, this.options, c[d])),
            'function' == typeof e.stagePadding && (e.stagePadding = e.stagePadding()),
            delete e.responsive,
            e.responsiveClass &&
              this.$element.attr(
                'class',
                this.$element
                  .attr('class')
                  .replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + d)
              ))
          : (e = a.extend({}, this.options)),
          this.trigger('change', { property: { name: 'settings', value: e } }),
          (this._breakpoint = d),
          (this.settings = e),
          this.invalidate('settings'),
          this.trigger('changed', {
            property: { name: 'settings', value: this.settings },
          });
      }),
      (e.prototype.optionsLogic = function () {
        this.settings.autoWidth && ((this.settings.stagePadding = !1), (this.settings.merge = !1));
      }),
      (e.prototype.prepare = function (b) {
        var c = this.trigger('prepare', { content: b });
        return (
          c.data ||
            (c.data = a('<' + this.settings.itemElement + '/>')
              .addClass(this.options.itemClass)
              .append(b)),
          this.trigger('prepared', { content: c.data }),
          c.data
        );
      }),
      (e.prototype.update = function () {
        for (
          var b = 0,
            c = this._pipe.length,
            d = a.proxy(function (a) {
              return this[a];
            }, this._invalidated),
            e = {};
          b < c;

        )
          (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
        (this._invalidated = {}), !this.is('valid') && this.enter('valid');
      }),
      (e.prototype.width = function (a) {
        switch ((a = a || e.Width.Default)) {
          case e.Width.Inner:
          case e.Width.Outer:
            return this._width;
          default:
            return this._width - 2 * this.settings.stagePadding + this.settings.margin;
        }
      }),
      (e.prototype.refresh = function () {
        this.enter('refreshing'),
          this.trigger('refresh'),
          this.setup(),
          this.optionsLogic(),
          this.$element.addClass(this.options.refreshClass),
          this.update(),
          this.$element.removeClass(this.options.refreshClass),
          this.leave('refreshing'),
          this.trigger('refreshed');
      }),
      (e.prototype.onThrottledResize = function () {
        b.clearTimeout(this.resizeTimer),
          (this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate));
      }),
      (e.prototype.onResize = function () {
        return (
          !!this._items.length &&
          this._width !== this.$element.width() &&
          !!this.isVisible() &&
          (this.enter('resizing'),
          this.trigger('resize').isDefaultPrevented()
            ? (this.leave('resizing'), !1)
            : (this.invalidate('width'), this.refresh(), this.leave('resizing'), void this.trigger('resized')))
        );
      }),
      (e.prototype.registerEventHandlers = function () {
        a.support.transition &&
          this.$stage.on(a.support.transition.end + '.owl.core', a.proxy(this.onTransitionEnd, this)),
          !1 !== this.settings.responsive && this.on(b, 'resize', this._handlers.onThrottledResize),
          this.settings.mouseDrag &&
            (this.$element.addClass(this.options.dragClass),
            this.$stage.on('mousedown.owl.core', a.proxy(this.onDragStart, this)),
            this.$stage.on('dragstart.owl.core selectstart.owl.core', function () {
              return !1;
            })),
          this.settings.touchDrag &&
            (this.$stage.on('touchstart.owl.core', a.proxy(this.onDragStart, this)),
            this.$stage.on('touchcancel.owl.core', a.proxy(this.onDragEnd, this)));
      }),
      (e.prototype.onDragStart = function (b) {
        var d = null;
        3 !== b.which &&
          (a.support.transform
            ? ((d = this.$stage
                .css('transform')
                .replace(/.*\(|\)| /g, '')
                .split(',')),
              (d = {
                x: d[16 === d.length ? 12 : 4],
                y: d[16 === d.length ? 13 : 5],
              }))
            : ((d = this.$stage.position()),
              (d = {
                x: this.settings.rtl ? d.left + this.$stage.width() - this.width() + this.settings.margin : d.left,
                y: d.top,
              })),
          this.is('animating') &&
            (a.support.transform ? this.animate(d.x) : this.$stage.stop(), this.invalidate('position')),
          this.$element.toggleClass(this.options.grabClass, 'mousedown' === b.type),
          this.speed(0),
          (this._drag.time = new Date().getTime()),
          (this._drag.target = a(b.target)),
          (this._drag.stage.start = d),
          (this._drag.stage.current = d),
          (this._drag.pointer = this.pointer(b)),
          a(c).on('mouseup.owl.core touchend.owl.core', a.proxy(this.onDragEnd, this)),
          a(c).one(
            'mousemove.owl.core touchmove.owl.core',
            a.proxy(function (b) {
              var d = this.difference(this._drag.pointer, this.pointer(b));
              a(c).on('mousemove.owl.core touchmove.owl.core', a.proxy(this.onDragMove, this)),
                (Math.abs(d.x) < Math.abs(d.y) && this.is('valid')) ||
                  (b.preventDefault(), this.enter('dragging'), this.trigger('drag'));
            }, this)
          ));
      }),
      (e.prototype.onDragMove = function (a) {
        var b = null,
          c = null,
          d = null,
          e = this.difference(this._drag.pointer, this.pointer(a)),
          f = this.difference(this._drag.stage.start, e);
        this.is('dragging') &&
          (a.preventDefault(),
          this.settings.loop
            ? ((b = this.coordinates(this.minimum())),
              (c = this.coordinates(this.maximum() + 1) - b),
              (f.x = ((((f.x - b) % c) + c) % c) + b))
            : ((b = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum())),
              (c = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum())),
              (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
              (f.x = Math.max(Math.min(f.x, b + d), c + d))),
          (this._drag.stage.current = f),
          this.animate(f.x));
      }),
      (e.prototype.onDragEnd = function (b) {
        var d = this.difference(this._drag.pointer, this.pointer(b)),
          e = this._drag.stage.current,
          f = (d.x > 0) ^ this.settings.rtl ? 'left' : 'right';
        a(c).off('.owl.core'),
          this.$element.removeClass(this.options.grabClass),
          ((0 !== d.x && this.is('dragging')) || !this.is('valid')) &&
            (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
            this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
            this.invalidate('position'),
            this.update(),
            (this._drag.direction = f),
            (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
              this._drag.target.one('click.owl.core', function () {
                return !1;
              })),
          this.is('dragging') && (this.leave('dragging'), this.trigger('dragged'));
      }),
      (e.prototype.closest = function (b, c) {
        var e = -1,
          f = 30,
          g = this.width(),
          h = this.coordinates();
        return (
          this.settings.freeDrag ||
            a.each(
              h,
              a.proxy(function (a, i) {
                return (
                  'left' === c && b > i - f && b < i + f
                    ? (e = a)
                    : 'right' === c && b > i - g - f && b < i - g + f
                    ? (e = a + 1)
                    : this.op(b, '<', i) &&
                      this.op(b, '>', h[a + 1] !== d ? h[a + 1] : i - g) &&
                      (e = 'left' === c ? a + 1 : a),
                  -1 === e
                );
              }, this)
            ),
          this.settings.loop ||
            (this.op(b, '>', h[this.minimum()])
              ? (e = b = this.minimum())
              : this.op(b, '<', h[this.maximum()]) && (e = b = this.maximum())),
          e
        );
      }),
      (e.prototype.animate = function (b) {
        var c = this.speed() > 0;
        this.is('animating') && this.onTransitionEnd(),
          c && (this.enter('animating'), this.trigger('translate')),
          a.support.transform3d && a.support.transition
            ? this.$stage.css({
                transform: 'translate3d(' + b + 'px,0px,0px)',
                transition:
                  this.speed() / 1e3 + 's' + (this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''),
              })
            : c
            ? this.$stage.animate(
                { left: b + 'px' },
                this.speed(),
                this.settings.fallbackEasing,
                a.proxy(this.onTransitionEnd, this)
              )
            : this.$stage.css({ left: b + 'px' });
      }),
      (e.prototype.is = function (a) {
        return this._states.current[a] && this._states.current[a] > 0;
      }),
      (e.prototype.current = function (a) {
        if (a === d) return this._current;
        if (0 === this._items.length) return d;
        if (((a = this.normalize(a)), this._current !== a)) {
          var b = this.trigger('change', {
            property: { name: 'position', value: a },
          });
          b.data !== d && (a = this.normalize(b.data)),
            (this._current = a),
            this.invalidate('position'),
            this.trigger('changed', {
              property: { name: 'position', value: this._current },
            });
        }
        return this._current;
      }),
      (e.prototype.invalidate = function (b) {
        return (
          'string' === a.type(b) && ((this._invalidated[b] = !0), this.is('valid') && this.leave('valid')),
          a.map(this._invalidated, function (a, b) {
            return b;
          })
        );
      }),
      (e.prototype.reset = function (a) {
        (a = this.normalize(a)) !== d &&
          ((this._speed = 0),
          (this._current = a),
          this.suppress(['translate', 'translated']),
          this.animate(this.coordinates(a)),
          this.release(['translate', 'translated']));
      }),
      (e.prototype.normalize = function (a, b) {
        var c = this._items.length,
          e = b ? 0 : this._clones.length;
        return (
          !this.isNumeric(a) || c < 1 ? (a = d) : (a < 0 || a >= c + e) && (a = ((((a - e / 2) % c) + c) % c) + e / 2),
          a
        );
      }),
      (e.prototype.relative = function (a) {
        return (a -= this._clones.length / 2), this.normalize(a, !0);
      }),
      (e.prototype.maximum = function (a) {
        var b,
          c,
          d,
          e = this.settings,
          f = this._coordinates.length;
        if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
        else if (e.autoWidth || e.merge) {
          if ((b = this._items.length))
            for (
              c = this._items[--b].width(), d = this.$element.width();
              b-- && !((c += this._items[b].width() + this.settings.margin) > d);

            );
          f = b + 1;
        } else f = e.center ? this._items.length - 1 : this._items.length - e.items;
        return a && (f -= this._clones.length / 2), Math.max(f, 0);
      }),
      (e.prototype.minimum = function (a) {
        return a ? 0 : this._clones.length / 2;
      }),
      (e.prototype.items = function (a) {
        return a === d ? this._items.slice() : ((a = this.normalize(a, !0)), this._items[a]);
      }),
      (e.prototype.mergers = function (a) {
        return a === d ? this._mergers.slice() : ((a = this.normalize(a, !0)), this._mergers[a]);
      }),
      (e.prototype.clones = function (b) {
        var c = this._clones.length / 2,
          e = c + this._items.length,
          f = function (a) {
            return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2;
          };
        return b === d
          ? a.map(this._clones, function (a, b) {
              return f(b);
            })
          : a.map(this._clones, function (a, c) {
              return a === b ? f(c) : null;
            });
      }),
      (e.prototype.speed = function (a) {
        return a !== d && (this._speed = a), this._speed;
      }),
      (e.prototype.coordinates = function (b) {
        var c,
          e = 1,
          f = b - 1;
        return b === d
          ? a.map(
              this._coordinates,
              a.proxy(function (a, b) {
                return this.coordinates(b);
              }, this)
            )
          : (this.settings.center
              ? (this.settings.rtl && ((e = -1), (f = b + 1)),
                (c = this._coordinates[b]),
                (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
              : (c = this._coordinates[f] || 0),
            (c = Math.ceil(c)));
      }),
      (e.prototype.duration = function (a, b, c) {
        return 0 === c ? 0 : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed);
      }),
      (e.prototype.to = function (a, b) {
        var c = this.current(),
          d = null,
          e = a - this.relative(c),
          f = (e > 0) - (e < 0),
          g = this._items.length,
          h = this.minimum(),
          i = this.maximum();
        this.settings.loop
          ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g),
            (a = c + e),
            (d = ((((a - h) % g) + g) % g) + h) !== a &&
              d - e <= i &&
              d - e > 0 &&
              ((c = d - e), (a = d), this.reset(c)))
          : this.settings.rewind
          ? ((i += 1), (a = ((a % i) + i) % i))
          : (a = Math.max(h, Math.min(i, a))),
          this.speed(this.duration(c, a, b)),
          this.current(a),
          this.isVisible() && this.update();
      }),
      (e.prototype.next = function (a) {
        (a = a || !1), this.to(this.relative(this.current()) + 1, a);
      }),
      (e.prototype.prev = function (a) {
        (a = a || !1), this.to(this.relative(this.current()) - 1, a);
      }),
      (e.prototype.onTransitionEnd = function (a) {
        if (a !== d && (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0)))
          return !1;
        this.leave('animating'), this.trigger('translated');
      }),
      (e.prototype.viewport = function () {
        var d;
        return (
          this.options.responsiveBaseElement !== b
            ? (d = a(this.options.responsiveBaseElement).width())
            : b.innerWidth
            ? (d = b.innerWidth)
            : c.documentElement && c.documentElement.clientWidth
            ? (d = c.documentElement.clientWidth)
            : console.warn('Can not detect viewport width.'),
          d
        );
      }),
      (e.prototype.replace = function (b) {
        this.$stage.empty(),
          (this._items = []),
          b && (b = b instanceof jQuery ? b : a(b)),
          this.settings.nestedItemSelector && (b = b.find('.' + this.settings.nestedItemSelector)),
          b
            .filter(function () {
              return 1 === this.nodeType;
            })
            .each(
              a.proxy(function (a, b) {
                (b = this.prepare(b)),
                  this.$stage.append(b),
                  this._items.push(b),
                  this._mergers.push(1 * b.find('[data-merge]').addBack('[data-merge]').attr('data-merge') || 1);
              }, this)
            ),
          this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
          this.invalidate('items');
      }),
      (e.prototype.add = function (b, c) {
        var e = this.relative(this._current);
        (c = c === d ? this._items.length : this.normalize(c, !0)),
          (b = b instanceof jQuery ? b : a(b)),
          this.trigger('add', { content: b, position: c }),
          (b = this.prepare(b)),
          0 === this._items.length || c === this._items.length
            ? (0 === this._items.length && this.$stage.append(b),
              0 !== this._items.length && this._items[c - 1].after(b),
              this._items.push(b),
              this._mergers.push(1 * b.find('[data-merge]').addBack('[data-merge]').attr('data-merge') || 1))
            : (this._items[c].before(b),
              this._items.splice(c, 0, b),
              this._mergers.splice(c, 0, 1 * b.find('[data-merge]').addBack('[data-merge]').attr('data-merge') || 1)),
          this._items[e] && this.reset(this._items[e].index()),
          this.invalidate('items'),
          this.trigger('added', { content: b, position: c });
      }),
      (e.prototype.remove = function (a) {
        (a = this.normalize(a, !0)) !== d &&
          (this.trigger('remove', { content: this._items[a], position: a }),
          this._items[a].remove(),
          this._items.splice(a, 1),
          this._mergers.splice(a, 1),
          this.invalidate('items'),
          this.trigger('removed', { content: null, position: a }));
      }),
      (e.prototype.preloadAutoWidthImages = function (b) {
        b.each(
          a.proxy(function (b, c) {
            this.enter('pre-loading'),
              (c = a(c)),
              a(new Image())
                .one(
                  'load',
                  a.proxy(function (a) {
                    c.attr('src', a.target.src),
                      c.css('opacity', 1),
                      this.leave('pre-loading'),
                      !this.is('pre-loading') && !this.is('initializing') && this.refresh();
                  }, this)
                )
                .attr('src', c.attr('src') || c.attr('data-src') || c.attr('data-src-retina'));
          }, this)
        );
      }),
      (e.prototype.destroy = function () {
        this.$element.off('.owl.core'),
          this.$stage.off('.owl.core'),
          a(c).off('.owl.core'),
          !1 !== this.settings.responsive &&
            (b.clearTimeout(this.resizeTimer), this.off(b, 'resize', this._handlers.onThrottledResize));
        for (var d in this._plugins) this._plugins[d].destroy();
        this.$stage.children('.cloned').remove(),
          this.$stage.unwrap(),
          this.$stage.children().contents().unwrap(),
          this.$stage.children().unwrap(),
          this.$stage.remove(),
          this.$element
            .removeClass(this.options.refreshClass)
            .removeClass(this.options.loadingClass)
            .removeClass(this.options.loadedClass)
            .removeClass(this.options.rtlClass)
            .removeClass(this.options.dragClass)
            .removeClass(this.options.grabClass)
            .attr(
              'class',
              this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), '')
            )
            .removeData('owl.carousel');
      }),
      (e.prototype.op = function (a, b, c) {
        var d = this.settings.rtl;
        switch (b) {
          case '<':
            return d ? a > c : a < c;
          case '>':
            return d ? a < c : a > c;
          case '>=':
            return d ? a <= c : a >= c;
          case '<=':
            return d ? a >= c : a <= c;
        }
      }),
      (e.prototype.on = function (a, b, c, d) {
        a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent('on' + b, c);
      }),
      (e.prototype.off = function (a, b, c, d) {
        a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent('on' + b, c);
      }),
      (e.prototype.trigger = function (b, c, d, f, g) {
        var h = { item: { count: this._items.length, index: this.current() } },
          i = a.camelCase(
            a
              .grep(['on', b, d], function (a) {
                return a;
              })
              .join('-')
              .toLowerCase()
          ),
          j = a.Event([b, 'owl', d || 'carousel'].join('.').toLowerCase(), a.extend({ relatedTarget: this }, h, c));
        return (
          this._supress[b] ||
            (a.each(this._plugins, function (a, b) {
              b.onTrigger && b.onTrigger(j);
            }),
            this.register({ type: e.Type.Event, name: b }),
            this.$element.trigger(j),
            this.settings && 'function' == typeof this.settings[i] && this.settings[i].call(this, j)),
          j
        );
      }),
      (e.prototype.enter = function (b) {
        a.each(
          [b].concat(this._states.tags[b] || []),
          a.proxy(function (a, b) {
            this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++;
          }, this)
        );
      }),
      (e.prototype.leave = function (b) {
        a.each(
          [b].concat(this._states.tags[b] || []),
          a.proxy(function (a, b) {
            this._states.current[b]--;
          }, this)
        );
      }),
      (e.prototype.register = function (b) {
        if (b.type === e.Type.Event) {
          if ((a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl)) {
            var c = a.event.special[b.name]._default;
            (a.event.special[b.name]._default = function (a) {
              return !c || !c.apply || (a.namespace && -1 !== a.namespace.indexOf('owl'))
                ? a.namespace && a.namespace.indexOf('owl') > -1
                : c.apply(this, arguments);
            }),
              (a.event.special[b.name].owl = !0);
          }
        } else
          b.type === e.Type.State &&
            (this._states.tags[b.name]
              ? (this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags))
              : (this._states.tags[b.name] = b.tags),
            (this._states.tags[b.name] = a.grep(
              this._states.tags[b.name],
              a.proxy(function (c, d) {
                return a.inArray(c, this._states.tags[b.name]) === d;
              }, this)
            )));
      }),
      (e.prototype.suppress = function (b) {
        a.each(
          b,
          a.proxy(function (a, b) {
            this._supress[b] = !0;
          }, this)
        );
      }),
      (e.prototype.release = function (b) {
        a.each(
          b,
          a.proxy(function (a, b) {
            delete this._supress[b];
          }, this)
        );
      }),
      (e.prototype.pointer = function (a) {
        var c = { x: null, y: null };
        return (
          (a = a.originalEvent || a || b.event),
          (a =
            a.touches && a.touches.length
              ? a.touches[0]
              : a.changedTouches && a.changedTouches.length
              ? a.changedTouches[0]
              : a),
          a.pageX ? ((c.x = a.pageX), (c.y = a.pageY)) : ((c.x = a.clientX), (c.y = a.clientY)),
          c
        );
      }),
      (e.prototype.isNumeric = function (a) {
        return !isNaN(parseFloat(a));
      }),
      (e.prototype.difference = function (a, b) {
        return { x: a.x - b.x, y: a.y - b.y };
      }),
      (a.fn.owlCarousel = function (b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
          var d = a(this),
            f = d.data('owl.carousel');
          f ||
            ((f = new e(this, 'object' == typeof b && b)),
            d.data('owl.carousel', f),
            a.each(['next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'], function (b, c) {
              f.register({ type: e.Type.Event, name: c }),
                f.$element.on(
                  c + '.owl.carousel.core',
                  a.proxy(function (a) {
                    a.namespace &&
                      a.relatedTarget !== this &&
                      (this.suppress([c]), f[c].apply(this, [].slice.call(arguments, 1)), this.release([c]));
                  }, f)
                );
            })),
            'string' == typeof b && '_' !== b.charAt(0) && f[b].apply(f, c);
        });
      }),
      (a.fn.owlCarousel.Constructor = e);
  })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._interval = null),
          (this._visible = null),
          (this._handlers = {
            'initialized.owl.carousel': a.proxy(function (a) {
              a.namespace && this._core.settings.autoRefresh && this.watch();
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers);
      };
      (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
        (e.prototype.watch = function () {
          this._interval ||
            ((this._visible = this._core.isVisible()),
            (this._interval = b.setInterval(a.proxy(this.refresh, this), this._core.settings.autoRefreshInterval)));
        }),
        (e.prototype.refresh = function () {
          this._core.isVisible() !== this._visible &&
            ((this._visible = !this._visible),
            this._core.$element.toggleClass('owl-hidden', !this._visible),
            this._visible && this._core.invalidate('width') && this._core.refresh());
        }),
        (e.prototype.destroy = function () {
          var a, c;
          b.clearInterval(this._interval);
          for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
          for (c in Object.getOwnPropertyNames(this)) 'function' != typeof this[c] && (this[c] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._loaded = []),
          (this._handlers = {
            'initialized.owl.carousel change.owl.carousel resized.owl.carousel': a.proxy(function (b) {
              if (
                b.namespace &&
                this._core.settings &&
                this._core.settings.lazyLoad &&
                ((b.property && 'position' == b.property.name) || 'initialized' == b.type)
              ) {
                var c = this._core.settings,
                  e = (c.center && Math.ceil(c.items / 2)) || c.items,
                  f = (c.center && -1 * e) || 0,
                  g = (b.property && b.property.value !== d ? b.property.value : this._core.current()) + f,
                  h = this._core.clones().length,
                  i = a.proxy(function (a, b) {
                    this.load(b);
                  }, this);
                for (
                  c.lazyLoadEager > 0 && ((e += c.lazyLoadEager), c.loop && ((g -= c.lazyLoadEager), e++));
                  f++ < e;

                )
                  this.load(h / 2 + this._core.relative(g)),
                    h && a.each(this._core.clones(this._core.relative(g)), i),
                    g++;
              }
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers);
      };
      (e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
        (e.prototype.load = function (c) {
          var d = this._core.$stage.children().eq(c),
            e = d && d.find('.owl-lazy');
          !e ||
            a.inArray(d.get(0), this._loaded) > -1 ||
            (e.each(
              a.proxy(function (c, d) {
                var e,
                  f = a(d),
                  g =
                    (b.devicePixelRatio > 1 && f.attr('data-src-retina')) ||
                    f.attr('data-src') ||
                    f.attr('data-srcset');
                this._core.trigger('load', { element: f, url: g }, 'lazy'),
                  f.is('img')
                    ? f
                        .one(
                          'load.owl.lazy',
                          a.proxy(function () {
                            f.css('opacity', 1), this._core.trigger('loaded', { element: f, url: g }, 'lazy');
                          }, this)
                        )
                        .attr('src', g)
                    : f.is('source')
                    ? f
                        .one(
                          'load.owl.lazy',
                          a.proxy(function () {
                            this._;
                            core.trigger('loaded', { element: f, url: g }, 'lazy');
                          }, this)
                        )
                        .attr('srcset', g)
                    : ((e = new Image()),
                      (e.onload = a.proxy(function () {
                        f.css({
                          'background-image': 'url("' + g + '")',
                          opacity: '1',
                        }),
                          this._core.trigger('loaded', { element: f, url: g }, 'lazy');
                      }, this)),
                      (e.src = g));
              }, this)
            ),
            this._loaded.push(d.get(0)));
        }),
        (e.prototype.destroy = function () {
          var a, b;
          for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
          for (b in Object.getOwnPropertyNames(this)) 'function' != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (c) {
        (this._core = c),
          (this._previousHeight = null),
          (this._handlers = {
            'initialized.owl.carousel refreshed.owl.carousel': a.proxy(function (a) {
              a.namespace && this._core.settings.autoHeight && this.update();
            }, this),
            'changed.owl.carousel': a.proxy(function (a) {
              a.namespace && this._core.settings.autoHeight && 'position' === a.property.name && this.update();
            }, this),
            'loaded.owl.lazy': a.proxy(function (a) {
              a.namespace &&
                this._core.settings.autoHeight &&
                a.element.closest('.' + this._core.settings.itemClass).index() === this._core.current() &&
                this.update();
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers),
          (this._intervalId = null);
        var d = this;
        a(b).on('load', function () {
          d._core.settings.autoHeight && d.update();
        }),
          a(b).resize(function () {
            d._core.settings.autoHeight &&
              (null != d._intervalId && clearTimeout(d._intervalId),
              (d._intervalId = setTimeout(function () {
                d.update();
              }, 250)));
          });
      };
      (e.Defaults = { autoHeight: !1, autoHeightClass: 'owl-height' }),
        (e.prototype.update = function () {
          var b = this._core._current,
            c = b + this._core.settings.items,
            d = this._core.settings.lazyLoad,
            e = this._core.$stage.children().toArray().slice(b, c),
            f = [],
            g = 0;
          a.each(e, function (b, c) {
            f.push(a(c).height());
          }),
            (g = Math.max.apply(null, f)),
            g <= 1 && d && this._previousHeight && (g = this._previousHeight),
            (this._previousHeight = g),
            this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass);
        }),
        (e.prototype.destroy = function () {
          var a, b;
          for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
          for (b in Object.getOwnPropertyNames(this)) 'function' != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._videos = {}),
          (this._playing = null),
          (this._handlers = {
            'initialized.owl.carousel': a.proxy(function (a) {
              a.namespace &&
                this._core.register({
                  type: 'state',
                  name: 'playing',
                  tags: ['interacting'],
                });
            }, this),
            'resize.owl.carousel': a.proxy(function (a) {
              a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault();
            }, this),
            'refreshed.owl.carousel': a.proxy(function (a) {
              a.namespace && this._core.is('resizing') && this._core.$stage.find('.cloned .owl-video-frame').remove();
            }, this),
            'changed.owl.carousel': a.proxy(function (a) {
              a.namespace && 'position' === a.property.name && this._playing && this.stop();
            }, this),
            'prepared.owl.carousel': a.proxy(function (b) {
              if (b.namespace) {
                var c = a(b.content).find('.owl-video');
                c.length && (c.css('display', 'none'), this.fetch(c, a(b.content)));
              }
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers),
          this._core.$element.on(
            'click.owl.video',
            '.owl-video-play-icon',
            a.proxy(function (a) {
              this.play(a);
            }, this)
          );
      };
      (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
        (e.prototype.fetch = function (a, b) {
          var c = (function () {
              return a.attr('data-vimeo-id') ? 'vimeo' : a.attr('data-vzaar-id') ? 'vzaar' : 'youtube';
            })(),
            d = a.attr('data-vimeo-id') || a.attr('data-youtube-id') || a.attr('data-vzaar-id'),
            e = a.attr('data-width') || this._core.settings.videoWidth,
            f = a.attr('data-height') || this._core.settings.videoHeight,
            g = a.attr('href');
          if (!g) throw new Error('Missing video URL.');
          if (
            ((d = g.match(
              /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
            )),
            d[3].indexOf('youtu') > -1)
          )
            c = 'youtube';
          else if (d[3].indexOf('vimeo') > -1) c = 'vimeo';
          else {
            if (!(d[3].indexOf('vzaar') > -1)) throw new Error('Video URL not supported.');
            c = 'vzaar';
          }
          (d = d[6]),
            (this._videos[g] = { type: c, id: d, width: e, height: f }),
            b.attr('data-video', g),
            this.thumbnail(a, this._videos[g]);
        }),
        (e.prototype.thumbnail = function (b, c) {
          var d,
            e,
            f,
            g = c.width && c.height ? 'width:' + c.width + 'px;height:' + c.height + 'px;' : '',
            h = b.find('img'),
            i = 'src',
            j = '',
            k = this._core.settings,
            l = function (c) {
              (e = '<div class="owl-video-play-icon"></div>'),
                (d = k.lazyLoad
                  ? a('<div/>', { class: 'owl-video-tn ' + j, srcType: c })
                  : a('<div/>', {
                      class: 'owl-video-tn',
                      style: 'opacity:1;background-image:url(' + c + ')',
                    })),
                b.after(d),
                b.after(e);
            };
          if (
            (b.wrap(a('<div/>', { class: 'owl-video-wrapper', style: g })),
            this._core.settings.lazyLoad && ((i = 'data-src'), (j = 'owl-lazy')),
            h.length)
          )
            return l(h.attr(i)), h.remove(), !1;
          'youtube' === c.type
            ? ((f = '//img.youtube.com/vi/' + c.id + '/hqdefault.jpg'), l(f))
            : 'vimeo' === c.type
            ? a.ajax({
                type: 'GET',
                url: '//vimeo.com/api/v2/video/' + c.id + '.json',
                jsonp: 'callback',
                dataType: 'jsonp',
                success: function (a) {
                  (f = a[0].thumbnail_large), l(f);
                },
              })
            : 'vzaar' === c.type &&
              a.ajax({
                type: 'GET',
                url: '//vzaar.com/api/videos/' + c.id + '.json',
                jsonp: 'callback',
                dataType: 'jsonp',
                success: function (a) {
                  (f = a.framegrab_url), l(f);
                },
              });
        }),
        (e.prototype.stop = function () {
          this._core.trigger('stop', null, 'video'),
            this._playing.find('.owl-video-frame').remove(),
            this._playing.removeClass('owl-video-playing'),
            (this._playing = null),
            this._core.leave('playing'),
            this._core.trigger('stopped', null, 'video');
        }),
        (e.prototype.play = function (b) {
          var c,
            d = a(b.target),
            e = d.closest('.' + this._core.settings.itemClass),
            f = this._videos[e.attr('data-video')],
            g = f.width || '100%',
            h = f.height || this._core.$stage.height();
          this._playing ||
            (this._core.enter('playing'),
            this._core.trigger('play', null, 'video'),
            (e = this._core.items(this._core.relative(e.index()))),
            this._core.reset(e.index()),
            (c = a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')),
            c.attr('height', h),
            c.attr('width', g),
            'youtube' === f.type
              ? c.attr('src', '//www.youtube.com/embed/' + f.id + '?autoplay=1&rel=0&v=' + f.id)
              : 'vimeo' === f.type
              ? c.attr('src', '//player.vimeo.com/video/' + f.id + '?autoplay=1')
              : 'vzaar' === f.type && c.attr('src', '//view.vzaar.com/' + f.id + '/player?autoplay=true'),
            a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find('.owl-video')),
            (this._playing = e.addClass('owl-video-playing')));
        }),
        (e.prototype.isInFullScreen = function () {
          var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
          return b && a(b).parent().hasClass('owl-video-frame');
        }),
        (e.prototype.destroy = function () {
          var a, b;
          this._core.$element.off('click.owl.video');
          for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
          for (b in Object.getOwnPropertyNames(this)) 'function' != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Video = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this.core = b),
          (this.core.options = a.extend({}, e.Defaults, this.core.options)),
          (this.swapping = !0),
          (this.previous = d),
          (this.next = d),
          (this.handlers = {
            'change.owl.carousel': a.proxy(function (a) {
              a.namespace &&
                'position' == a.property.name &&
                ((this.previous = this.core.current()), (this.next = a.property.value));
            }, this),
            'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': a.proxy(function (a) {
              a.namespace && (this.swapping = 'translated' == a.type);
            }, this),
            'translate.owl.carousel': a.proxy(function (a) {
              a.namespace &&
                this.swapping &&
                (this.core.options.animateOut || this.core.options.animateIn) &&
                this.swap();
            }, this),
          }),
          this.core.$element.on(this.handlers);
      };
      (e.Defaults = { animateOut: !1, animateIn: !1 }),
        (e.prototype.swap = function () {
          if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
            this.core.speed(0);
            var b,
              c = a.proxy(this.clear, this),
              d = this.core.$stage.children().eq(this.previous),
              e = this.core.$stage.children().eq(this.next),
              f = this.core.settings.animateIn,
              g = this.core.settings.animateOut;
            this.core.current() !== this.previous &&
              (g &&
                ((b = this.core.coordinates(this.previous) - this.core.coordinates(this.next)),
                d
                  .one(a.support.animation.end, c)
                  .css({ left: b + 'px' })
                  .addClass('animated owl-animated-out')
                  .addClass(g)),
              f && e.one(a.support.animation.end, c).addClass('animated owl-animated-in').addClass(f));
          }
        }),
        (e.prototype.clear = function (b) {
          a(b.target)
            .css({ left: '' })
            .removeClass('animated owl-animated-out owl-animated-in')
            .removeClass(this.core.settings.animateIn)
            .removeClass(this.core.settings.animateOut),
            this.core.onTransitionEnd();
        }),
        (e.prototype.destroy = function () {
          var a, b;
          for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
          for (b in Object.getOwnPropertyNames(this)) 'function' != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._call = null),
          (this._time = 0),
          (this._timeout = 0),
          (this._paused = !0),
          (this._handlers = {
            'changed.owl.carousel': a.proxy(function (a) {
              a.namespace && 'settings' === a.property.name
                ? this._core.settings.autoplay
                  ? this.play()
                  : this.stop()
                : a.namespace && 'position' === a.property.name && this._paused && (this._time = 0);
            }, this),
            'initialized.owl.carousel': a.proxy(function (a) {
              a.namespace && this._core.settings.autoplay && this.play();
            }, this),
            'play.owl.autoplay': a.proxy(function (a, b, c) {
              a.namespace && this.play(b, c);
            }, this),
            'stop.owl.autoplay': a.proxy(function (a) {
              a.namespace && this.stop();
            }, this),
            'mouseover.owl.autoplay': a.proxy(function () {
              this._core.settings.autoplayHoverPause && this._core.is('rotating') && this.pause();
            }, this),
            'mouseleave.owl.autoplay': a.proxy(function () {
              this._core.settings.autoplayHoverPause && this._core.is('rotating') && this.play();
            }, this),
            'touchstart.owl.core': a.proxy(function () {
              this._core.settings.autoplayHoverPause && this._core.is('rotating') && this.pause();
            }, this),
            'touchend.owl.core': a.proxy(function () {
              this._core.settings.autoplayHoverPause && this.play();
            }, this),
          }),
          this._core.$element.on(this._handlers),
          (this._core.options = a.extend({}, e.Defaults, this._core.options));
      };
      (e.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1,
      }),
        (e.prototype._next = function (d) {
          (this._call = b.setTimeout(
            a.proxy(this._next, this, d),
            this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
          )),
            this._core.is('interacting') || c.hidden || this._core.next(d || this._core.settings.autoplaySpeed);
        }),
        (e.prototype.read = function () {
          return new Date().getTime() - this._time;
        }),
        (e.prototype.play = function (c, d) {
          var e;
          this._core.is('rotating') || this._core.enter('rotating'),
            (c = c || this._core.settings.autoplayTimeout),
            (e = Math.min(this._time % (this._timeout || c), c)),
            this._paused ? ((this._time = this.read()), (this._paused = !1)) : b.clearTimeout(this._call),
            (this._time += (this.read() % c) - e),
            (this._timeout = c),
            (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e));
        }),
        (e.prototype.stop = function () {
          this._core.is('rotating') &&
            ((this._time = 0), (this._paused = !0), b.clearTimeout(this._call), this._core.leave('rotating'));
        }),
        (e.prototype.pause = function () {
          this._core.is('rotating') &&
            !this._paused &&
            ((this._time = this.read()), (this._paused = !0), b.clearTimeout(this._call));
        }),
        (e.prototype.destroy = function () {
          var a, b;
          this.stop();
          for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
          for (b in Object.getOwnPropertyNames(this)) 'function' != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      'use strict';
      var e = function (b) {
        (this._core = b),
          (this._initialized = !1),
          (this._pages = []),
          (this._controls = {}),
          (this._templates = []),
          (this.$element = this._core.$element),
          (this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to,
          }),
          (this._handlers = {
            'prepared.owl.carousel': a.proxy(function (b) {
              b.namespace &&
                this._core.settings.dotsData &&
                this._templates.push(
                  '<div class="' +
                    this._core.settings.dotClass +
                    '">' +
                    a(b.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') +
                    '</div>'
                );
            }, this),
            'added.owl.carousel': a.proxy(function (a) {
              a.namespace &&
                this._core.settings.dotsData &&
                this._templates.splice(a.position, 0, this._templates.pop());
            }, this),
            'remove.owl.carousel': a.proxy(function (a) {
              a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1);
            }, this),
            'changed.owl.carousel': a.proxy(function (a) {
              a.namespace && 'position' == a.property.name && this.draw();
            }, this),
            'initialized.owl.carousel': a.proxy(function (a) {
              a.namespace &&
                !this._initialized &&
                (this._core.trigger('initialize', null, 'navigation'),
                this.initialize(),
                this.update(),
                this.draw(),
                (this._initialized = !0),
                this._core.trigger('initialized', null, 'navigation'));
            }, this),
            'refreshed.owl.carousel': a.proxy(function (a) {
              a.namespace &&
                this._initialized &&
                (this._core.trigger('refresh', null, 'navigation'),
                this.update(),
                this.draw(),
                this._core.trigger('refreshed', null, 'navigation'));
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this.$element.on(this._handlers);
      };
      (e.Defaults = {
        nav: !1,
        navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
        navSpeed: !1,
        navElement: 'button type="button" role="presentation"',
        navContainer: !1,
        navContainerClass: 'owl-nav',
        navClass: ['owl-prev', 'owl-next'],
        slideBy: 1,
        dotClass: 'owl-dot',
        dotsClass: 'owl-dots',
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1,
      }),
        (e.prototype.initialize = function () {
          var b,
            c = this._core.settings;
          (this._controls.$relative = (
            c.navContainer ? a(c.navContainer) : a('<div>').addClass(c.navContainerClass).appendTo(this.$element)
          ).addClass('disabled')),
            (this._controls.$previous = a('<' + c.navElement + '>')
              .addClass(c.navClass[0])
              .html(c.navText[0])
              .prependTo(this._controls.$relative)
              .on(
                'click',
                a.proxy(function (a) {
                  this.prev(c.navSpeed);
                }, this)
              )),
            (this._controls.$next = a('<' + c.navElement + '>')
              .addClass(c.navClass[1])
              .html(c.navText[1])
              .appendTo(this._controls.$relative)
              .on(
                'click',
                a.proxy(function (a) {
                  this.next(c.navSpeed);
                }, this)
              )),
            c.dotsData ||
              (this._templates = [
                a('<button role="button">').addClass(c.dotClass).append(a('<span>')).prop('outerHTML'),
              ]),
            (this._controls.$absolute = (
              c.dotsContainer ? a(c.dotsContainer) : a('<div>').addClass(c.dotsClass).appendTo(this.$element)
            ).addClass('disabled')),
            this._controls.$absolute.on(
              'click',
              'button',
              a.proxy(function (b) {
                var d = a(b.target).parent().is(this._controls.$absolute)
                  ? a(b.target).index()
                  : a(b.target).parent().index();
                b.preventDefault(), this.to(d, c.dotsSpeed);
              }, this)
            );
          for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
        }),
        (e.prototype.destroy = function () {
          var a, b, c, d, e;
          e = this._core.settings;
          for (a in this._handlers) this.$element.off(a, this._handlers[a]);
          for (b in this._controls)
            '$relative' === b && e.navContainer ? this._controls[b].html('') : this._controls[b].remove();
          for (d in this.overides) this._core[d] = this._overrides[d];
          for (c in Object.getOwnPropertyNames(this)) 'function' != typeof this[c] && (this[c] = null);
        }),
        (e.prototype.update = function () {
          var a,
            b,
            c,
            d = this._core.clones().length / 2,
            e = d + this._core.items().length,
            f = this._core.maximum(!0),
            g = this._core.settings,
            h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
          if (('page' !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)), g.dots || 'page' == g.slideBy))
            for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
              if (b >= h || 0 === b) {
                if (
                  (this._pages.push({
                    start: Math.min(f, a - d),
                    end: a - d + h - 1,
                  }),
                  Math.min(f, a - d) === f)
                )
                  break;
                (b = 0), ++c;
              }
              b += this._core.mergers(this._core.relative(a));
            }
        }),
        (e.prototype.draw = function () {
          var b,
            c = this._core.settings,
            d = this._core.items().length <= c.items,
            e = this._core.relative(this._core.current()),
            f = c.loop || c.rewind;
          this._controls.$relative.toggleClass('disabled', !c.nav || d),
            c.nav &&
              (this._controls.$previous.toggleClass('disabled', !f && e <= this._core.minimum(!0)),
              this._controls.$next.toggleClass('disabled', !f && e >= this._core.maximum(!0))),
            this._controls.$absolute.toggleClass('disabled', !c.dots || d),
            c.dots &&
              ((b = this._pages.length - this._controls.$absolute.children().length),
              c.dotsData && 0 !== b
                ? this._controls.$absolute.html(this._templates.join(''))
                : b > 0
                ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0]))
                : b < 0 && this._controls.$absolute.children().slice(b).remove(),
              this._controls.$absolute.find('.active').removeClass('active'),
              this._controls.$absolute.children().eq(a.inArray(this.current(), this._pages)).addClass('active'));
        }),
        (e.prototype.onTrigger = function (b) {
          var c = this._core.settings;
          b.page = {
            index: a.inArray(this.current(), this._pages),
            count: this._pages.length,
            size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items),
          };
        }),
        (e.prototype.current = function () {
          var b = this._core.relative(this._core.current());
          return a
            .grep(
              this._pages,
              a.proxy(function (a, c) {
                return a.start <= b && a.end >= b;
              }, this)
            )
            .pop();
        }),
        (e.prototype.getPosition = function (b) {
          var c,
            d,
            e = this._core.settings;
          return (
            'page' == e.slideBy
              ? ((c = a.inArray(this.current(), this._pages)),
                (d = this._pages.length),
                b ? ++c : --c,
                (c = this._pages[((c % d) + d) % d].start))
              : ((c = this._core.relative(this._core.current())),
                (d = this._core.items().length),
                b ? (c += e.slideBy) : (c -= e.slideBy)),
            c
          );
        }),
        (e.prototype.next = function (b) {
          a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
        }),
        (e.prototype.prev = function (b) {
          a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
        }),
        (e.prototype.to = function (b, c, d) {
          var e;
          !d && this._pages.length
            ? ((e = this._pages.length),
              a.proxy(this._overrides.to, this._core)(this._pages[((b % e) + e) % e].start, c))
            : a.proxy(this._overrides.to, this._core)(b, c);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      'use strict';
      var e = function (c) {
        (this._core = c),
          (this._hashes = {}),
          (this.$element = this._core.$element),
          (this._handlers = {
            'initialized.owl.carousel': a.proxy(function (c) {
              c.namespace &&
                'URLHash' === this._core.settings.startPosition &&
                a(b).trigger('hashchange.owl.navigation');
            }, this),
            'prepared.owl.carousel': a.proxy(function (b) {
              if (b.namespace) {
                var c = a(b.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');
                if (!c) return;
                this._hashes[c] = b.content;
              }
            }, this),
            'changed.owl.carousel': a.proxy(function (c) {
              if (c.namespace && 'position' === c.property.name) {
                var d = this._core.items(this._core.relative(this._core.current())),
                  e = a
                    .map(this._hashes, function (a, b) {
                      return a === d ? b : null;
                    })
                    .join();
                if (!e || b.location.hash.slice(1) === e) return;
                b.location.hash = e;
              }
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this.$element.on(this._handlers),
          a(b).on(
            'hashchange.owl.navigation',
            a.proxy(function (a) {
              var c = b.location.hash.substring(1),
                e = this._core.$stage.children(),
                f = this._hashes[c] && e.index(this._hashes[c]);
              f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0);
            }, this)
          );
      };
      (e.Defaults = { URLhashListener: !1 }),
        (e.prototype.destroy = function () {
          var c, d;
          a(b).off('hashchange.owl.navigation');
          for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
          for (d in Object.getOwnPropertyNames(this)) 'function' != typeof this[d] && (this[d] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      function e(b, c) {
        var e = !1,
          f = b.charAt(0).toUpperCase() + b.slice(1);
        return (
          a.each((b + ' ' + h.join(f + ' ') + f).split(' '), function (a, b) {
            if (g[b] !== d) return (e = !c || b), !1;
          }),
          e
        );
      }
      function f(a) {
        return e(a, !0);
      }
      var g = a('<support>').get(0).style,
        h = 'Webkit Moz O ms'.split(' '),
        i = {
          transition: {
            end: {
              WebkitTransition: 'webkitTransitionEnd',
              MozTransition: 'transitionend',
              OTransition: 'oTransitionEnd',
              transition: 'transitionend',
            },
          },
          animation: {
            end: {
              WebkitAnimation: 'webkitAnimationEnd',
              MozAnimation: 'animationend',
              OAnimation: 'oAnimationEnd',
              animation: 'animationend',
            },
          },
        },
        j = {
          csstransforms: function () {
            return !!e('transform');
          },
          csstransforms3d: function () {
            return !!e('perspective');
          },
          csstransitions: function () {
            return !!e('transition');
          },
          cssanimations: function () {
            return !!e('animation');
          },
        };
      j.csstransitions() &&
        ((a.support.transition = new String(f('transition'))),
        (a.support.transition.end = i.transition.end[a.support.transition])),
        j.cssanimations() &&
          ((a.support.animation = new String(f('animation'))),
          (a.support.animation.end = i.animation.end[a.support.animation])),
        j.csstransforms() &&
          ((a.support.transform = new String(f('transform'))), (a.support.transform3d = j.csstransforms3d()));
    })(window.Zepto || window.jQuery, window, document);

  /**
   * Readmore.js jQuery plugin
   * Author: @jed_foster
   * Project home: http://jedfoster.github.io/Readmore.js
   * Licensed under the MIT license
   * Version: 3.0.0-alpha-6
   */
  !(function (e, t) {
    'object' == typeof exports && 'object' == typeof module
      ? (module.exports = t())
      : 'function' == typeof define && define.amd
      ? define('Readmore', [], t)
      : 'object' == typeof exports
      ? (exports.Readmore = t())
      : (e.Readmore = t());
  })('undefined' != typeof self ? self : this, function () {
    return ((r = {}),
    (n.m = o =
      [
        function (e, t, o) {
          e.exports = o(1);
        },
        function (e, t, o) {
          'use strict';
          Object.defineProperty(t, '__esModule', { value: !0 });
          var n = function (e, t, o) {
            return t && r(e.prototype, t), o && r(e, o), e;
          };
          function r(e, t) {
            for (var o = 0; o < t.length; o++) {
              var n = t[o];
              (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                'value' in n && (n.writable = !0),
                Object.defineProperty(e, n.key, n);
            }
          }
          var c =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                    ? 'symbol'
                    : typeof e;
                };
          var i = 0,
            a = [];
          function s(e, t, o) {
            for (var n = 0; n < e.length; n += 1) t.call(o, e[n], n);
          }
          function l() {
            return 'rmjs-' + (i += 1);
          }
          function d(e) {
            e.style.height = 'auto';
            var t = parseInt(e.getBoundingClientRect().height, 10),
              o = parseInt(window.getComputedStyle(e).maxHeight, 10),
              n = parseInt(e.readmore.defaultHeight, 10);
            (e.readmore.expandedHeight = t),
              (e.readmore.maxHeight = o),
              (e.readmore.collapsedHeight = o || e.readmore.collapsedHeight || n),
              (e.style.maxHeight = 'none');
          }
          function u(e, t) {
            if (!a[e]) {
              var o = '';
              t.embedCSS &&
                '' !== t.blockCSS &&
                (o += e + ' + [data-readmore-toggle], ' + e + '[data-readmore] {\n        ' + t.blockCSS + '\n      }'),
                (o +=
                  e + '[data-readmore] {\n      transition: height ' + t.speed + 'ms;\n      overflow: hidden;\n    }'),
                (n = document),
                (r = o),
                ((i = n.createElement('style')).type = 'text/css'),
                i.styleSheet ? (i.styleSheet.cssText = r) : i.appendChild(n.createTextNode(r)),
                n.getElementsByTagName('head')[0].appendChild(i),
                (a[e] = !0);
            }
            var n, r, i;
          }
          function f(e, t, o) {
            var n = e;
            'function' == typeof e && (n = e(t));
            var r,
              i,
              a = ((r = n), ((i = document.createElement('div')).innerHTML = r), i.firstChild);
            return (
              a.setAttribute('data-readmore-toggle', t.id),
              a.setAttribute('aria-controls', t.id),
              a.addEventListener(
                'click',
                function (e) {
                  this.toggle(t, e);
                }.bind(o)
              ),
              a
            );
          }
          [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function (e) {
            Object.prototype.hasOwnProperty.call(e, 'remove') ||
              Object.defineProperty(e, 'remove', {
                configurable: !0,
                enumerable: !0,
                writable: !0,
                value: function () {
                  null !== this.parentNode && this.parentNode.removeChild(this);
                },
              });
          });
          function p() {
            for (var e = this, t = arguments.length, o = Array(t), n = 0; n < t; n++) o[n] = arguments[n];
            var r = g && !y;
            clearTimeout(y),
              (y = setTimeout(function () {
                (y = null), g || h.apply(e, o);
              }, m)),
              r && h.apply(this, o);
          }
          var h,
            m,
            g,
            y,
            v = {
              speed: (m = 100),
              collapsedHeight: 200,
              heightMargin: 16,
              moreLink: '<a href="#">Read More</a>',
              lessLink: '<a href="#">Close</a>',
              embedCSS: !(y = void 0),
              blockCSS: 'display: block; width: 100%;',
              startOpen: !(h = function () {
                s(document.querySelectorAll('[data-readmore]'), function (e) {
                  var t = 'true' === e.getAttribute('aria-expanded');
                  d(e), (e.style.height = (t ? e.readmore.expandedHeight : e.readmore.collapsedHeight) + 'px');
                });
              }),
              sourceOrder: 'after',
              blockProcessed: function () {},
              beforeToggle: function () {},
              afterToggle: function () {},
            },
            b =
              (n(S, [
                {
                  key: 'toggle',
                  value: function (e, t) {
                    function o(t) {
                      var o = document.querySelector('[aria-controls="' + t.id + '"]'),
                        n = t.getBoundingClientRect().height <= t.readmore.collapsedHeight,
                        e = n ? t.readmore.expandedHeight : t.readmore.collapsedHeight;
                      if ('function' != typeof a.options.beforeToggle || !1 !== a.options.beforeToggle(o, t, !n)) {
                        (t.style.height = e + 'px'),
                          t.addEventListener('transitionend', i, !1),
                          a.options.speed < 1 && i.call(a, { target: t });
                        var r = n ? a.options.lessLink : a.options.moreLink;
                        r ? o && o.parentNode && o.parentNode.replaceChild(f(r, t, a), o) : o.remove();
                      }
                      function i(e) {
                        'function' == typeof a.options.afterToggle && a.options.afterToggle(o, t, n),
                          e.stopPropagation(),
                          t.setAttribute('aria-expanded', n),
                          t.removeEventListener('transitionend', i, !1);
                      }
                    }
                    var a = this,
                      n = arguments.length <= 0 ? void 0 : e;
                    if (('string' == typeof n && (n = document.querySelectorAll(n)), !n))
                      throw new Error('Element MUST be either an HTML node or querySelector string');
                    var r = arguments.length <= 1 ? void 0 : t;
                    r && (r.preventDefault(), r.stopPropagation()),
                      'object' !== (void 0 === n ? 'undefined' : c(n)) || n.nodeName ? o(n) : s(n, o);
                  },
                },
                {
                  key: 'destroy',
                  value: function (e) {
                    var o = this;
                    s(
                      e ? ('string' == typeof e ? document.querySelectorAll(e) : e.nodeName ? [e] : e) : this.elements,
                      function (t) {
                        if (-1 !== o.elements.indexOf(t)) {
                          (o.elements = o.elements.filter(function (e) {
                            return e !== t;
                          })),
                            o.instanceSelector && t.classList.remove(o.instanceSelector.substr(1)),
                            delete t.readmore,
                            (t.style.height = 'initial'),
                            (t.style.maxHeight = 'initial'),
                            t.removeAttribute('data-readmore'),
                            t.removeAttribute('aria-expanded');
                          var e = document.querySelector('[aria-controls="' + t.id + '"]');
                          e && e.remove(), -1 !== t.id.indexOf('rmjs-') && t.removeAttribute('id');
                        }
                      }
                    );
                  },
                },
              ]),
              S);
          function S() {
            var r = this;
            if (
              (!(function (e, t) {
                if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
              })(this, S),
              'undefined' != typeof window &&
                'undefined' != typeof document &&
                document.querySelectorAll &&
                window.addEventListener)
            ) {
              for (var e = arguments.length, t = Array(e), o = 0; o < e; o++) t[o] = arguments[o];
              var n = t[0],
                i = t[1],
                a = void 0;
              (a = 'string' == typeof n ? document.querySelectorAll(n) : n.nodeName ? [n] : n).length &&
                ((this.options = (function t() {
                  for (var e = arguments.length, o = Array(e), n = 0; n < e; n++) o[n] = arguments[n];
                  var r = {}.hasOwnProperty,
                    i = o[0],
                    a = o[1];
                  if (2 < o.length) {
                    var s = [];
                    for (
                      Object.keys(o).forEach(function (e) {
                        s.push(o[e]);
                      });
                      2 < s.length;

                    ) {
                      var l = s.shift(),
                        d = s.shift();
                      s.unshift(t(l, d));
                    }
                    (i = s.shift()), (a = s.shift());
                  }
                  return (
                    a &&
                      Object.keys(a).forEach(function (e) {
                        r.call(a, e) &&
                          ('object' === c(a[e]) ? ((i[e] = i[e] || {}), (i[e] = t(i[e], a[e]))) : (i[e] = a[e]));
                      }),
                    i
                  );
                })({}, v, i)),
                'string' == typeof n
                  ? u(n, this.options)
                  : ((this.instanceSelector = '.' + l()), u(this.instanceSelector, this.options)),
                window.addEventListener('load', p),
                window.addEventListener('resize', p),
                (this.elements = []),
                s(a, function (e) {
                  r.instanceSelector && e.classList.add(r.instanceSelector.substr(1));
                  var t = r.options.startOpen;
                  (e.readmore = {
                    defaultHeight: r.options.collapsedHeight,
                    heightMargin: r.options.heightMargin,
                  }),
                    d(e);
                  var o = e.readmore.heightMargin;
                  if (e.getBoundingClientRect().height <= e.readmore.collapsedHeight + o)
                    'function' == typeof r.options.blockProcessed && r.options.blockProcessed(e, !1);
                  else {
                    e.setAttribute('data-readmore', ''), e.setAttribute('aria-expanded', t), (e.id = e.id || l());
                    var n = f(t ? r.options.lessLink : r.options.moreLink, e, r);
                    e.parentNode.insertBefore(n, 'before' === r.options.sourceOrder ? e : e.nextSibling),
                      (e.style.height = (t ? e.readmore.expandedHeight : e.readmore.collapsedHeight) + 'px'),
                      'function' == typeof r.options.blockProcessed && r.options.blockProcessed(e, !0),
                      r.elements.push(e);
                  }
                }));
            }
          }
          (b.VERSION = '3.0.0-alpha-6'), (t.default = b);
        },
      ]),
    (n.c = r),
    (n.d = function (e, t, o) {
      n.o(e, t) ||
        Object.defineProperty(e, t, {
          configurable: !1,
          enumerable: !0,
          get: o,
        });
    }),
    (n.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return n.d(t, 'a', t), t;
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.p = ''),
    n((n.s = 0))).default;
    function n(e) {
      if (r[e]) return r[e].exports;
      var t = (r[e] = { i: e, l: !1, exports: {} });
      return o[e].call(t.exports, t, t.exports, n), (t.l = !0), t.exports;
    }
    var o, r;
  });

  /*!
   * Rellax.js - v1.9.1
   * Buttery smooth parallax library
   * Copyright (c) 2016 Moe Amaya (@moeamaya)
   * MIT license
   */
  (function (q, g) {
    'function' === typeof define && define.amd
      ? define([], g)
      : 'object' === typeof module && module.exports
      ? (module.exports = g())
      : (q.Rellax = g());
  })('undefined' !== typeof window ? window : global, function () {
    var q = function (g, t) {
      var b = Object.create(q.prototype),
        l = 0,
        u = 0,
        n = 0,
        v = 0,
        c = [],
        w = !0,
        A =
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          function (b) {
            return setTimeout(b, 1e3 / 60);
          },
        p = null,
        x = !1;
      try {
        var k = Object.defineProperty({}, 'passive', {
          get: function () {
            x = !0;
          },
        });
        window.addEventListener('testPassive', null, k);
        window.removeEventListener('testPassive', null, k);
      } catch (f) {}
      var J = window.cancelAnimationFrame || window.mozCancelAnimationFrame || clearTimeout,
        K =
          window.transformProp ||
          (function () {
            var b = document.createElement('div');
            if (null === b.style.transform) {
              var a = ['Webkit', 'Moz', 'ms'],
                d;
              for (d in a) if (void 0 !== b.style[a[d] + 'Transform']) return a[d] + 'Transform';
            }
            return 'transform';
          })();
      b.options = {
        speed: -2,
        verticalSpeed: null,
        horizontalSpeed: null,
        center: !1,
        wrapper: null,
        relativeToWrapper: !1,
        round: !0,
        vertical: !0,
        horizontal: !1,
        verticalScrollAxis: 'y',
        horizontalScrollAxis: 'x',
        callback: function () {},
      };
      t &&
        Object.keys(t).forEach(function (c) {
          b.options[c] = t[c];
        });
      g || (g = '.rellax');
      k = 'string' === typeof g ? document.querySelectorAll(g) : [g];
      if (0 < k.length) {
        b.elems = k;
        if (b.options.wrapper && !b.options.wrapper.nodeType)
          if ((k = document.querySelector(b.options.wrapper))) b.options.wrapper = k;
          else {
            console.warn("Rellax: The wrapper you're trying to use doesn't exist.");
            return;
          }
        var B = function () {
            for (var f = 0; f < c.length; f++) b.elems[f].style.cssText = c[f].style;
            c = [];
            u = window.innerHeight;
            v = window.innerWidth;
            D();
            for (f = 0; f < b.elems.length; f++) {
              var a = b.elems[f],
                d = a.getAttribute('data-rellax-percentage'),
                e = a.getAttribute('data-rellax-speed'),
                y = a.getAttribute('data-rellax-vertical-speed'),
                g = a.getAttribute('data-rellax-horizontal-speed'),
                h = a.getAttribute('data-rellax-vertical-scroll-axis'),
                k = a.getAttribute('data-rellax-horizontal-scroll-axis'),
                l = a.getAttribute('data-rellax-zindex') || 0,
                n = a.getAttribute('data-rellax-min'),
                p = a.getAttribute('data-rellax-max'),
                q = a.getAttribute('data-rellax-min-x'),
                t = a.getAttribute('data-rellax-max-x'),
                x = a.getAttribute('data-rellax-min-y'),
                A = a.getAttribute('data-rellax-max-y'),
                z = b.options.wrapper
                  ? b.options.wrapper.scrollTop
                  : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
              b.options.relativeToWrapper &&
                (z =
                  (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) -
                  b.options.wrapper.offsetTop);
              var m = b.options.vertical ? (d || b.options.center ? z : 0) : 0,
                r = b.options.horizontal
                  ? d || b.options.center
                    ? b.options.wrapper
                      ? b.options.wrapper.scrollLeft
                      : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft
                    : 0
                  : 0;
              z = m + a.getBoundingClientRect().top;
              var E = a.clientHeight || a.offsetHeight || a.scrollHeight,
                F = r + a.getBoundingClientRect().left,
                G = a.clientWidth || a.offsetWidth || a.scrollWidth;
              m = d ? d : (m - z + u) / (E + u);
              d = d ? d : (r - F + v) / (G + v);
              b.options.center && (m = d = 0.5);
              e = e ? e : b.options.speed;
              y = y ? y : b.options.verticalSpeed;
              g = g ? g : b.options.horizontalSpeed;
              h = h ? h : b.options.verticalScrollAxis;
              k = k ? k : b.options.horizontalScrollAxis;
              m = H(d, m, e, y, g);
              a = a.style.cssText;
              d = '';
              if ((r = /transform\s*:/i.exec(a)))
                (d = a.slice(r.index)),
                  (d = (r = d.indexOf(';'))
                    ? ' ' + d.slice(11, r).replace(/\s/g, '')
                    : ' ' + d.slice(11).replace(/\s/g, ''));
              c.push({
                baseX: m.x,
                baseY: m.y,
                top: z,
                left: F,
                height: E,
                width: G,
                speed: e,
                verticalSpeed: y,
                horizontalSpeed: g,
                verticalScrollAxis: h,
                horizontalScrollAxis: k,
                style: a,
                transform: d,
                zindex: l,
                min: n,
                max: p,
                minX: q,
                maxX: t,
                minY: x,
                maxY: A,
              });
            }
            I();
            w && (window.addEventListener('resize', B), (w = !1), C());
          },
          D = function () {
            var c = l,
              a = n;
            l = b.options.wrapper
              ? b.options.wrapper.scrollTop
              : (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
            n = b.options.wrapper
              ? b.options.wrapper.scrollLeft
              : (document.documentElement || document.body.parentNode || document.body).scrollLeft ||
                window.pageXOffset;
            b.options.relativeToWrapper &&
              (l =
                ((document.documentElement || document.body.parentNode || document.body).scrollTop ||
                  window.pageYOffset) - b.options.wrapper.offsetTop);
            return (c != l && b.options.vertical) || (a != n && b.options.horizontal) ? !0 : !1;
          },
          H = function (c, a, d, e, g) {
            var f = {};
            c = 100 * (g ? g : d) * (1 - c);
            a = 100 * (e ? e : d) * (1 - a);
            f.x = b.options.round ? Math.round(c) : Math.round(100 * c) / 100;
            f.y = b.options.round ? Math.round(a) : Math.round(100 * a) / 100;
            return f;
          },
          h = function () {
            window.removeEventListener('resize', h);
            window.removeEventListener('orientationchange', h);
            (b.options.wrapper ? b.options.wrapper : window).removeEventListener('scroll', h);
            (b.options.wrapper ? b.options.wrapper : document).removeEventListener('touchmove', h);
            p = A(C);
          },
          C = function () {
            D() && !1 === w
              ? (I(), (p = A(C)))
              : ((p = null),
                window.addEventListener('resize', h),
                window.addEventListener('orientationchange', h),
                (b.options.wrapper ? b.options.wrapper : window).addEventListener(
                  'scroll',
                  h,
                  x ? { passive: !0 } : !1
                ),
                (b.options.wrapper ? b.options.wrapper : document).addEventListener(
                  'touchmove',
                  h,
                  x ? { passive: !0 } : !1
                ));
          },
          I = function () {
            for (var f, a = 0; a < b.elems.length; a++) {
              var d = c[a].verticalScrollAxis.toLowerCase(),
                e = c[a].horizontalScrollAxis.toLowerCase();
              f = -1 != d.indexOf('x') ? l : 0;
              d = -1 != d.indexOf('y') ? l : 0;
              var g = -1 != e.indexOf('x') ? n : 0;
              e = -1 != e.indexOf('y') ? n : 0;
              f = H(
                (f + g - c[a].left + v) / (c[a].width + v),
                (d + e - c[a].top + u) / (c[a].height + u),
                c[a].speed,
                c[a].verticalSpeed,
                c[a].horizontalSpeed
              );
              e = f.y - c[a].baseY;
              d = f.x - c[a].baseX;
              null !== c[a].min &&
                (b.options.vertical && !b.options.horizontal && (e = e <= c[a].min ? c[a].min : e),
                b.options.horizontal && !b.options.vertical && (d = d <= c[a].min ? c[a].min : d));
              null != c[a].minY && (e = e <= c[a].minY ? c[a].minY : e);
              null != c[a].minX && (d = d <= c[a].minX ? c[a].minX : d);
              null !== c[a].max &&
                (b.options.vertical && !b.options.horizontal && (e = e >= c[a].max ? c[a].max : e),
                b.options.horizontal && !b.options.vertical && (d = d >= c[a].max ? c[a].max : d));
              null != c[a].maxY && (e = e >= c[a].maxY ? c[a].maxY : e);
              null != c[a].maxX && (d = d >= c[a].maxX ? c[a].maxX : d);
              b.elems[a].style[K] =
                'translate3d(' +
                (b.options.horizontal ? d : '0') +
                'px,' +
                (b.options.vertical ? e : '0') +
                'px,' +
                c[a].zindex +
                'px) ' +
                c[a].transform;
            }
            b.options.callback(f);
          };
        b.destroy = function () {
          for (var f = 0; f < b.elems.length; f++) b.elems[f].style.cssText = c[f].style;
          w || (window.removeEventListener('resize', B), (w = !0));
          J(p);
          p = null;
        };
        B();
        b.refresh = B;
        return b;
      }
      console.warn("Rellax: The elements you're trying to select don't exist.");
    };
    return q;
  });

  /*! lazysizes - v4.0.1 */
  !(function (a, b) {
    var c = b(a, a.document);
    (a.lazySizes = c), 'object' == typeof module && module.exports && (module.exports = c);
  })(window, function (a, b) {
    'use strict';
    if (b.getElementsByClassName) {
      var c,
        d,
        e = b.documentElement,
        f = a.Date,
        g = a.HTMLPictureElement,
        h = 'addEventListener',
        i = 'getAttribute',
        j = a[h],
        k = a.setTimeout,
        l = a.requestAnimationFrame || k,
        m = a.requestIdleCallback,
        n = /^picture$/i,
        o = ['load', 'error', 'lazyincluded', '_lazyloaded'],
        p = {},
        q = Array.prototype.forEach,
        r = function (a, b) {
          return p[b] || (p[b] = new RegExp('(\\s|^)' + b + '(\\s|$)')), p[b].test(a[i]('class') || '') && p[b];
        },
        s = function (a, b) {
          r(a, b) || a.setAttribute('class', (a[i]('class') || '').trim() + ' ' + b);
        },
        t = function (a, b) {
          var c;
          (c = r(a, b)) && a.setAttribute('class', (a[i]('class') || '').replace(c, ' '));
        },
        u = function (a, b, c) {
          var d = c ? h : 'removeEventListener';
          c && u(a, b),
            o.forEach(function (c) {
              a[d](c, b);
            });
        },
        v = function (a, d, e, f, g) {
          var h = b.createEvent('CustomEvent');
          return e || (e = {}), (e.instance = c), h.initCustomEvent(d, !f, !g, e), a.dispatchEvent(h), h;
        },
        w = function (b, c) {
          var e;
          !g && (e = a.picturefill || d.pf) ? e({ reevaluate: !0, elements: [b] }) : c && c.src && (b.src = c.src);
        },
        x = function (a, b) {
          return (getComputedStyle(a, null) || {})[b];
        },
        y = function (a, b, c) {
          for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; )
            (c = b.offsetWidth), (b = b.parentNode);
          return c;
        },
        z = (function () {
          var a,
            c,
            d = [],
            e = [],
            f = d,
            g = function () {
              var b = f;
              for (f = d.length ? e : d, a = !0, c = !1; b.length; ) b.shift()();
              a = !1;
            },
            h = function (d, e) {
              a && !e ? d.apply(this, arguments) : (f.push(d), c || ((c = !0), (b.hidden ? k : l)(g)));
            };
          return (h._lsFlush = g), h;
        })(),
        A = function (a, b) {
          return b
            ? function () {
                z(a);
              }
            : function () {
                var b = this,
                  c = arguments;
                z(function () {
                  a.apply(b, c);
                });
              };
        },
        B = function (a) {
          var b,
            c = 0,
            e = 125,
            g = d.ricTimeout,
            h = function () {
              (b = !1), (c = f.now()), a();
            },
            i =
              m && d.ricTimeout
                ? function () {
                    m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout);
                  }
                : A(function () {
                    k(h);
                  }, !0);
          return function (a) {
            var d;
            (a = a === !0) && (g = 33),
              b || ((b = !0), (d = e - (f.now() - c)), 0 > d && (d = 0), a || (9 > d && m) ? i() : k(i, d));
          };
        },
        C = function (a) {
          var b,
            c,
            d = 99,
            e = function () {
              (b = null), a();
            },
            g = function () {
              var a = f.now() - c;
              d > a ? k(g, d - a) : (m || e)(e);
            };
          return function () {
            (c = f.now()), b || (b = k(g, d));
          };
        };
      !(function () {
        var b,
          c = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            autosizesClass: 'lazyautosizes',
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: !0,
            ricTimeout: 300,
          };
        d = a.lazySizesConfig || a.lazysizesConfig || {};
        for (b in c) b in d || (d[b] = c[b]);
        (a.lazySizesConfig = d),
          k(function () {
            d.init && F();
          });
      })();
      var D = (function () {
          var g,
            l,
            m,
            o,
            p,
            y,
            D,
            F,
            G,
            H,
            I,
            J,
            K,
            L,
            M = /^img$/i,
            N = /^iframe$/i,
            O = 'onscroll' in a && !/glebot/.test(navigator.userAgent),
            P = 0,
            Q = 0,
            R = 0,
            S = -1,
            T = function (a) {
              R--, a && a.target && u(a.target, T), (!a || 0 > R || !a.target) && (R = 0);
            },
            U = function (a, c) {
              var d,
                f = a,
                g = 'hidden' == x(b.body, 'visibility') || 'hidden' != x(a, 'visibility');
              for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e; )
                (g = (x(f, 'opacity') || 1) > 0),
                  g &&
                    'visible' != x(f, 'overflow') &&
                    ((d = f.getBoundingClientRect()),
                    (g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1));
              return g;
            },
            V = function () {
              var a,
                f,
                h,
                j,
                k,
                m,
                n,
                p,
                q,
                r = c.elements;
              if ((o = d.loadMode) && 8 > R && (a = r.length)) {
                (f = 0),
                  S++,
                  null == K &&
                    ('expand' in d || (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370),
                    (J = d.expand),
                    (K = J * d.expFactor)),
                  K > Q && 1 > R && S > 2 && o > 2 && !b.hidden
                    ? ((Q = K), (S = 0))
                    : (Q = o > 1 && S > 1 && 6 > R ? J : P);
                for (; a > f; f++)
                  if (r[f] && !r[f]._lazyRace)
                    if (O)
                      if (
                        (((p = r[f][i]('data-expand')) && (m = 1 * p)) || (m = Q),
                        q !== m && ((y = innerWidth + m * L), (D = innerHeight + m), (n = -1 * m), (q = m)),
                        (h = r[f].getBoundingClientRect()),
                        (I = h.bottom) >= n &&
                          (F = h.top) <= D &&
                          (H = h.right) >= n * L &&
                          (G = h.left) <= y &&
                          (I || H || G || F) &&
                          (d.loadHidden || 'hidden' != x(r[f], 'visibility')) &&
                          ((l && 3 > R && !p && (3 > o || 4 > S)) || U(r[f], m)))
                      ) {
                        if ((ba(r[f]), (k = !0), R > 9)) break;
                      } else
                        !k &&
                          l &&
                          !j &&
                          4 > R &&
                          4 > S &&
                          o > 2 &&
                          (g[0] || d.preloadAfterLoad) &&
                          (g[0] || (!p && (I || H || G || F || 'auto' != r[f][i](d.sizesAttr)))) &&
                          (j = g[0] || r[f]);
                    else ba(r[f]);
                j && !k && ba(j);
              }
            },
            W = B(V),
            X = function (a) {
              s(a.target, d.loadedClass), t(a.target, d.loadingClass), u(a.target, Z), v(a.target, 'lazyloaded');
            },
            Y = A(X),
            Z = function (a) {
              Y({ target: a.target });
            },
            $ = function (a, b) {
              try {
                a.contentWindow.location.replace(b);
              } catch (c) {
                a.src = b;
              }
            },
            _ = function (a) {
              var b,
                c = a[i](d.srcsetAttr);
              (b = d.customMedia[a[i]('data-media') || a[i]('media')]) && a.setAttribute('media', b),
                c && a.setAttribute('srcset', c);
            },
            aa = A(function (a, b, c, e, f) {
              var g, h, j, l, o, p;
              (o = v(a, 'lazybeforeunveil', b)).defaultPrevented ||
                (e && (c ? s(a, d.autosizesClass) : a.setAttribute('sizes', e)),
                (h = a[i](d.srcsetAttr)),
                (g = a[i](d.srcAttr)),
                f && ((j = a.parentNode), (l = j && n.test(j.nodeName || ''))),
                (p = b.firesLoad || ('src' in a && (h || g || l))),
                (o = { target: a }),
                p && (u(a, T, !0), clearTimeout(m), (m = k(T, 2500)), s(a, d.loadingClass), u(a, Z, !0)),
                l && q.call(j.getElementsByTagName('source'), _),
                h ? a.setAttribute('srcset', h) : g && !l && (N.test(a.nodeName) ? $(a, g) : (a.src = g)),
                f && (h || l) && w(a, { src: g })),
                a._lazyRace && delete a._lazyRace,
                t(a, d.lazyClass),
                z(function () {
                  (!p || (a.complete && a.naturalWidth > 1)) && (p ? T(o) : R--, X(o));
                }, !0);
            }),
            ba = function (a) {
              var b,
                c = M.test(a.nodeName),
                e = c && (a[i](d.sizesAttr) || a[i]('sizes')),
                f = 'auto' == e;
              ((!f && l) ||
                !c ||
                (!a[i]('src') && !a.srcset) ||
                a.complete ||
                r(a, d.errorClass) ||
                !r(a, d.lazyClass)) &&
                ((b = v(a, 'lazyunveilread').detail),
                f && E.updateElem(a, !0, a.offsetWidth),
                (a._lazyRace = !0),
                R++,
                aa(a, b, f, e, c));
            },
            ca = function () {
              if (!l) {
                if (f.now() - p < 999) return void k(ca, 999);
                var a = C(function () {
                  (d.loadMode = 3), W();
                });
                (l = !0),
                  (d.loadMode = 3),
                  W(),
                  j(
                    'scroll',
                    function () {
                      3 == d.loadMode && (d.loadMode = 2), a();
                    },
                    !0
                  );
              }
            };
          return {
            _: function () {
              (p = f.now()),
                (c.elements = b.getElementsByClassName(d.lazyClass)),
                (g = b.getElementsByClassName(d.lazyClass + ' ' + d.preloadClass)),
                (L = d.hFac),
                j('scroll', W, !0),
                j('resize', W, !0),
                a.MutationObserver
                  ? new MutationObserver(W).observe(e, {
                      childList: !0,
                      subtree: !0,
                      attributes: !0,
                    })
                  : (e[h]('DOMNodeInserted', W, !0), e[h]('DOMAttrModified', W, !0), setInterval(W, 999)),
                j('hashchange', W, !0),
                ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(
                  function (a) {
                    b[h](a, W, !0);
                  }
                ),
                /d$|^c/.test(b.readyState) ? ca() : (j('load', ca), b[h]('DOMContentLoaded', W), k(ca, 2e4)),
                c.elements.length ? (V(), z._lsFlush()) : W();
            },
            checkElems: W,
            unveil: ba,
          };
        })(),
        E = (function () {
          var a,
            c = A(function (a, b, c, d) {
              var e, f, g;
              if (((a._lazysizesWidth = d), (d += 'px'), a.setAttribute('sizes', d), n.test(b.nodeName || '')))
                for (e = b.getElementsByTagName('source'), f = 0, g = e.length; g > f; f++)
                  e[f].setAttribute('sizes', d);
              c.detail.dataAttr || w(a, c.detail);
            }),
            e = function (a, b, d) {
              var e,
                f = a.parentNode;
              f &&
                ((d = y(a, f, d)),
                (e = v(a, 'lazybeforesizes', { width: d, dataAttr: !!b })),
                e.defaultPrevented || ((d = e.detail.width), d && d !== a._lazysizesWidth && c(a, f, e, d)));
            },
            f = function () {
              var b,
                c = a.length;
              if (c) for (b = 0; c > b; b++) e(a[b]);
            },
            g = C(f);
          return {
            _: function () {
              (a = b.getElementsByClassName(d.autosizesClass)), j('resize', g);
            },
            checkElems: g,
            updateElem: e,
          };
        })(),
        F = function () {
          F.i || ((F.i = !0), E._(), D._());
        };
      return (c = {
        cfg: d,
        autoSizer: E,
        loader: D,
        init: F,
        uP: w,
        aC: s,
        rC: t,
        hC: r,
        fire: v,
        gW: y,
        rAF: z,
      });
    }
  });

  /*! lazysizes RIaS - v4.0.1 */
  !(function (a, b) {
    var c = function () {
      b(a.lazySizes), a.removeEventListener('lazyunveilread', c, !0);
    };
    (b = b.bind(null, a, a.document)),
      'object' == typeof module && module.exports
        ? b(require('lazysizes'))
        : a.lazySizes
        ? c()
        : a.addEventListener('lazyunveilread', c, !0);
  })(window, function (a, b, c) {
    'use strict';
    function d(b, c) {
      var d,
        e,
        f,
        g,
        h = a.getComputedStyle(b);
      (e = b.parentNode),
        (g = { isPicture: !(!e || !m.test(e.nodeName || '')) }),
        (f = function (a, c) {
          var d = b.getAttribute('data-' + a);
          if (!d) {
            var e = h.getPropertyValue('--ls-' + a);
            e && (d = e.trim());
          }
          if (d) {
            if ('true' == d) d = !0;
            else if ('false' == d) d = !1;
            else if (l.test(d)) d = parseFloat(d);
            else if ('function' == typeof j[a]) d = j[a](b, d);
            else if (q.test(d))
              try {
                d = JSON.parse(d);
              } catch (f) {}
            g[a] = d;
          } else
            a in j && 'function' != typeof j[a] ? (g[a] = j[a]) : c && 'function' == typeof j[a] && (g[a] = j[a](b, d));
        });
      for (d in j) f(d);
      return (
        c.replace(p, function (a, b) {
          b in g || f(b, !0);
        }),
        g
      );
    }
    function e(a, b) {
      var c = [],
        d = function (a, c) {
          return k[typeof b[c]] ? b[c] : a;
        };
      return (
        (c.srcset = []),
        b.absUrl && (s.setAttribute('href', a), (a = s.href)),
        (a = ((b.prefix || '') + a + (b.postfix || '')).replace(p, d)),
        b.widths.forEach(function (d) {
          var e = b.widthmap[d] || d,
            f = {
              u: a.replace(n, e).replace(o, b.ratio ? Math.round(d * b.ratio) : ''),
              w: d,
            };
          c.push(f), c.srcset.push((f.c = f.u + ' ' + d + 'w'));
        }),
        c
      );
    }
    function f(a, c, d) {
      var f = 0,
        g = 0,
        h = d;
      if (a) {
        if ('container' === c.ratio) {
          for (f = h.scrollWidth, g = h.scrollHeight; !((f && g) || h === b); )
            (h = h.parentNode), (f = h.scrollWidth), (g = h.scrollHeight);
          f && g && (c.ratio = g / f);
        }
        (a = e(a, c)),
          (a.isPicture = c.isPicture),
          u && 'IMG' == d.nodeName.toUpperCase()
            ? d.removeAttribute(i.srcsetAttr)
            : d.setAttribute(i.srcsetAttr, a.srcset.join(', ')),
          Object.defineProperty(d, '_lazyrias', { value: a, writable: !0 });
      }
    }
    function g(a, b) {
      var e = d(a, b);
      return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, 'lazyriasmodifyoptions', e), e;
    }
    function h(a) {
      return (
        a.getAttribute(a.getAttribute('data-srcattr') || j.srcAttr) ||
        a.getAttribute(i.srcsetAttr) ||
        a.getAttribute(i.srcAttr) ||
        a.getAttribute('data-pfsrcset') ||
        ''
      );
    }
    var i,
      j,
      k = { string: 1, number: 1 },
      l = /^\-*\+*\d+\.*\d*$/,
      m = /^picture$/i,
      n = /\s*\{\s*width\s*\}\s*/i,
      o = /\s*\{\s*height\s*\}\s*/i,
      p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      q = /^\[.*\]|\{.*\}$/,
      r = /^(?:auto|\d+(px)?)$/,
      s = b.createElement('a'),
      t = b.createElement('img'),
      u = 'srcset' in t && !('sizes' in t),
      v = !!a.HTMLPictureElement && !u;
    !(function () {
      var b,
        d = function () {},
        e = {
          prefix: '',
          postfix: '',
          srcAttr: 'data-src',
          absUrl: !1,
          modifyOptions: d,
          widthmap: {},
          ratio: !1,
        };
      (i = (c && c.cfg) || a.lazySizesConfig),
        i || ((i = {}), (a.lazySizesConfig = i)),
        i.supportsType ||
          (i.supportsType = function (a) {
            return !a;
          }),
        i.rias || (i.rias = {}),
        (j = i.rias),
        'widths' in j ||
          ((j.widths = []),
          (function (a) {
            for (var b, c = 0; !b || 3e3 > b; ) (c += 5), c > 30 && (c += 1), (b = 36 * c), a.push(b);
          })(j.widths));
      for (b in e) b in j || (j[b] = e[b]);
    })(),
      addEventListener(
        'lazybeforesizes',
        function (a) {
          if (a.detail.instance == c) {
            var b, d, e, k, l, m, o, p, q, s, t, u, x;
            if (
              ((b = a.target),
              a.detail.dataAttr &&
                !a.defaultPrevented &&
                !j.disabled &&
                (q = b.getAttribute(i.sizesAttr) || b.getAttribute('sizes')) &&
                r.test(q))
            ) {
              if (
                ((d = h(b)),
                (e = g(b, d)),
                (t = n.test(e.prefix) || n.test(e.postfix)),
                e.isPicture && (k = b.parentNode))
              )
                for (l = k.getElementsByTagName('source'), m = 0, o = l.length; o > m; m++)
                  (t || n.test((p = h(l[m])))) && (f(p, e, l[m]), (u = !0));
              t || n.test(d)
                ? (f(d, e, b), (u = !0))
                : u &&
                  ((x = []),
                  (x.srcset = []),
                  (x.isPicture = !0),
                  Object.defineProperty(b, '_lazyrias', {
                    value: x,
                    writable: !0,
                  })),
                u &&
                  (v
                    ? b.removeAttribute(i.srcAttr)
                    : 'auto' != q && ((s = { width: parseInt(q, 10) }), w({ target: b, detail: s })));
            }
          }
        },
        !0
      );
    var w = (function () {
      var d = function (a, b) {
          return a.w - b.w;
        },
        e = function (a) {
          var b,
            c,
            d = a.length,
            e = a[d - 1],
            f = 0;
          for (f; d > f; f++)
            if (((e = a[f]), (e.d = e.w / a.w), e.d >= a.d)) {
              !e.cached &&
                (b = a[f - 1]) &&
                b.d > a.d - 0.13 * Math.pow(a.d, 2.2) &&
                ((c = Math.pow(b.d - 0.6, 1.6)), b.cached && (b.d += 0.15 * c), b.d + (e.d - a.d) * c > a.d && (e = b));
              break;
            }
          return e;
        },
        f = function (a, b) {
          var d;
          return (
            !a._lazyrias &&
              c.pWS &&
              (d = c.pWS(a.getAttribute(i.srcsetAttr || ''))).length &&
              (Object.defineProperty(a, '_lazyrias', {
                value: d,
                writable: !0,
              }),
              b && a.parentNode && (d.isPicture = 'PICTURE' == a.parentNode.nodeName.toUpperCase())),
            a._lazyrias
          );
        },
        g = function (b) {
          var d = a.devicePixelRatio || 1,
            e = c.getX && c.getX(b);
          return Math.min(e || d, 2.4, d);
        },
        h = function (b, c) {
          var h, i, j, k, l, m;
          if (((l = b._lazyrias), l.isPicture && a.matchMedia))
            for (i = 0, h = b.parentNode.getElementsByTagName('source'), j = h.length; j > i; i++)
              if (
                f(h[i]) &&
                !h[i].getAttribute('type') &&
                (!(k = h[i].getAttribute('media')) || (matchMedia(k) || {}).matches)
              ) {
                l = h[i]._lazyrias;
                break;
              }
          return (!l.w || l.w < c) && ((l.w = c), (l.d = g(b)), (m = e(l.sort(d)))), m;
        },
        j = function (d) {
          if (d.detail.instance == c) {
            var e,
              g = d.target;
            return !u && (a.respimage || a.picturefill || lazySizesConfig.pf)
              ? void b.removeEventListener('lazybeforesizes', j)
              : void (
                  ('_lazyrias' in g || (d.detail.dataAttr && f(g, !0))) &&
                  ((e = h(g, d.detail.width)),
                  e &&
                    e.u &&
                    g._lazyrias.cur != e.u &&
                    ((g._lazyrias.cur = e.u),
                    (e.cached = !0),
                    c.rAF(function () {
                      g.setAttribute(i.srcAttr, e.u), g.setAttribute('src', e.u);
                    })))
                );
          }
        };
      return v ? (j = function () {}) : addEventListener('lazybeforesizes', j), j;
    })();
  });

  /*! lazysizes object-fit - v4.0.1 */
  !(function (a, b) {
    var c = function (d) {
      b(a.lazySizes, d), a.removeEventListener('lazyunveilread', c, !0);
    };
    (b = b.bind(null, a, a.document)),
      'object' == typeof module && module.exports
        ? b(require('lazysizes'))
        : a.lazySizes
        ? c()
        : a.addEventListener('lazyunveilread', c, !0);
  })(window, function (a, b, c, d) {
    'use strict';
    function e(a) {
      var b = getComputedStyle(a, null) || {},
        c = b.fontFamily || '',
        d = c.match(j) || '',
        e = (d && c.match(k)) || '';
      return e && (e = e[1]), { fit: (d && d[1]) || '', position: n[e] || e || 'center' };
    }
    function f(a, b) {
      var d,
        e,
        f = c.cfg,
        g = a.cloneNode(!1),
        h = g.style,
        i = function () {
          var b = a.currentSrc || a.src;
          b &&
            e !== b &&
            ((e = b),
            (h.backgroundImage = 'url(' + (m.test(b) ? JSON.stringify(b) : b) + ')'),
            d || ((d = !0), c.rC(g, f.loadingClass), c.aC(g, f.loadedClass)));
        },
        j = function () {
          c.rAF(i);
        };
      (a._lazysizesParentFit = b.fit),
        a.addEventListener('lazyloaded', j, !0),
        a.addEventListener('load', j, !0),
        g.addEventListener('load', function () {
          var a = g.currentSrc || g.src;
          a && a != l && ((g.src = l), (g.srcset = ''));
        }),
        c.rAF(function () {
          var d = a,
            e = a.parentNode;
          'PICTURE' == e.nodeName.toUpperCase() && ((d = e), (e = e.parentNode)),
            c.rC(g, f.loadedClass),
            c.rC(g, f.lazyClass),
            c.aC(g, f.loadingClass),
            c.aC(g, f.objectFitClass || 'lazysizes-display-clone'),
            g.getAttribute(f.srcsetAttr) && g.setAttribute(f.srcsetAttr, ''),
            g.getAttribute(f.srcAttr) && g.setAttribute(f.srcAttr, ''),
            (g.src = l),
            (g.srcset = ''),
            (h.backgroundRepeat = 'no-repeat'),
            (h.backgroundPosition = b.position),
            (h.backgroundSize = b.fit),
            (d.style.display = 'none'),
            a.setAttribute('data-parent-fit', b.fit),
            a.setAttribute('data-parent-container', 'prev'),
            e.insertBefore(g, d),
            a._lazysizesParentFit && delete a._lazysizesParentFit,
            a.complete && i();
        });
    }
    var g = b.createElement('a').style,
      h = 'objectFit' in g,
      i = h && 'objectPosition' in g,
      j = /object-fit["']*\s*:\s*["']*(contain|cover)/,
      k = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
      l = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      m = /\(|\)|'/,
      n = { center: 'center', '50% 50%': 'center' };
    if (!h || !i) {
      var o = function (a) {
        if (a.detail.instance == c) {
          var b = a.target,
            d = e(b);
          !d.fit || (h && 'center' == d.position) || f(b, d);
        }
      };
      a.addEventListener('lazyunveilread', o, !0), d && d.detail && o(d);
    }
  });

  /* color-thief v2.3.0 */
  !(function (t, r) {
    'object' == typeof exports && 'undefined' != typeof module
      ? (module.exports = r())
      : 'function' == typeof define && define.amd
      ? define(r)
      : (t.ColorThief = r());
  })(this, function () {
    if (!t)
      var t = {
        map: function (t, r) {
          var n = {};
          return r
            ? t.map(function (t, o) {
                return (n.index = o), r.call(n, t);
              })
            : t.slice();
        },
        naturalOrder: function (t, r) {
          return t < r ? -1 : t > r ? 1 : 0;
        },
        sum: function (t, r) {
          var n = {};
          return t.reduce(
            r
              ? function (t, o, e) {
                  return (n.index = e), t + r.call(n, o);
                }
              : function (t, r) {
                  return t + r;
                },
            0
          );
        },
        max: function (r, n) {
          return Math.max.apply(null, n ? t.map(r, n) : r);
        },
      };
    var r = (function () {
        var r = 5,
          n = 8 - r,
          o = 1e3;
        function e(t, n, o) {
          return (t << (2 * r)) + (n << r) + o;
        }
        function i(t) {
          var r = [],
            n = !1;
          function o() {
            r.sort(t), (n = !0);
          }
          return {
            push: function (t) {
              r.push(t), (n = !1);
            },
            peek: function (t) {
              return n || o(), void 0 === t && (t = r.length - 1), r[t];
            },
            pop: function () {
              return n || o(), r.pop();
            },
            size: function () {
              return r.length;
            },
            map: function (t) {
              return r.map(t);
            },
            debug: function () {
              return n || o(), r;
            },
          };
        }
        function u(t, r, n, o, e, i, u) {
          (this.r1 = t), (this.r2 = r), (this.g1 = n), (this.g2 = o), (this.b1 = e), (this.b2 = i), (this.histo = u);
        }
        function a() {
          this.vboxes = new i(function (r, n) {
            return t.naturalOrder(r.vbox.count() * r.vbox.volume(), n.vbox.count() * n.vbox.volume());
          });
        }
        function s(r, n) {
          if (n.count()) {
            var o = n.r2 - n.r1 + 1,
              i = n.g2 - n.g1 + 1,
              u = t.max([o, i, n.b2 - n.b1 + 1]);
            if (1 == n.count()) return [n.copy()];
            var a,
              s,
              h,
              c,
              f = 0,
              v = [],
              l = [];
            if (u == o)
              for (a = n.r1; a <= n.r2; a++) {
                for (c = 0, s = n.g1; s <= n.g2; s++) for (h = n.b1; h <= n.b2; h++) c += r[e(a, s, h)] || 0;
                v[a] = f += c;
              }
            else if (u == i)
              for (a = n.g1; a <= n.g2; a++) {
                for (c = 0, s = n.r1; s <= n.r2; s++) for (h = n.b1; h <= n.b2; h++) c += r[e(s, a, h)] || 0;
                v[a] = f += c;
              }
            else
              for (a = n.b1; a <= n.b2; a++) {
                for (c = 0, s = n.r1; s <= n.r2; s++) for (h = n.g1; h <= n.g2; h++) c += r[e(s, h, a)] || 0;
                v[a] = f += c;
              }
            return (
              v.forEach(function (t, r) {
                l[r] = f - t;
              }),
              (function (t) {
                var r,
                  o,
                  e,
                  i,
                  u,
                  s = t + '1',
                  h = t + '2',
                  c = 0;
                for (a = n[s]; a <= n[h]; a++)
                  if (v[a] > f / 2) {
                    for (
                      e = n.copy(),
                        i = n.copy(),
                        u =
                          (r = a - n[s]) <= (o = n[h] - a)
                            ? Math.min(n[h] - 1, ~~(a + o / 2))
                            : Math.max(n[s], ~~(a - 1 - r / 2));
                      !v[u];

                    )
                      u++;
                    for (c = l[u]; !c && v[u - 1]; ) c = l[--u];
                    return (e[h] = u), (i[s] = e[h] + 1), [e, i];
                  }
              })(u == o ? 'r' : u == i ? 'g' : 'b')
            );
          }
        }
        return (
          (u.prototype = {
            volume: function (t) {
              return (
                (this._volume && !t) ||
                  (this._volume = (this.r2 - this.r1 + 1) * (this.g2 - this.g1 + 1) * (this.b2 - this.b1 + 1)),
                this._volume
              );
            },
            count: function (t) {
              var r = this.histo;
              if (!this._count_set || t) {
                var n,
                  o,
                  i,
                  u = 0;
                for (n = this.r1; n <= this.r2; n++)
                  for (o = this.g1; o <= this.g2; o++) for (i = this.b1; i <= this.b2; i++) u += r[e(n, o, i)] || 0;
                (this._count = u), (this._count_set = !0);
              }
              return this._count;
            },
            copy: function () {
              return new u(this.r1, this.r2, this.g1, this.g2, this.b1, this.b2, this.histo);
            },
            avg: function (t) {
              var n = this.histo;
              if (!this._avg || t) {
                var o,
                  i,
                  u,
                  a,
                  s = 0,
                  h = 1 << (8 - r),
                  c = 0,
                  f = 0,
                  v = 0;
                for (i = this.r1; i <= this.r2; i++)
                  for (u = this.g1; u <= this.g2; u++)
                    for (a = this.b1; a <= this.b2; a++)
                      (s += o = n[e(i, u, a)] || 0),
                        (c += o * (i + 0.5) * h),
                        (f += o * (u + 0.5) * h),
                        (v += o * (a + 0.5) * h);
                this._avg = s
                  ? [~~(c / s), ~~(f / s), ~~(v / s)]
                  : [
                      ~~((h * (this.r1 + this.r2 + 1)) / 2),
                      ~~((h * (this.g1 + this.g2 + 1)) / 2),
                      ~~((h * (this.b1 + this.b2 + 1)) / 2),
                    ];
              }
              return this._avg;
            },
            contains: function (t) {
              var r = t[0] >> n;
              return (
                (gval = t[1] >> n),
                (bval = t[2] >> n),
                r >= this.r1 && r <= this.r2 && gval >= this.g1 && gval <= this.g2 && bval >= this.b1 && bval <= this.b2
              );
            },
          }),
          (a.prototype = {
            push: function (t) {
              this.vboxes.push({ vbox: t, color: t.avg() });
            },
            palette: function () {
              return this.vboxes.map(function (t) {
                return t.color;
              });
            },
            size: function () {
              return this.vboxes.size();
            },
            map: function (t) {
              for (var r = this.vboxes, n = 0; n < r.size(); n++)
                if (r.peek(n).vbox.contains(t)) return r.peek(n).color;
              return this.nearest(t);
            },
            nearest: function (t) {
              for (var r, n, o, e = this.vboxes, i = 0; i < e.size(); i++)
                ((n = Math.sqrt(
                  Math.pow(t[0] - e.peek(i).color[0], 2) +
                    Math.pow(t[1] - e.peek(i).color[1], 2) +
                    Math.pow(t[2] - e.peek(i).color[2], 2)
                )) < r ||
                  void 0 === r) &&
                  ((r = n), (o = e.peek(i).color));
              return o;
            },
            forcebw: function () {
              var r = this.vboxes;
              r.sort(function (r, n) {
                return t.naturalOrder(t.sum(r.color), t.sum(n.color));
              });
              var n = r[0].color;
              n[0] < 5 && n[1] < 5 && n[2] < 5 && (r[0].color = [0, 0, 0]);
              var o = r.length - 1,
                e = r[o].color;
              e[0] > 251 && e[1] > 251 && e[2] > 251 && (r[o].color = [255, 255, 255]);
            },
          }),
          {
            quantize: function (h, c) {
              if (!h.length || c < 2 || c > 256) return !1;
              var f = (function (t) {
                var o,
                  i = new Array(1 << (3 * r));
                return (
                  t.forEach(function (t) {
                    (o = e(t[0] >> n, t[1] >> n, t[2] >> n)), (i[o] = (i[o] || 0) + 1);
                  }),
                  i
                );
              })(h);
              f.forEach(function () {});
              var v = (function (t, r) {
                  var o,
                    e,
                    i,
                    a = 1e6,
                    s = 0,
                    h = 1e6,
                    c = 0,
                    f = 1e6,
                    v = 0;
                  return (
                    t.forEach(function (t) {
                      (o = t[0] >> n) < a ? (a = o) : o > s && (s = o),
                        (e = t[1] >> n) < h ? (h = e) : e > c && (c = e),
                        (i = t[2] >> n) < f ? (f = i) : i > v && (v = i);
                    }),
                    new u(a, s, h, c, f, v, r)
                  );
                })(h, f),
                l = new i(function (r, n) {
                  return t.naturalOrder(r.count(), n.count());
                });
              function g(t, r) {
                for (var n, e = t.size(), i = 0; i < o; ) {
                  if (e >= r) return;
                  if (i++ > o) return;
                  if ((n = t.pop()).count()) {
                    var u = s(f, n),
                      a = u[0],
                      h = u[1];
                    if (!a) return;
                    t.push(a), h && (t.push(h), e++);
                  } else t.push(n), i++;
                }
              }
              l.push(v), g(l, 0.75 * c);
              for (
                var p = new i(function (r, n) {
                  return t.naturalOrder(r.count() * r.volume(), n.count() * n.volume());
                });
                l.size();

              )
                p.push(l.pop());
              g(p, c);
              for (var d = new a(); p.size(); ) d.push(p.pop());
              return d;
            },
          }
        );
      })().quantize,
      n = function (t) {
        (this.canvas = document.createElement('canvas')),
          (this.context = this.canvas.getContext('2d')),
          (this.width = this.canvas.width = t.width),
          (this.height = this.canvas.height = t.height),
          this.context.drawImage(t, 0, 0, this.width, this.height);
      };
    n.prototype.getImageData = function () {
      return this.context.getImageData(0, 0, this.width, this.height);
    };
    var o = function () {};
    return (
      (o.prototype.getColor = function (t, r) {
        return void 0 === r && (r = 10), this.getPalette(t, 5, r)[0];
      }),
      (o.prototype.getPalette = function (t, o, e) {
        var i = (function (t) {
            var r = t.colorCount,
              n = t.quality;
            if (void 0 !== r && Number.isInteger(r)) {
              if (1 === r)
                throw new Error(
                  'colorCount should be between 2 and 20. To get one color, call getColor() instead of getPalette()'
                );
              (r = Math.max(r, 2)), (r = Math.min(r, 20));
            } else r = 10;
            return void 0 === n || Number.isInteger(n) ? (n = 10) : n < 1 && (n = 10), { colorCount: r, quality: n };
          })({ colorCount: o, quality: e }),
          u = new n(t),
          a = (function (t, r, n) {
            for (var o = t, e = [], i = 0, u = void 0, a = void 0, s = void 0, h = void 0, c = void 0; i < r; i += n)
              (a = o[0 + (u = 4 * i)]),
                (s = o[u + 1]),
                (h = o[u + 2]),
                (void 0 === (c = o[u + 3]) || c >= 125) && ((a > 250 && s > 250 && h > 250) || e.push([a, s, h]));
            return e;
          })(u.getImageData().data, u.width * u.height, i.quality),
          s = r(a, i.colorCount);
        return s ? s.palette() : null;
      }),
      (o.prototype.getColorFromUrl = function (t, r, n) {
        var o = document.createElement('img'),
          e = this;
        o.addEventListener('load', function () {
          var i = e.getPalette(o, 5, n);
          r(i[0], t);
        }),
          (o.src = t);
      }),
      (o.prototype.getImageData = function (t, r) {
        var n = new XMLHttpRequest();
        n.open('GET', t, !0),
          (n.responseType = 'arraybuffer'),
          (n.onload = function () {
            if (200 == this.status) {
              var t = new Uint8Array(this.response);
              o = t.length;
              for (var n = new Array(o), o = 0; o < t.length; o++) n[o] = String.fromCharCode(t[o]);
              var e = n.join(''),
                i = window.btoa(e);
              r('data:image/png;base64,' + i);
            }
          }),
          n.send();
      }),
      (o.prototype.getColorAsync = function (t, r, n) {
        var o = this;
        this.getImageData(t, function (t) {
          var e = document.createElement('img');
          e.addEventListener('load', function () {
            var t = o.getPalette(e, 5, n);
            r(t[0], this);
          }),
            (e.src = t);
        });
      }),
      o
    );
  });

  /**
   * Module to show Recently Viewed Products
   *
   * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
   * Dual licensed under the MIT and GPL licenses:
   * http://www.opensource.org/licenses/mit-license.php
   * http://www.gnu.org/licenses/gpl.html
   *
   */
  Shopify.Products = (function () {
    var a = {
      howManyToShow: 3,
      howManyToStoreInMemory: 10,
      wrapperId: 'recently-viewed-products',
      templateId: 'recently-viewed-product-template',
      onComplete: null,
    };
    var c = [];
    var h = null;
    var d = null;
    var e = 0;
    var b = {
      configuration: {
        expires: 90,
        path: '/',
        domain: window.location.hostname,
      },
      name: 'shopify_recently_viewed',
      write: function (i) {
        jQuery.cookie(this.name, i.join(' '), this.configuration);
      },
      read: function () {
        var i = [];
        var j = jQuery.cookie(this.name);
        if (j !== null && j != undefined) {
          i = j.split(' ');
        }
        return i;
      },
      destroy: function () {
        jQuery.cookie(this.name, null, this.configuration);
      },
      remove: function (k) {
        var j = this.read();
        var i = jQuery.inArray(k, j);
        if (i !== -1) {
          j.splice(i, 1);
          this.write(j);
        }
      },
    };
    var f = function () {
      h.show();
      if (a.onComplete) {
        try {
          a.onComplete();
        } catch (i) {}
      }
    };
    var g = function () {
      if (c.length && e < a.howManyToShow) {
        jQuery.ajax({
          dataType: 'json',
          url: '/products/' + c[0] + '.js',
          cache: false,
          success: function (i) {
            d.tmpl(i).appendTo(h);
            c.shift();
            e++;
            g();
          },
          error: function () {
            b.remove(c[0]);
            c.shift();
            g();
          },
        });
      } else {
        f();
      }
    };
    return {
      resizeImage: function (m, j) {
        if (j == null) {
          return m;
        }
        if (j == 'master') {
          return m.replace(/http(s)?:/, '');
        }
        var i = m.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
        if (i != null) {
          var k = m.split(i[0]);
          var l = i[0];
          return (k[0] + '_' + j + l).replace(/http(s)?:/, '');
        } else {
          return null;
        }
      },
      showRecentlyViewed: function (i) {
        var i = i || {};
        e = 0;
        jQuery.extend(a, i);
        c = b.read();
        d = jQuery('#' + a.templateId);
        h = jQuery('#' + a.wrapperId);
        a.howManyToShow = Math.min(c.length, a.howManyToShow);
        if (a.howManyToShow && d.length && h.length) {
          g();
        }
      },
      getConfig: function () {
        return a;
      },
      clearList: function () {
        b.destroy();
      },
      recordRecentlyViewed: function (l) {
        var l = l || {};
        jQuery.extend(a, l);
        var j = b.read();
        if (window.location.pathname.indexOf('/products/') !== -1) {
          var k = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
          var i = jQuery.inArray(k, j);
          if (i === -1) {
            j.unshift(k);
            j = j.splice(0, a.howManyToStoreInMemory);
          } else {
            j.splice(i, 1);
            j.unshift(k);
          }
          b.write(j);
        }
      },
    };
  })();

  /*! lazysizes blur-up - v4.1.6 */
  !(function (a, b) {
    var c = function () {
      b(a.lazySizes), a.removeEventListener('lazyunveilread', c, !0);
    };
    (b = b.bind(null, a, a.document)),
      'object' == typeof module && module.exports
        ? b(require('lazysizes'))
        : a.lazySizes
        ? c()
        : a.addEventListener('lazyunveilread', c, !0);
  })(window, function (a, b, c) {
    'use strict';
    var d = [].slice,
      e = /blur-up["']*\s*:\s*["']*(always|auto|unobtrusive)/,
      f = /image\/(jpeg|png|gif|svg\+xml)/,
      g = function (b) {
        var d = b.getAttribute('data-media') || b.getAttribute('media'),
          e = b.getAttribute('type');
        return (!e || f.test(e)) && (!d || a.matchMedia(c.cfg.customMedia[d] || d).matches);
      },
      h = function (a, b) {
        var c = a ? d.call(a.querySelectorAll('source, img')) : [b],
          e = c.find(function (a) {
            return a.getAttribute('data-lowsrc') && g(a);
          });
        return e && e.getAttribute('data-lowsrc');
      },
      i = function (a, d, e, f) {
        var g,
          h = !1,
          i = !1,
          j = 'always' == f ? 0 : Date.now(),
          k = 0,
          l = (a || d).parentNode,
          m = function () {
            if (e) {
              var j = function () {
                (h = !0),
                  g &&
                    (c.rAF(function () {
                      g && c.aC(g, 'ls-blur-up-loaded');
                    }),
                    g.removeEventListener('load', j),
                    g.removeEventListener('error', j));
              };
              (g = b.createElement('img')),
                g.addEventListener('load', j),
                g.addEventListener('error', j),
                (g.className = 'ls-blur-up-img'),
                (g.src = e),
                (g.alt = ''),
                g.setAttribute('aria-hidden', 'true'),
                (g.className += ' ls-inview'),
                l.insertBefore(g, (a || d).nextSibling),
                'always' != f &&
                  ((g.style.visibility = 'hidden'),
                  setTimeout(function () {
                    c.rAF(function () {
                      i || (g.style.visibility = '');
                    });
                  }, 20));
            }
          },
          n = function () {
            g &&
              c.rAF(function () {
                try {
                  g.parentNode.removeChild(g);
                } catch (a) {}
                g = null;
              });
          },
          o = function (a) {
            k++, (i = a || i), a ? n() : k > 1 && setTimeout(n, 5e3);
          },
          p = function () {
            d.removeEventListener('load', p),
              d.removeEventListener('error', p),
              g &&
                c.rAF(function () {
                  c.aC(g, 'ls-original-loaded');
                }),
              !h || Date.now() - j < 66 ? o(!0) : o();
          };
        if ((m(), d.addEventListener('load', p), d.addEventListener('error', p), 'unobtrusive' == f)) o();
        else {
          var q = function (a) {
            l == a.target && (c.aC(g || d, 'ls-inview'), o(), l.removeEventListener('lazybeforeunveil', q));
          };
          l.getAttribute('data-expand') || l.setAttribute('data-expand', -1),
            l.addEventListener('lazybeforeunveil', q),
            c.aC(l, c.cfg.lazyClass);
        }
      };
    a.addEventListener('lazybeforeunveil', function (a) {
      var b = a.detail;
      if (b.instance == c && b.blurUp) {
        var d = a.target,
          e = d.parentNode;
        'PICTURE' != e.nodeName && (e = null),
          i(e, d, h(e, d) || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==', b.blurUp);
      }
    }),
      a.addEventListener('lazyunveilread', function (a) {
        var b = a.detail;
        if (b.instance == c) {
          var d = a.target,
            f = (getComputedStyle(d, null) || { fontFamily: '' }).fontFamily.match(e);
          (f || d.getAttribute('data-lowsrc')) && (b.blurUp = (f && f[1]) || 'always');
        }
      });
  });

  window.jQuery = _oldJquery;
})(window.wetheme.$);
